import * as utilities from "../src/utilities";
import * as storage from "../src/storage";
import * as config from "../src/config";
import * as stash from "../src/stash";
import * as digitalDataFormatters from "../src/digitalDataFormatters";
import * as appData from "../src/appData";
import * as productString from "../src/productString";

const remoteUtils = await import( 'AAPE_Sync/utilities' );

/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */

var mapMethods = {

	'setErrorMessage': function ( ) {
		
		// prevent ITC/Sponsored Click related values from firing on Overlays	
		mapMethods.clearSponsoredMetrics();

		_aape.metrics.events = utilities.apl( 'event49' );
		utilities.addEventsToLinkTrack( 'event49' );

	},

	'setSearchTypeAheadImpression': function ( data ) {
		var result = "",
			first = "";

		data = ( typeof ( data ) !== 'undefined' ? data : '' );

		if ( Array.isArray( data ) && data.length ) {

			// grab first element in the array to use as prefix for any element in the array that starts with ' in '
			first = data[ 0 ];

			result = data.map( function ( term ) {

				return ( term.toString().indexOf( " in " ) !== 0 ? term : first + "~" + term );

			} ).join( "|" );

		}

		return result;

	},

	'findRecType': function ( checkRecObj ) {
		checkRecObj = ( typeof checkRecObj !== "undefined" ? checkRecObj : {} );

		let stashObj = ( checkRecObj && checkRecObj.recobj && checkRecObj.recobj.recommendationType ? checkRecObj.recobj.recommendationType : '' );

		return stashObj;

	},
	'recObjFromMerchQueryParam': function ( val, prevPageType ) {
		
		//example: MERCH=REC-_-PLP_Browse-_-NA-_-301709300-_-N&	
		let arr = val.split( "-_-" ),
			displayPosition = ( arr.length > 3 ? arr[3] : "" ),
			recType = ( arr.length > 2 ? arr[1] : "" ),			
			searchCommonIVRData = ( function ( rt ) {

				let result = "";

				if ( recType.toLowerCase().indexOf("searchcommon_ivr") !== -1 ) {
					result = rt.split("~!~");				
				}

				return result;

			}( recType ));  

			
		if ( Array.isArray( searchCommonIVRData ) && searchCommonIVRData.length > 1 ){

			recType =  searchCommonIVRData[0];
			displayPosition = searchCommonIVRData[1];

		} 
		
		return {
				"recommendationType": recType,
				"pageType": prevPageType,
				"displayPosition": displayPosition,
				"anchorProductSku":  ( arr.length > 3 ? arr[2] : "" ),
				"strategy": "", 
				"recommendationVersion": "",
				"featureVersion": "",
				"interval": ""
			};			
	},
	'canSetEvent33': function( pObj, rObj ) {
		var prodObj = pObj,
			recStashedData = rObj,
			haveRecObj = false;

		/* Check evar6, the product array or the event array to see if a recommendation object exist */
		if ( prodObj.recommendation && utilities.objHasValue( prodObj.recommendation ) || prodObj.productInfo && prodObj.productInfo.recommendation && utilities.objHasValue( prodObj.productInfo.recommendation ) || utilities.objHasValue( recStashedData ) ) {
			haveRecObj = true;
		}

		return haveRecObj;
	},

	'getSemanticToken': function ( v40 ) {
		v40 = ( typeof v40 === 'string' ? v40 : "" );

		var parts = v40.split( " " ),
			index = parts.indexOf( ">" );

		return ( index > 0 ? parts[ index - 1 ] : "" );
	},
	
	'getFilters': function( filters = [] ) {
		
		let result = "";

		if( Array.isArray( filters ) && filters.length > 0 ) {
			let arrLength = filters.length;

			for ( let index = 0; index < arrLength; index += 1 ) {
				result += filters[ index ].position + "," + filters[ index ].type + ":" + filters[ index ].value;

				if ( filters[ index ].selectionMethod ) {
					result += "," + filters[ index ].selectionMethod;
				}

				if ( index < arrLength - 1 ) {
					result += "|";
				}
			}

		}

		return result;

	},
	'setEvar33': function ( paymentMethod, defaultPaymentMethod = "" ) {

		if ( typeof ( paymentMethod ) !== 'undefined' && Array.isArray( paymentMethod ) && paymentMethod.length ) {

			return  paymentMethod.join( '|' );

		}
		
		return ( typeof ( paymentMethod ) === 'string' && paymentMethod ? paymentMethod : defaultPaymentMethod );
		
	},
	'setEvar21ForBrowseAndSearch': function ( sourceobj,  v21event = 'event14' ) {
				
		let result = "";
		
		if ( sourceobj.displayAttributes && ( sourceobj.displayAttributes.viewType || sourceobj.displayAttributes.sortBy || sourceobj.displayAttributes.productsAvailability ) ) {
			
			result += sourceobj.displayAttributes.viewType ? sourceobj.displayAttributes.viewType : '';
			result += "|";
			result += sourceobj.displayAttributes.sortBy ? sourceobj.displayAttributes.sortBy : '';
			result += "|";
			result += sourceobj.displayAttributes.productsAvailability ? sourceobj.displayAttributes.productsAvailability : '';
			
		}
		
		if ( v21event ) {

			_aape.metrics.events = utilities.apl( v21event );

		}

		return ( result ? result : "no ddo" );

	},
	'setEVar101': function ( podClickData= {} ) {

		let result = "";
		
		if ( podClickData ) {

			result += ( podClickData.podPageNumber ? podClickData.podPageNumber : '' ) + "|";
			result += ( podClickData.podPageResults ? podClickData.podPageResults : '' ) + "|";
			result += ( podClickData.podPosition ? podClickData.podPosition : '' ) + "|";
			result += ( podClickData.podType ? podClickData.podType : '' ) + "|";
			result += ( podClickData.podAction ? podClickData.podAction : '' ) + "|";
			result += ( podClickData.podAnchorSku ? podClickData.podAnchorSku : '' );

			_aape.metrics.events = utilities.apl( "event123=" + ( podClickData.podInteractionNumber ? podClickData.podInteractionNumber : '' ) );

		}

		return result;

	},
	'setEvar132': function (ddo) {
		let stashedData = stash.getPersistedDataObject(),
			searchTerm = "",
			visNavAnalyticsQueryParam = mapMethods.visNavAnalyticsFromURLParam();

		if (stashedData.searchTerm) {
			searchTerm = stashedData.searchTerm;
		}
		else if (visNavAnalyticsQueryParam.searchTerm) {
			searchTerm = visNavAnalyticsQueryParam.searchTerm;
		}
		else if (ddo.page.onsiteSearchInfo.searchTerm) {
			searchTerm = ddo.page.onsiteSearchInfo.searchTerm;
		}

		return (searchTerm ? searchTerm : "non search");
	},

	'setEvar144': function ( ddo, eventIndex, evt ) {

		var eventObj = ddo.event[ eventIndex ],
			data = ( eventObj && eventObj.content && Array.isArray( eventObj.content.module ) ? eventObj.content.module : [] );

		_aape.metrics.eVar144 = ( function ( dataArr ) {
			var result = "",
				data = ( Array.isArray( dataArr ) && dataArr[ dataArr.length - 1 ] ? dataArr[ dataArr.length - 1 ] : "" );

			if ( data ) {

				result += ( data.name ? data.name : "n/a" ) + ">";
				result += ( data.feature ? data.feature : "n/a" ) + ">";
				result += ( data.type ? data.type : "n/a" );

				_aape.metrics.events = utilities.apl( evt );

			}

			return result;

		}( data ) );

		utilities.addEventsToLinkTrack( evt );
		utilities.addVarsToLinkTrack( 'eVar144' );

	},

	'setProp23': function ( ddo ) { 
		let result = [],
			visualCategoryIdArray = ddo.page.onsiteSearchInfo.visualCategoryId;
		
		// impression data for visual nav
		if ( Array.isArray( visualCategoryIdArray ) && visualCategoryIdArray.length ) {

			result.push( "imp" );

			for ( let index = 0; index < visualCategoryIdArray.length; index += 1 ) {

				result.push( ( visualCategoryIdArray[ index ] && visualCategoryIdArray[ index ].slot ? "" + ( 1 * index + 1 ) + "-" + visualCategoryIdArray[ index ].slot : "" ) );

			}

		}

		return result.join( "|" );

	},
	'setProp69': function ( ddo, stshData ) {
		
		let index,
			result = [],						
			stashedData = stshData,
			visNavAnalyticsQueryParam = mapMethods.visNavAnalyticsFromURLParam(),
			visualCategoryIdLength;
			

		// occurs on the following page when a click through from visual nav happens
		if ( typeof stashedData.visualCategoryIdLength !== "undefined" ) {

			visualCategoryIdLength = ( typeof stashedData.visualCategoryIdLength !== "undefined" ? stashedData.visualCategoryIdLength : 0 );

			result.push( "clk" );
			
			for ( index = 1; index <= visualCategoryIdLength; index++ ) {

				result.push( ( index === stashedData.podPosition && stashedData.categoryId ?  index + "-" + stashedData.categoryId : "" ) );

			}

			_aape.metrics.events = utilities.apl( "event190" );

			return result.join( "|" );
			
		} else if ( visNavAnalyticsQueryParam.categoryId && visNavAnalyticsQueryParam.podPosition ) {

			_aape.metrics.events = utilities.apl( "event190" );

			return `clk|${visNavAnalyticsQueryParam.podPosition}-${visNavAnalyticsQueryParam.categoryId}`;
			
		}

		return "";

	},

	'setRedirect': function ( ddo ) {

		var semanticBits,
			fifthBit,
			num;

		let searchRedirect = remoteUtils.getQueryParam( 'searchRedirect' );
		let semanticToken = remoteUtils.getQueryParam( 'semanticToken' );
		let stashedData = stash.getPersistedDataObject();

		let searchAnalyticsQueryParam = mapMethods.searchAnalyticsFromURLParam();
		let visNavAnalyticsQueryParam = mapMethods.visNavAnalyticsFromURLParam();

		let searchTerm = stashedData.searchTerm || searchAnalyticsQueryParam.searchTerm || visNavAnalyticsQueryParam.searchTerm || ddo.page.onsiteSearchInfo.searchTerm || searchRedirect || "";		
		// looks weird but found that we need to double decode some search term values, like those coming from type ahead
		searchTerm = decodeURI( decodeURI( searchTerm ) );

		//Checking if semanticToken is populated in the URL, if so use the ddo reference of that identical value. (This is due to semanticToken URL value being truncated)

		_aape.metrics.eVar40 = ( ddo.page.onsiteSearchInfo.semanticSearchTokens ? ddo.page.onsiteSearchInfo.semanticSearchTokens : semanticToken ? semanticToken : "" );
		_aape.metrics.eVar39 = mapMethods.getSemanticToken( _aape.metrics.eVar40 );

		if ( searchTerm ) {

			if ( ddo.page.onsiteSearchInfo.semanticSearchTokens || searchRedirect !== "" && semanticToken !== "" ) {
				
				_aape.metrics.events = utilities.apl( "event15" );

				_aape.metrics.prop4 = searchTerm;

				_aape.metrics.prop37 = ( function () {

					let prop37Source = "";
	
					if ( stashedData.searchTerm ) {					
						prop37Source = "stash";
					}
					else if ( searchAnalyticsQueryParam.searchTerm ) {					
						prop37Source = "typeaheadurlparam";
					}
					else if ( visNavAnalyticsQueryParam.searchTerm ) {					
						prop37Source = "visnavurlparam";
					}
					else if ( ddo.page.onsiteSearchInfo.searchTerm ) {									
						prop37Source = "ddo";
					} else if ( searchRedirect ) {									
						prop37Source = "searchredirecturlparam";
					} 
	
					return prop37Source;
	
				}() );

				_aape.metrics.eVar5 = _aape.metrics.prop4;
				_aape.metrics.eVar12 = stashedData.searchMedium || searchAnalyticsQueryParam.searchMedium || "text";

				_aape.metrics.eVar63 = "category redirect";

				semanticBits = semanticToken.split( " ", 1 );

				if ( semanticBits[ 0 ].length === 5 ) {

					fifthBit = semanticBits.toString().slice( -1 );
					num = parseInt( fifthBit );

					switch ( num ) {
						case 0:
							_aape.metrics.eVar63 = "non redirect";
							break;
						case 1:
							_aape.metrics.eVar12 = "redirect";
							_aape.metrics.eVar63 = "search config redirect";
							break;
						case 2:
							_aape.metrics.eVar12 = "redirect";

							break;
						case 3:
							_aape.metrics.eVar12 = "redirect";
							_aape.metrics.eVar63 = "rental redirect";
							break;
						default:
							break;
					}
				}

			}
		} 
	},

	'setInitialLoadSearchNucleus': function ( ddo ) {

			let _filterArray = ( Array.isArray( ddo.page.filter ) && ddo.page.filter.length ? ddo.page.filter : [] ),
				_isFilter2point0 = ( _filterArray.length && Array.isArray(_filterArray[0]) ? true : false ),
				searchAnalyticsQueryParam = mapMethods.searchAnalyticsFromURLParam(),
				visNavAnalyticsQueryParam = mapMethods.visNavAnalyticsFromURLParam(),
				searchTerm = ( ddo.page.onsiteSearchInfo.searchTerm ? ddo.page.onsiteSearchInfo.searchTerm : '' ),
				prop37Source = "";

			const pageNumber = ( ddo.page.displayAttributes && typeof ( ddo.page.displayAttributes.pageNumber ) !== 'undefined' ? ddo.page.displayAttributes.pageNumber : '');

			const stashedData = stash.getPersistedDataObject();

			const searchMedium = ( function () {

				let searchMedium = "";

				if ( stashedData.searchMedium ) {
					searchMedium = stashedData.searchMedium;
				}
				else if ( searchAnalyticsQueryParam.searchMedium ) {
					searchMedium = searchAnalyticsQueryParam.searchMedium;						
				}
				else if ( ddo.page.onsiteSearchInfo.searchMedium ) {
					searchMedium = ddo.page.onsiteSearchInfo.searchMedium;
				}

				return searchMedium;

			}() );

			const sl_token = remoteUtils.getQueryParam( 'sl_token' );
			
			searchTerm = ( function () {

				let searchTerm = "";

				if ( stashedData.searchTerm ) {
					searchTerm = stashedData.searchTerm;
					prop37Source = "stash";
				}
				else if ( searchAnalyticsQueryParam.searchTerm ) {
					searchTerm = searchAnalyticsQueryParam.searchTerm;	
					prop37Source = "typeaheadurlparam";
				}
				else if ( visNavAnalyticsQueryParam.searchTerm ) {
					searchTerm = visNavAnalyticsQueryParam.searchTerm;	
					prop37Source = "visnavurlparam";
				}
				else if ( ddo.page.onsiteSearchInfo.searchTerm ) {
					searchTerm = ddo.page.onsiteSearchInfo.searchTerm;					
					prop37Source = "ddo";
				} 

				return searchTerm;

			}() );

			_aape.metrics.prop37 = prop37Source;

			_aape.metrics.events = ( function ( ddo ) {

				let _evtStr = utilities.apl( "event15" );

				if ( stashedData.searchMedium === "type ahead" || searchAnalyticsQueryParam.searchMedium === "type ahead" ) {
					_evtStr = utilities.apl( "event21", _evtStr );
				}

				if ( ddo.page.onsiteSearchInfo.numberOfResults === '0' ) {
					_evtStr = utilities.apl( "event32", _evtStr );
				}

				if ( stashedData.searchTypeAheadType === "recent searches" || searchAnalyticsQueryParam.searchTypeAheadType === "recent searches" ) {
					_evtStr = utilities.apl( "event34", _evtStr );
				}

				return _evtStr;

			}( ddo ) );

			_aape.metrics.prop4 = searchTerm;

			_aape.metrics.prop6 = stashedData.searchTermSuggestion ? stashedData.searchTermSuggestion : ddo.page.onsiteSearchInfo.correctedTerm;

			_aape.metrics.prop7 = pageNumber;

			_aape.metrics.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );


			if ( _isFilter2point0 ) {
				
				_aape.metrics.eVar18 = ( _filterArray.length ? digitalDataFormatters.formatSearchBrowseFilters( _filterArray[ _filterArray.length - 1 ], ";" ) : "" );
				
				_aape.metrics.eVar29 = _filterArray.map( filterArr => digitalDataFormatters.formatSearchBrowseFilters( filterArr ) ).join(",");
				
				_aape.metrics.prop16 = !stashedData.refinements ? _aape.metrics.eVar29 : "";			
				

			} else {

				_aape.metrics.eVar29 = mapMethods.getFilters( _filterArray );
				
				_aape.metrics.prop16 = !stashedData.refinements ? _aape.metrics.eVar29 : "";
				
	
			}
			
			if ( _aape.metrics.eVar29 ) {

				_aape.metrics.events = utilities.apl( "event14" ); 

			}
			_aape.metrics.prop21 = storage.getItem( "s_pv_pName" );
		
			_aape.metrics.prop23 = mapMethods.setProp23 ( ddo );

			_aape.metrics.prop64 = stashedData.searchTermOrigin || searchAnalyticsQueryParam.searchTermOrigin || "";

			if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
				_aape.metrics.prop62 = ddo.page.pageInfo.pageTemplate;
			}

			_aape.metrics.prop69 = mapMethods.setProp69( ddo, stashedData );

			_aape.metrics.eVar5 = searchTerm;
			_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;

			_aape.metrics.eVar12 = ( function ( ddo ) {
				let searchType = "";

				if ( ddo.page.onsiteSearchInfo.relatedSearch && remoteUtils.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related Search";
				}
				if ( ddo.page.onsiteSearchInfo.relatedCategory && remoteUtils.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related category";
				}
				if ( remoteUtils.getQueryParam( 'searchRedirect' ) !== "" ) {
					searchType = "redirect";
				}
				/* Internal Search Terms (SearchCenter) - defined on standard search */
				if ( searchTerm ) {
					if ( ddo.page.onsiteSearchInfo.correctedTerm && ddo.page.onsiteSearchInfo.resultsType === "spell correction" ) {
						searchType = ddo.page.onsiteSearchInfo.resultsType;
					}
					else if ( ddo.page.onsiteSearchInfo.numberOfResults === '0' ) {
						searchType = "null";
					}
					else {
						searchType = "text";
					}
				}

				if ( searchMedium ) {
					searchType = searchMedium;
				}

				if ( sl_token ) {
					searchType = "image search";
				}

				if ( ddo.page.onsiteSearchInfo.numberOfResults === '0' ) {
					searchType = searchMedium + "|" + ddo.page.onsiteSearchInfo.resultsType;
				}

				if ( BUILD_TARGET === 'b2consumer-mobile' ) {
					if ( remoteUtils.getQueryParam( 'searchType' ).toLowerCase() === 'barcode' ) {
						searchType = 'barcode';
					}
				}

				return searchType;
			}( ddo ) );

			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

			_aape.metrics.eVar32 = mapMethods.setSearchTypeAheadImpression( stashedData.searchTypeAheadImp );

			_aape.metrics.eVar40 = ( ddo.page.onsiteSearchInfo.semanticSearchTokens ? ddo.page.onsiteSearchInfo.semanticSearchTokens : remoteUtils.getQueryParam( 'semanticToken', document.URL ) ? remoteUtils.getQueryParam( 'semanticToken', document.URL ) : "" );

			_aape.metrics.eVar39 = mapMethods.getSemanticToken( _aape.metrics.eVar40 );

			_aape.metrics.eVar63 = ( function () {

				let result = "";
				let searchIntent = ( typeof ( ddo.page.onsiteSearchInfo.searchIntent ) === 'string' ? ddo.page.onsiteSearchInfo.searchIntent.toLowerCase() : '' );

				if ( stashedData.searchTypeAheadType || searchAnalyticsQueryParam.searchTypeAheadType ) {
					result = stashedData.searchTypeAheadType || searchAnalyticsQueryParam.searchTypeAheadType;					
				}
				else if ( stashedData.searchMedium || searchAnalyticsQueryParam.searchMedium ) {
					result = stashedData.searchMedium || searchAnalyticsQueryParam.searchMedium;
				}
				else if ( sl_token ) {
					result = "image search";
				}
				else {
					result = ddo.page.onsiteSearchInfo.resultsCategory;
				}

				result = ( searchIntent === "rental intent" ? searchIntent : result );

				return result;

			}() );

			_aape.metrics.eVar78 = ( function () {

				let searchTypeAheadBits = "";

				if ( stashedData.searchTypeAheadBits ) {
					searchTypeAheadBits = stashedData.searchTypeAheadBits;
				}
				else if ( searchAnalyticsQueryParam.searchTypeAheadBits ) {
					searchTypeAheadBits = searchAnalyticsQueryParam.searchTypeAheadBits;
				}
				else if ( ddo.page.onsiteSearchInfo.searchTypeAheadBit ) {
					searchTypeAheadBits = ddo.page.onsiteSearchInfo.searchTypeAheadBit;
				}

				return searchTypeAheadBits;

			}() );

			_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

			if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
				_aape.metrics.events = utilities.apl( "event118" );
			}

			if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
				_aape.metrics.eVar82 = ddo.page.pageInfo.pageTemplate;
			}
				
			if ( stashedData.filterby ) {
				_aape.metrics.events = utilities.apl( "event37" );
			}

	},
	'setInitialLoadBrowseNucleus': function ( ddo ) {

		const stashedData = stash.getPersistedDataObject();

		// merge stashData with onsiteSearchInfo, giving stash the priority
		let _filterArray = ( Array.isArray( ddo.page.filter ) && ddo.page.filter.length ? ddo.page.filter : [] ),
			_isFilter2point0 = ( _filterArray.length && Array.isArray(_filterArray[0]) ? true : false ),
			searchAnalyticsQueryParam = mapMethods.searchAnalyticsFromURLParam(),
			visNavAnalyticsQueryParam = mapMethods.visNavAnalyticsFromURLParam(),
			searchInfo = { ...ddo.page.onsiteSearchInfo, ...visNavAnalyticsQueryParam, ...searchAnalyticsQueryParam, ...stashedData },
			headerCrumb = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );
		
		if ( searchInfo.searchTerm ) {

			_aape.metrics.events = utilities.apl( "event15" );

			if ( searchInfo.searchMedium === "type ahead" ) {
				_aape.metrics.events = utilities.apl( "event21" );
			}

			if ( searchInfo.searchTypeAheadType === "recent searches" ) {
				_aape.metrics.events = utilities.apl( "event34" );
			}

			_aape.metrics.prop4 = searchInfo.searchTerm;

			_aape.metrics.prop6 = searchInfo.searchTermSuggestion ? searchInfo.searchTermSuggestion : "";
			
			_aape.metrics.prop37 = ( function () {

				let prop37Source = "";

				if ( stashedData.searchTerm ) {					
					prop37Source = "stash";
				}
				else if ( searchAnalyticsQueryParam.searchTerm ) {					
					prop37Source = "typeaheadurlparam";
				}
				else if ( visNavAnalyticsQueryParam.searchTerm ) {					
					prop37Source = "visnavurlparam";
				}
				else if ( ddo.page.onsiteSearchInfo.searchTerm ) {									
					prop37Source = "ddo";
				} 

				return prop37Source;

			}() );

			_aape.metrics.prop64 = searchInfo.searchTermOrigin ? searchInfo.searchTermOrigin : "";

			_aape.metrics.eVar40 = ( ddo.page.onsiteSearchInfo.semanticSearchTokens ? ddo.page.onsiteSearchInfo.semanticSearchTokens : remoteUtils.getQueryParam( 'semanticToken', document.URL ) ? remoteUtils.getQueryParam( 'semanticToken', document.URL ) : "" );

			_aape.metrics.eVar39 = mapMethods.getSemanticToken( _aape.metrics.eVar40 );

			_aape.metrics.eVar5 = searchInfo.searchTerm;

			_aape.metrics.eVar12 = ( function ( ddo ) {

				let searchType = "";
				let sl_token = remoteUtils.getQueryParam( 'sl_token' );

				if ( ddo.page.onsiteSearchInfo.relatedSearch && remoteUtils.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related Search";
				}
				if ( ddo.page.onsiteSearchInfo.relatedCategory && remoteUtils.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related category";
				}
				if ( remoteUtils.getQueryParam( 'searchRedirect' ) !== "" ) {
					searchType = "redirect";
				}
				
				if ( sl_token ) {
					searchType = "image search";
				}
	
				if ( searchInfo.correctedTerm && searchInfo.resultsType === "spell correction" ) {
					searchType = searchInfo.resultsType;
				}
				else if ( searchInfo.numberOfResults === '0' ) {
					searchType = "null";
				}
				else {
					searchType = "text";
				}
				
				if ( searchInfo.searchMedium ) {
					searchType = searchInfo.searchMedium;
				}

				return searchType;
			}( ddo ) );

			_aape.metrics.eVar32 = mapMethods.setSearchTypeAheadImpression( searchInfo.searchTypeAheadImp );

			_aape.metrics.eVar63 = ( function () {

				let result = "";

				if ( searchInfo.searchTypeAheadType ) {
					result = searchInfo.searchTypeAheadType;
				}
				else if ( searchInfo.searchMedium ) {
					result = searchInfo.searchMedium;
				}

				return result;

			}() );

			_aape.metrics.eVar78 = searchInfo.searchTypeAheadBits;

		} else {

			_aape.metrics.eVar5 = "non-search";
			
		}

		_aape.metrics.prop7 = (  ddo.page.displayAttributes && typeof ( ddo.page.displayAttributes.pageNumber ) !== 'undefined' ? ddo.page.displayAttributes.pageNumber : "" );

		_aape.metrics.prop23 = mapMethods.setProp23 ( ddo );

		_aape.metrics.prop61 = headerCrumb;

		_aape.metrics.prop69 = mapMethods.setProp69( ddo, searchInfo );

		_aape.metrics.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );

		_aape.metrics.prop21 = storage.getItem( "s_pv_pName" );
		
		

		if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
			_aape.metrics.prop62 = ddo.page.pageInfo.pageTemplate;
		}

		_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

		if ( _isFilter2point0 ) {
				
			_aape.metrics.eVar18 = ( _filterArray.length ? digitalDataFormatters.formatSearchBrowseFilters( _filterArray[ _filterArray.length - 1 ], ";" ) : "" );
			
			_aape.metrics.eVar29 = _filterArray.map( filterArr => digitalDataFormatters.formatSearchBrowseFilters( filterArr ) ).join(",");
			
			_aape.metrics.prop16 = _aape.metrics.eVar29;			
			
		} else {

			_aape.metrics.eVar29 = mapMethods.getFilters( _filterArray );
			
			_aape.metrics.prop16 = _aape.metrics.eVar29;
			
		}
		
		if ( _aape.metrics.eVar29 ) {

			_aape.metrics.events = utilities.apl( "event14" ); 
			
		}

		_aape.metrics.eVar31 = headerCrumb;

		_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

		if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
			_aape.metrics.events = utilities.apl( "event118" );
		}

		if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
			_aape.metrics.eVar82 = ddo.page.pageInfo.pageTemplate;
		}

		//no search results found event
		if ( ddo.page.onsiteSearchInfo.numberOfResults === "0" && ddo.page.pageInfo.pageName === "no search results" ) {
			_aape.metrics.events = utilities.apl( "event32" );
		}

		if ( searchInfo.filterby ) {

			_aape.metrics.events = utilities.apl( "event37" );

		}

	},

	'setFilterBy': function ( ddo, eventIndex ) {
		let _filterArray = ( Array.isArray( ddo.event[ eventIndex ].filter ) && ddo.event[ eventIndex ].filter.length ? ddo.event[ eventIndex ].filter : [] ),
			_isFilter2point0 = ( _filterArray.length && Array.isArray(_filterArray[0]) ? true : false ),		
			_isSearch = ( window.location.pathname.indexOf( "/s/" ) !== -1 ),	
			headerCrumb = ( _isSearch ? "non-browse" : ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

		

		_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		_aape.metrics.events = utilities.apl( 'event37' );

		_aape.metrics.prop4 = ddo.page.onsiteSearchInfo.searchTerm;
		_aape.metrics.prop6 = ddo.page.onsiteSearchInfo.correctedTerm;
		_aape.metrics.prop7 = ddo.page.onsiteSearchInfo.pageNum;
		_aape.metrics.prop8 = ddo.page.onsiteSearchInfo.numberOfResults;

		if ( _isFilter2point0 ) {
						
			_aape.metrics.eVar18 = ( _filterArray.length ? digitalDataFormatters.formatSearchBrowseFilters( _filterArray[ _filterArray.length - 1 ], ";" ) : "" );
			
			_aape.metrics.eVar29 = _filterArray.map( filterArr => digitalDataFormatters.formatSearchBrowseFilters( filterArr ) ).join(",");

			_aape.metrics.prop16 = _aape.metrics.eVar29;

		} else {

		_aape.metrics.prop16 = ( function ( ddo, eventIndex ) {
				var result = "";
	
				if ( ddo.event[ eventIndex ].filter && ddo.event[ eventIndex ].filter.length > 0 ) {
					var lastIndex = ddo.event[ eventIndex ].filter.length - 1;
	
					result += ddo.event[ eventIndex ].filter[ lastIndex ].position + "," + ddo.event[ eventIndex ].filter[ lastIndex ].type + ":" + ddo.event[ eventIndex ].filter[ lastIndex ].value;
	
					if ( ddo.event[ eventIndex ].filter[ lastIndex ].selectionMethod ) {
						result += "," + ddo.event[ eventIndex ].filter[ lastIndex ].selectionMethod;
					}
	
				}
	
				return result;
			}( ddo, eventIndex ) );

			_aape.metrics.eVar29 = mapMethods.getFilters( _filterArray );

		}
		
		

		_aape.metrics.prop21 = storage.getItem( "s_pv_pName" );
		_aape.metrics.prop30 = ddo.page.pageInfo.pageType;
		_aape.metrics.prop36 = ddo.page.onsiteSearchInfo.searchTerm;
		_aape.metrics.prop61 = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

		_aape.metrics.eVar5 = ddo.page.onsiteSearchInfo.searchTerm;

		_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );

		_aape.metrics.eVar28 = headerCrumb;
	
		_aape.metrics.eVar63 = ddo.page.onsiteSearchInfo.resultsCategory;

		_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

		if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
			_aape.metrics.events = utilities.apl( "event118" );
		}

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			_aape.metrics.events = utilities.apl( "event119" );

			_aape.metrics.products = productString.run( "productImpression", ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

			_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );
		}

		utilities.addEventsToLinkTrack( 'event14,event37,event118,event119' );
		utilities.addVarsToLinkTrack( 'prop4,prop6,prop7,prop8,prop16,prop21,prop30,prop36,prop61,eVar5,eVar18,eVar21,eVar29,eVar63,eVar103,eVar132,products' );

	},

	'setPagination': function ( ddo, eventIndex ) {

		_aape.metrics.referrer = "";

		let _filterArray = ( Array.isArray( ddo.event[ eventIndex ].filter ) && ddo.event[ eventIndex ].filter.length ? ddo.event[ eventIndex ].filter : [] ),
			_isFilter2point0 = ( _filterArray.length && Array.isArray(_filterArray[0]) ? true : false ),		
			headerCrumb = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

		_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName;

		_aape.metrics.prop7 = ( function () {

			var result = "";

			if ( ddo.event[ eventIndex ].displayAttributes ) {
				result = ddo.event[ eventIndex ].displayAttributes.pageNumber;
			}

			return result;

		}() );

		_aape.metrics.prop61 = headerCrumb;

		_aape.metrics.prop62 = ddo.page.pageInfo.pageTemplate;

		_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );
		_aape.metrics.eVar28 = headerCrumb;

		_aape.metrics.eVar31 = headerCrumb;

		_aape.metrics.eVar82 = ddo.page.pageInfo.pageTemplate;

		_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

		if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
			_aape.metrics.events = utilities.apl( "event118" );
		}

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			_aape.metrics.events = utilities.apl( "event119" );

			_aape.metrics.products = productString.run( "productImpression", ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

			_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );
		}

		if ( ddo.event[ eventIndex ].category.primaryCategory === "browse" || ddo.event[ eventIndex ].category.primaryCategory === "search" ) {

			_aape.metrics.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );
			
			if ( _isFilter2point0 ) {
				
				_aape.metrics.eVar18 = ( _filterArray.length ? digitalDataFormatters.formatSearchBrowseFilters( _filterArray[ _filterArray.length - 1 ], ";" ) : "" );
				
				_aape.metrics.eVar29 = _filterArray.map( filterArr => digitalDataFormatters.formatSearchBrowseFilters( filterArr ) ).join(",");
				
				_aape.metrics.prop16 = _aape.metrics.eVar29;			

	
			} else {

				_aape.metrics.eVar29 = mapMethods.getFilters( _filterArray );
				
				_aape.metrics.prop16 = _aape.metrics.eVar29;
				
	
			}
		}
	},

	'setSortBy': function ( ddo, eventIndex ) {

		_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;

		_aape.metrics.events = utilities.apl( 'event37' );

		_aape.metrics.prop30 = ddo.page.pageInfo.pageType;
		
		_aape.metrics.prop61 = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

		_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );

		_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

		if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
			_aape.metrics.events = utilities.apl( "event118" );
		}

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			_aape.metrics.events = utilities.apl( "event119" );

			_aape.metrics.products = productString.run( "productImpression", ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

			_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );
		}

		utilities.addEventsToLinkTrack( 'event14,event37,event118,event119' );
		utilities.addVarsToLinkTrack( 'prop30,prop61,eVar21,eVar103,eVar132,products' );

	},

	'setCommonTypeBy': function ( ddo, eventIndex ) {

		_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		_aape.metrics.events = utilities.apl( 'event37' );

		_aape.metrics.products = productString.run( "productImpression", ddo.content.product, {
			"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
		} );

		utilities.addEventsToLinkTrack( 'event14,event37' );
		utilities.addVarsToLinkTrack( 'eVar21,products' );

	},

	'setEvar85': function ( addressBookObj ) {

		var settings = ( typeof addressBookObj !== 'undefined' && addressBookObj.settings ? addressBookObj.settings : {} ),
			_default = ( settings.default ? settings.default : "" ),
			phoneForm = ( settings.phoneForm ? settings.phoneForm : "" ),
			apartmentForm = ( settings.apartmentForm ? settings.apartmentForm : "" ),
			quantity = ( settings.quantity ? settings.quantity : "" );

		return _default + ':' + phoneForm + ':' + apartmentForm + ':' + quantity;

	},

	'setCartAdd': function ( ddo, eventIndex ) {

		_aape.metrics.referrer = "";

		var stashRecAddLoc = stash.getEventData( "recCartAddLoc" ),
			//Giving Recommendation ATC Location priority when setting ATC Location in the product string
			stashATCLoc = ( stashRecAddLoc ? stashRecAddLoc : stash.getEventData( "cart add location" ) ),
			stashRecCartAdd = stash.getEventData( "recommendationCartAdd" ),
			stashCheckFulfillmentAvailability = stash.getEventData( "check fulfillment availability" ),
			stashEta = stash.getEventData( "checkFulfillmentAvailabilityEta" ),
			stashBadgeClickThrough = stash.getEventData( "atcBadgeClickThrough" ),
			stashPodClick = mapMethods.getPodClick(),
			sponsoredMetrics = appData.getFromCache( "sponsoredMetrics" );

			var stashSolverPathPersisted = stash.getPersistedDataWithKey( "solverPath" );
			var stashSolverPath = ( stashSolverPathPersisted ? stashSolverPathPersisted : stash.getEventData( "solverPath" ) );

		_aape.metrics.channel = 'cart add';
		_aape.metrics.events = ( function ( ddo ) {
			var scOpenString = "",
				_evtStr = utilities.apl( 'scAdd,event98' ),
				_cartID = ( ddo.cart && ddo.cart.cartID ? ddo.cart.cartID : "" ),
				evtObj = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ] ? ddo.event[ eventIndex ].item[ 0 ] : '' ),
				fulMethod = evtObj.fulfillment && typeof ( evtObj.fulfillment.method ) === 'string' ? evtObj.fulfillment.method.toLowerCase() : '',
				fulMethodType = evtObj.fulfillment && typeof ( evtObj.fulfillment.changeType ) === 'string' ? evtObj.fulfillment.changeType.toLowerCase() : '',
				fulPrevMethod = evtObj.fulfillment && typeof ( evtObj.fulfillment.previousMethod ) === 'string' ? evtObj.fulfillment.previousMethod.toLowerCase() : '';

			if ( _cartID ) {
				scOpenString = 'scOpen:' + _cartID;
				_evtStr = utilities.apl( scOpenString, _evtStr );
			}

			if ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ] && ddo.event[ eventIndex ].item[ 0 ].subscription && ddo.event[ eventIndex ].item[ 0 ].subscription.frequency ) {
				_evtStr = utilities.apl( 'event82', _evtStr );
			}

			if ( fulMethod === 'boss' && fulPrevMethod === 'bopis' ) {
				_evtStr = utilities.apl( "event263", _evtStr );
			}

			//inventory event
			if ( fulMethodType === 'inventory' ) {
				_evtStr = utilities.apl( "event263", _evtStr );
			}

			
			if ( stashBadgeClickThrough ) {
				_evtStr = utilities.apl( "event185", _evtStr );
			}

			return _evtStr;
		}( ddo ) );

		//logic to stop event258 from being populated in this beacon
		_aape.metrics.events = utilities.listRemove( _aape.metrics.events, "event258" );

		let productStringCartAddOptions = {
			"atcloc": stashATCLoc,
			"recobj": stashRecCartAdd,
			"checkfulfillobj": stashCheckFulfillmentAvailability,
			"badgeClickThrough": stashBadgeClickThrough,
			"etaobj": stashEta,
			"podclick": stashPodClick,
			"psAttributes": Array.isArray( ddo.event[ eventIndex ]?.attributes?.psOverlay ) ? ddo.event[ eventIndex ].attributes.psOverlay : []			
		};

		if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" || BUILD_TARGET === "b2business-desktop" || BUILD_TARGET === "b2business-mobile" || BUILD_TARGET === "tcs" ) {
			productStringCartAddOptions.solverpath = stashSolverPath;
		}

		_aape.metrics.products = productString.run( 'cartAdd', ddo.event[ eventIndex ].item, productStringCartAddOptions );

		// Account for PS Overlay Attributes							
		if (Array.isArray(_aape.metrics.products) &&
			(utilities.getValuesByPath(_aape.metrics.products, '_experience.analytics.customDimensions.eVars.eVar68').length ||
				utilities.getValuesByPath(_aape.metrics.products, '_experience.analytics.customDimensions.eVars.eVar126').length)) {
			_aape.metrics.events = utilities.apl("event126");
		}

		// clear stash values after using them in productString.cartAdd()
		stash.deleteEventData( "cart add location" );
		stash.deleteEventData( "recommendationCartAdd" );
		stash.deleteEventData( "recCartAddLoc" );
		stash.deleteEventData( "check fulfillment availability" );
		stash.deleteEventData( "atcBadgeClickThrough" );
		
		stash.deleteEventData( "solverPath" );
		stash.deletePersistedData( "solverPath" );		

		stash.deletePersistedData( "podClick" );
		stash.deleteEventData( "atcPodClick" );

		_aape.metrics.prop15 = ddo.page.pageInfo.pageName;
		_aape.metrics.prop17 = ddo.page.pageInfo.pageType;
		_aape.metrics.prop30 = 'cart add overlay';
		_aape.metrics.prop33 = ( ddo.event[ eventIndex ].eventInfo.abTest ? ddo.event[ eventIndex ].eventInfo.abTest : _aape.metrics.prop33 ? _aape.metrics.prop33 : '' );

		_aape.metrics.eVar8 = 'cart add overlay';
		_aape.metrics.eVar63 = appData.getFromCache( "pageLoadeVar63" );
		_aape.metrics.eVar89 = ( ddo.event[ eventIndex ].cart && ddo.event[ eventIndex ].cart.cartID ? ddo.event[ eventIndex ].cart.cartID : '' );
		_aape.metrics.eVar96 = _aape.metrics.prop15 ? _aape.metrics.prop15 : '';
		_aape.metrics.eVar97 = ddo.page.pageInfo.pageType;

		_aape.metrics.eVar101 = mapMethods.setEVar101( stashPodClick );

		//logic to stop v144 from being populated in this beacon
		_aape.metrics.eVar144 = '';
		_aape.metrics.eVar158 = ( function () {

			var selCat, selCol, result = "";

			selCat = stash.getEventData( "selectedCategory" );
			selCol = stash.getEventData( "selectedColor" );

			if ( selCat !== "" && selCol !== "" ) {
				result = 'clk|buy sample|' + selCat + "|" + selCol;
			}

			return result;

		}() );
		
		_aape.metrics.eVar215 = ( ddo.cart.quantityTotal ? ddo.cart.quantityTotal : "" );
		_aape.metrics.eVar216 = ( ddo.cart.uniqueSkuCount ? ddo.cart.uniqueSkuCount : "" );
		_aape.metrics.eVar217 = (ddo.cart.price && ddo.cart.price.cartTotal ? ddo.cart.price.cartTotal : "" );

		stash.deleteEventData( "selectedCategory" );
		stash.deleteEventData( "selectedColor" );

		// Maintain parity with current prod overlay*cart_add and add_to_cart_click*cart_add triggers for DW.
		if ( config.site.indexOf("b2") !== -1) {
			_aape.metrics.pageName = 'cart add';
			_aape.metrics.prop62 = "";
			_aape.metrics.eVar82 = "";
		}

		// Bundle Sponsored Click data from interaction*content_media_click.

		if ( sponsoredMetrics ) {
			
			sponsoredMetrics = JSON.parse(sponsoredMetrics);

			_aape.metrics.events = utilities.apl( "event209" );

			for (const [key, value] of Object.entries(sponsoredMetrics)) {
				_aape.metrics[key] = value;
			}			

			appData.addUpdateCache( "sponsoredMetrics", "" );

		}

	},
	'setApplianceCartAdd': function ( ddo, eventIndex ) {		

			// set cart add related metrics
			mapMethods.setCartAdd( ddo, eventIndex );

			_aape.metrics.events = utilities.apl( "event31" );

			//replace the ones that we need to for this use case
			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop30 = _aape.metrics.pageName;
			_aape.metrics.eVar8 = _aape.metrics.pageName;
		
	},
	'setCartRemove': function ( ddo, eventIndex ) {
		let evtObj = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ] ? ddo.event[ eventIndex ].item[ 0 ] : '' );

		_aape.metrics.eVar95 = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].removeLocation ? ddo.event[ eventIndex ].removeLocation : "" );

		_aape.metrics.events = utilities.apl( "scRemove" );

		if ( evtObj && evtObj.subscription && evtObj.subscription.frequency ) {
			_aape.metrics.events = utilities.apl( "event83" );

		}	


		//Pro Large Cart new metrics
		_aape.metrics.eVar118 = ( ddo.event[ eventIndex ].bulkAction ?? "" );
		_aape.metrics.eVar218 = ( ddo.cart.quantityTotal ? ddo.cart.quantityTotal : "" );
		_aape.metrics.eVar219 = ( ddo.cart.uniqueSkuCount ? ddo.cart.uniqueSkuCount : "" );
		_aape.metrics.eVar220 = (ddo.cart.price && ddo.cart.price.cartTotal ? ddo.cart.price.cartTotal : "" );

		_aape.metrics.products = productString.run( 'cartRemove', ddo.event[ eventIndex ].item, { "v95": _aape.metrics.eVar95 } );

		utilities.addEventsToLinkTrack( "scRemove,event83,event175" );
		utilities.addVarsToLinkTrack( 'products,eVar95,eVar115,eVar118,eVar218,eVar219,eVar220' );
	},

	'setProductView': function ( ddo ) {

		var stashedData = stash.getPersistedDataObject(),
			keyword = remoteUtils.getQueryParam('keyword'),
			semanticToken = remoteUtils.getQueryParam('semanticToken', document.URL),
			stashSolverPath = stash.getPersistedDataWithKey("solverPath"),
			widgetArray = (ddo.content && Array.isArray(ddo.content.widget) ? ddo.content.widget : []),
			prop37RecSource = "",
			prop37SearchSource = "",
			searchAnalyticsQueryParam = mapMethods.searchAnalyticsFromURLParam();

		// support ATC from PIP for Pesticide solver use case
		stash.addToEventData( "solverPath", stashSolverPath );
		
		
		var recStashedData = ( function () {
			var recentlyViewed = stash.getPersistedDataWithKey( "recRecentlyViewedPipLoad" ),
				recPipLoad = stash.getPersistedDataWithKey( "recommendationPipLoad" ),
				merch = remoteUtils.getQueryParam( 'MERCH', document.URL ),
				prevPageType = storage.getItem( "s_pv_pType" );
			

			if ( recentlyViewed ) { 

				_aape.metrics.prop37 = "recentlyViewedPipLoad";	
				prop37RecSource = "recentlyViewedPipLoad";	
				return recentlyViewed; 
			}

			if ( recPipLoad ) { 
				
				_aape.metrics.prop37 = "recommendationPipLoad";
				prop37RecSource = "recommendationPipLoad";
				return recPipLoad; 
			
			}	

			if ( merch && merch.toLowerCase().indexOf("rec-_-") === 0 && prevPageType.toLowerCase().indexOf( 'overlay' ) === -1) { 

				_aape.metrics.prop37 = "merchQueryParam";	
				prop37RecSource = "merchQueryParam";		

				return mapMethods.recObjFromMerchQueryParam(merch, prevPageType);
			}

			return {};

		}() );

		var stashBadgeClickThrough = stash.getPersistedDataWithKey( "badgeClickThrough" );

		let badges = ( ddo.content && ddo.content.product && ddo.content.product.productInfo && Array.isArray( ddo.content.product.productInfo.badge ) ? ddo.content.product.productInfo.badge : [] );

		var collectionsProductClick = stash.getPersistedDataWithKey( "collectionsProductClick" );

		var stashPodClick = ( utilities.objHasValue( stashedData.podClick ) ? stashedData.podClick : "" );

		var moduleResult = ( _aape.metrics.eVar144 ? _aape.metrics.eVar144 : '');

		var searchTerm = ( function () {

			var searchTerm = "";

			if ( stashedData.searchTerm ) {
				searchTerm = stashedData.searchTerm;
				prop37SearchSource = "stash";
			}
			else if ( searchAnalyticsQueryParam.searchTerm ){
				searchTerm = searchAnalyticsQueryParam.searchTerm;
				prop37SearchSource = "typeaheadurlparam";
			}
			else if ( keyword ) {
				searchTerm = decodeURIComponent( keyword );
				prop37SearchSource = "keywordurlparam";
			}
			else if ( ddo.product[ 0 ].productInfo.sku ) {
				searchTerm = ddo.product[ 0 ].productInfo.sku;
				prop37SearchSource = "ddo";
			}

			return searchTerm;

		}() );

		if ( !prop37RecSource ) {

			_aape.metrics.prop37 = prop37SearchSource;
		
		}

		var searchMedium = ( function () {

			var sm = "";

			if ( stashedData.searchMedium ) {
				sm = stashedData.searchMedium;
			}
			else if ( searchAnalyticsQueryParam.searchMedium ){
				sm = searchAnalyticsQueryParam.sm;
			}			
			else if ( ddo.page?.onsiteSearchInfo?.searchMedium ) {
				sm = ddo.page.onsiteSearchInfo.searchMedium;
			}

			return sm;

		}() );
		
		var isRedirect = ( function ( sd, kw, rsd, saqp ) {
			let sm = ( typeof ( ddo.page.onsiteSearchInfo.searchMedium ) === 'string' ? ddo.page.onsiteSearchInfo.searchMedium.toLowerCase() : "" );
		
			if ( !utilities.objHasValue( rsd ) && ( ( kw && document.referrer.indexOf( "/webapp/catalog/servlet/Search" ) === -1 ) || sd.searchTerm || saqp.searchTerm || sm === 'redirect' )) {

				return true;
			}

			return false;

		}( stashedData, keyword, recStashedData, searchAnalyticsQueryParam ) );

		if ( isRedirect ) {

			_aape.metrics.prop4 = searchTerm;

			_aape.metrics.prop8 = "1";			
			_aape.metrics.prop64 = stashedData.searchTermOrigin || searchAnalyticsQueryParam.searchTermOrigin || "";

			_aape.metrics.eVar5 = searchTerm;

			_aape.metrics.eVar12 = searchMedium || "text";
									
			_aape.metrics.eVar63 = stashedData.searchTypeAheadType || searchAnalyticsQueryParam.searchTypeAheadType || "search all";

		} else if (utilities.objHasValue( recStashedData ) ) {
			_aape.metrics.eVar5 = "non-search";
		}

		//TYPE AHEAD Metrics
		if ( typeof (stashedData?.searchMedium) === 'string' && stashedData.searchMedium.startsWith("type ahead>") ) {
			
			_aape.metrics.events = utilities.apl( "event15" );

			_aape.metrics.prop4 = stashedData.searchTerm ?? "";
			_aape.metrics.eVar5 =  stashedData.searchTerm ?? "";
			_aape.metrics.eVar12 = stashedData.searchMedium ?? "text";
			_aape.metrics.eVar32 = mapMethods.setSearchTypeAheadImpression( stashedData.searchTypeAheadImp );
			_aape.metrics.eVar44 = mapMethods.setSearchTypeAheadImpression( stashedData.searchTypeAheadRvImp );
			_aape.metrics.eVar45 = mapMethods.setSearchTypeAheadImpression( stashedData.searchTypeAheadBiaImp );			
			_aape.metrics.eVar63 = stashedData.searchTypeAheadType ?? "search all";
	
		}


		if ( BUILD_TARGET === 'b2consumer-mobile' ) {
			if ( remoteUtils.getQueryParam( 'searchType' ).toLowerCase() === 'barcode' ) {
				_aape.metrics.eVar12 = 'barcode';
			}
		}

		let productStringProductViewOptions = {
			'recobj': recStashedData,
			'badgeClickThrough': stashBadgeClickThrough,
			'collectionsProductClick': collectionsProductClick,
			'podclick': stashPodClick,
			'pageType': ddo.page.pageInfo.pageType,
			'solverpath': stashSolverPath,
			'widget': widgetArray,
			'badges': badges,
			'recNewTab': prop37RecSource
		};


		if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {
			//Instant Checkout impression on PIP page load (event80)
			if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.instantCheckoutDisplayed ) === 'string' && ddo.content.feature.instantCheckoutDisplayed.toLowerCase() === 'y' ) {

				_aape.metrics.events = utilities.apl( "event80" );

			}
		}
		
		_aape.metrics.products = productString.run( "productView",  ddo.product, productStringProductViewOptions );

		_aape.metrics.events = ( function ( ddo ) {
			// Preserve anything that may have been previously set in _aape.metrics.events
			var prodObj = {},

				evtStr = utilities.apl( 'prodView,event16', ( _aape.metrics.events ? _aape.metrics.events : "" ) );

			// do we have a product array?
			if ( Array.isArray( ddo.product ) && ddo.product.length ) {
				prodObj = ddo.product[ 0 ];
					
				if ( mapMethods.canSetEvent33( prodObj, recStashedData ) ) {
					evtStr = utilities.apl( evtStr, "event33" );
				}

				if ( isRedirect ) {

					evtStr = utilities.apl( evtStr, "event15" );

				}

				if ( prodObj.productInfo && prodObj.productInfo.availabilityStatus && typeof ( prodObj.productInfo.availabilityStatus.subscription ) !== 'undefined' ) {

					if ( prodObj.productInfo.availabilityStatus.subscription === true ) {
						evtStr = utilities.apl( evtStr, "event81" );
					}

				}

				
				if ( Array.isArray( _aape.metrics.products ) && utilities.getValuesByPath( _aape.metrics.products, '_experience.analytics.customDimensions.eVars.eVar112' ).length ) {
					evtStr = utilities.apl( "event127", evtStr );
				}

				if ( prodObj.productInfo && prodObj.productInfo.sskuInteraction ) {
					evtStr = utilities.apl( "event247", evtStr );
				}

			}

			if ( stashedData.searchMedium === "type ahead" || searchAnalyticsQueryParam.searchMedium === "type ahead" ) {
				evtStr = utilities.apl( "event21", evtStr );
			}

			if ( stashBadgeClickThrough ) {
				evtStr = utilities.apl( "event185", evtStr );
			}		

			//super duper sku event
			if ( prodObj.productInfo && prodObj.productInfo.superDuperSkuInteraction === true ) {
				evtStr = utilities.apl( "event252", evtStr );
			}
			
			if ( moduleResult && ( moduleResult.toLowerCase() ).match( /buy box>bogo>cta/ ) ) {
				evtStr = utilities.apl( "event268", evtStr );
			}
			// New event for multi-sku bulk impression on PIP
			if ( moduleResult && ( moduleResult.toLowerCase() ).match( /buy box>multi-sku bulk>cta/ ) ) {
				evtStr = utilities.apl( "event94", evtStr );
			}

			// New event for buy more save more impression on PIP
			if ( moduleResult && ( moduleResult.toLowerCase() ).match( /buy box>buy more save more>cta/ ) ) {
				evtStr = utilities.apl( "event92", evtStr );
			}

			// Clearance Messaging: Limited Stock on PIP
			if ( prodObj.productInfo && prodObj.productInfo.availabilityStatus && typeof ( prodObj.productInfo.availabilityStatus.isLimitedQuantity ) !== 'undefined' ) {
				
				if ( prodObj.productInfo.availabilityStatus.isLimitedQuantity === true ) {
					evtStr = utilities.apl( evtStr, "event63" );
				}

			}
			
			// Parts and Services Widget test
			if ( ddo.page.pageInfo && ddo.page.pageInfo.psTest ) {
				evtStr = utilities.apl( evtStr, "event314" );
			}
			

			return evtStr;
		}( ddo ) );

		_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;

		_aape.metrics.prop62 = "";
		_aape.metrics.prop62 = ddo.page.pageInfo.pageTemplate;

		_aape.metrics.eVar78 = stashedData.searchTypeAheadBits || searchAnalyticsQueryParam.searchTypeAheadBits || "";

		_aape.metrics.eVar82 = ddo.page.pageInfo.pageTemplate;

		_aape.metrics.eVar40 = ( ddo.page.onsiteSearchInfo.semanticSearchTokens ? ddo.page.onsiteSearchInfo.semanticSearchTokens : semanticToken ? semanticToken : '' );

		_aape.metrics.eVar39 = mapMethods.getSemanticToken( _aape.metrics.eVar40 );

		_aape.metrics.eVar101 = mapMethods.setEVar101( stashPodClick );

		_aape.metrics.eVar108 = ( function () {
			var cmMCId = remoteUtils.getQueryParam( 'cm_mmc', document.URL );

			if ( cmMCId && ( cmMCId.toString().toLowerCase().indexOf( "shopping" ) === 0 ) | ( cmMCId.toString().toLowerCase().indexOf( "pla" ) === 0 ) ) {

				if ( ddo.product && Array.isArray( ddo.product ) && ddo.product.length ) {

					return ( ddo.product[ 0 ].productInfo && ddo.product[ 0 ].productInfo.sku ? ddo.product[ 0 ].productInfo.sku.toString() : '' );

				}
			}

		}( ddo ) );

		_aape.metrics.eVar158 = ( function () {

			var selCat, selCol, result = "";

			selCat = stash.getPersistedDataWithKey( "selectedCategory" );
			selCol = stash.getPersistedDataWithKey( "selectedColor" );

			if ( selCat !== "" && selCol !== "" ) {
				result = 'clk|buy paint|' + selCat + "|" + selCol;
			}

			return result;

		}() );
			
		stash.deletePersistedData( "podClick" );
		stash.deletePersistedData( "selectedCategory" );
		stash.deletePersistedData( "selectedColor" );		

	},

	'setEvar26': function ( ddo ) {

		var result = ( ddo.user.profile.authenticationStatus ? ddo.user.profile.authenticationStatus : '' );

		return result;
	},

	'setWidgetTracking': function ( eventData ) {

		var result = "",
			widget = ( eventData && eventData.content && eventData.content.widgets && eventData.content.widgets[ 0 ] ? eventData.content.widgets[ 0 ] : '' );

		if ( widget ) {

			result += ( widget.id ? widget.id : "n/a" ) + "|";
			result += ( widget.name ? widget.name : "n/a" ) + "|";
			result += ( widget.templates ? widget.templates : "n/a" ) + "|";
			result += ( widget.component ? widget.component : "n/a" ) + "|";
			result += ( widget.campaign ? widget.campaign : "n/a" ) + "|";
			result += ( widget.action ? widget.action : "n/a" ) + "|";
			result += ( eventData.pageType ? eventData.pageType : "n/a" ) + "|";
			result += ( widget.element ? widget.element : "n/a" );

			_aape.metrics.eVar129 = result;
			_aape.metrics.events = utilities.apl( "event194" );
		}

		return result;

	},

	// For now we are only concerned with the first attached labor item returned
	'getAttachedLabor': function ( products ) {

		var i = 0,
			product = {};

		products = ( Array.isArray( products ) ? products : [] );

		for ( i = 0; i < products.length; i++ ) {
			product = products[ i ];

			if ( product.productInfo && product.productInfo.installationDisplayed ) {
				return {
					'type': 'installation',
					'productInfo': product.productInfo
				};
			}
			else if ( product.productInfo && ( product.productInfo.proReferralDisplayed || product.productInfo.laborType === "proreferral" )) {
				return {
					'type': 'proreferral',
					'productInfo': product.productInfo
				};
			}
			else if ( product.productInfo && ( product.productInfo.laborType === "sellable assembly" ) ) {
				return {
					'type': 'sellable assembly',
					'productInfo': product.productInfo
				};
			}
		}

		return {};
	},

	'getPodClick': function () {

		var stashDataObj = stash.getPersistedDataWithKey( "podClick" );

		if ( !stashDataObj ) {
			stashDataObj = stash.getEventData( "atcPodClick" );
		}

		return stashDataObj;
	},
	'getImpressionPageNumber': function ( evtObj, pageObj ) {
		let pageNumber = "";

		if ( typeof evtObj !== 'undefined' && evtObj.displayAttributes && evtObj.displayAttributes.pageNumber ) {
			pageNumber = evtObj.displayAttributes.pageNumber;
		} else if ( typeof pageObj !== 'undefined' && pageObj.displayAttributes && pageObj.displayAttributes.pageNumber ) {
			pageNumber = pageObj.displayAttributes.pageNumber;
		}

		return pageNumber;

	},
	'setPaintMetrics': function ( eventObj ) {

		var colorExplore = ( typeof eventObj !== 'undefined' && eventObj.colorExplore ? eventObj.colorExplore : '' ),
			v137 = "",
			v138 = "";

		if ( colorExplore ) {

			v137 += ( colorExplore.color ? colorExplore.color : "n/a" ) + "|";
			v137 += ( colorExplore.colorID ? colorExplore.colorID : "n/a" ) + "|";
			v137 += ( colorExplore.colorFamily ? colorExplore.colorFamily : "n/a" ) + "|";
			v137 += ( colorExplore.colorHue ? colorExplore.colorHue : "n/a" ) + "|";
			v137 += ( colorExplore.colorAnchor ? colorExplore.colorAnchor : "n/a" );

			_aape.metrics.eVar137 = v137;

			v138 += ( colorExplore.cem ? colorExplore.cem : "n/a" ) + "|";
			v138 += ( colorExplore.pageType ? colorExplore.pageType : "n/a" ) + "|";
			v138 += ( colorExplore.colorFilter ? colorExplore.colorFilter : "n/a" ) + "|";
			v138 += ( colorExplore.brandFilter ? colorExplore.brandFilter : "n/a" );

			_aape.metrics.eVar138 = v138;
		}
	},
	'setLaborDisplayed': function( ddo, eventIndex ) {

		var installLabor = mapMethods.getAttachedLabor( ddo.product ),
			installationStatus = ( utilities.objHasValue( installLabor ) && installLabor ? installLabor : '' );
	
		_aape.metrics.eVar131 = "sellable assembly";

		
		_aape.metrics.products = productString.run( 'installationSku', ddo.event[ eventIndex ].item );

		if ( installationStatus ) {			
			_aape.metrics.products = productString.run( 'installationSku', ddo.product );
		}
		
		utilities.addVarsToLinkTrack( 'products,eVar131' );

	},
	'setLaborDisplayedNucleus': function( ddo, eventIndex ) {

		let itemArray = ddo.event[ eventIndex ].item,
			attachedLaborData = mapMethods.getAttachedLabor( itemArray ),
			laborType = ( attachedLaborData.type ? attachedLaborData.type : '' );
	
		_aape.metrics.eVar131 = laborType;
		
		_aape.metrics.products = productString.run( 'attachedLaborSku', itemArray, { "laborType": laborType } );
	
		utilities.addVarsToLinkTrack( 'products,eVar131' );
			
	},
	'setFulfillmentChange': function ( ddo, eventIndex ) {
		let evtObj = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ] ? ddo.event[ eventIndex ].item[ 0 ] : '' ),
			fulMethod = evtObj.fulfillment && typeof ( evtObj.fulfillment.method ) === 'string' ? evtObj.fulfillment.method.toLowerCase() : '',
			fulPrevMethod = evtObj.fulfillment && typeof ( evtObj.fulfillment.previousMethod ) === 'string' ? evtObj.fulfillment.previousMethod.toLowerCase() : '';

		if ( evtObj && evtObj.subscription && evtObj.subscription.status && evtObj.subscription.status === 'add' ) {
			_aape.metrics.events = utilities.apl( "event82" );

		}
		else if ( evtObj && evtObj.subscription && evtObj.subscription.status && evtObj.subscription.status === 'remove' ) {
			_aape.metrics.events = utilities.apl( "event83" );
		}

		if ( fulMethod === 'boss' && fulPrevMethod === 'bopis' ) {
			_aape.metrics.events = utilities.apl( "event263" );
		}
		
		// Bulk Fulfillment Option 
		_aape.metrics.eVar119 = ( ddo.cart.bulkAvailability ? ddo.cart.bulkAvailability : '' );

		_aape.metrics.events = utilities.apl( "event134" );
		
		_aape.metrics.products = productString.run( 'cartView', ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event82,event83,event134,event263" );
		utilities.addVarsToLinkTrack( 'products,eVar119' );
	},
	'setQuoteAdd':  function ( ddo, eventIndex, eventList = 'event149') {

		let evtObj = ddo.event[ eventIndex ];

		_aape.metrics.events = utilities.apl( eventList );
		
		_aape.metrics.products = productString.run( 'quoteAdd',  evtObj.item, { "quoteid": evtObj.quoteId, "quotetype":  evtObj.quoteType } );

		_aape.metrics.eVar154 = ( evtObj.quoteTimeElapsed ? evtObj.quoteTimeElapsed : '' );

		utilities.addEventsToLinkTrack( eventList );
		utilities.addVarsToLinkTrack( 'eVar154,products' );

	},
	'setConfirmReturn': function ( postOrderObject ) {

		let postOrderReturn = postOrderObject ? postOrderObject : {},
		postOrderReturnItem = ( Array.isArray( postOrderReturn.item ) && postOrderReturn.item.length ? postOrderReturn.item : [] );

		_aape.metrics.events = utilities.apl( 'event43' );

		_aape.metrics.products = productString.run( 'confirmReturn', postOrderReturnItem );			

		utilities.addEventsToLinkTrack( 'event43' );	
		utilities.addVarsToLinkTrack( 'products' );	

	},	
	'clearSponsoredMetrics': function () {

		_aape.metrics.prop19 = '';
		_aape.metrics.eVar50 = '';
		_aape.metrics.eVar178 = '';
		_aape.metrics.eVar180 = '';
		_aape.metrics.events = utilities.listRemove( _aape.metrics.events, "event209" );

	},
	'setPurchaseMetrics': function ( ddo ) {

		let threeDSOverlay = stash.getPersistedDataWithKey( "3ds-overlay" ),
			opcOrderAttributes = stash.getPersistedDataWithKey( "opc_order_attributes" );
		
		_aape.metrics.eVar33 = mapMethods.setEvar33( ddo.transaction.price.paymentMethod );

		_aape.metrics.eVar51 = ( opcOrderAttributes.textOrder ?? '' );
		
		_aape.metrics.eVar100 = ( threeDSOverlay ? threeDSOverlay : '' );

		_aape.metrics.purchaseID = ( function ( ddo ) {

			let purchaseID = remoteUtils.getQueryParam( 'orderId', document.URL ),
				purchIdSource = "queryParam purchase id";

			if ( !purchaseID ) {
				if ( ddo.transaction && ddo.transaction.transactionID ) {
					purchaseID = ddo.transaction.transactionID;
					purchIdSource = "ddo purchase id";
				} else {
					purchIdSource = "no purchase id";
					purchaseID = "";
				}
			}

			// track source of purchase id (dev use)
			_aape.metrics.prop37 = utilities.apl( purchIdSource, _aape.metrics.prop37 );

			return purchaseID;

		}( ddo ) );

		_aape.metrics.transactionID = ( typeof ( _aape.metrics.purchaseID ) === 'string' ? _aape.metrics.purchaseID.toLowerCase() : "" );
		
		_aape.metrics.eVar90 = _aape.metrics.transactionID;

		_aape.metrics.state = ddo.transaction.profile.address.stateProvince;
		_aape.metrics.zip = ddo.transaction.profile.address.postalCode;

		_aape.metrics.events = utilities.apl( "purchase,event5=" + digitalDataFormatters.stripComma( ddo.transaction.price.tax ) + ",event6=" + ( ddo.transaction.price.shipping ? digitalDataFormatters.stripComma( ddo.transaction.price.shipping ) : '' ) );

		if ( typeof ( ddo.transaction.price.bodfsShipping ) !== 'undefined' ) {

			_aape.metrics.events = utilities.apl( "event47=" + digitalDataFormatters.stripComma( ddo.transaction.price.bodfsShipping ) );

		}

		if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {
			/* Instant Checkout enrollment */
			if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.instantCheckoutEnroll ) === 'string' && ddo.content.feature.instantCheckoutEnroll.toLowerCase() === 'y' ) {
				_aape.metrics.events = utilities.apl( "event64" );
			}
			
		}

		if (opcOrderAttributes.giftCardCount && opcOrderAttributes.giftCardAmount) {

			_aape.metrics.events = utilities.apl( `event315=${opcOrderAttributes.giftCardCount}` );
			_aape.metrics.events = utilities.apl( `event316=${opcOrderAttributes.giftCardAmount}` );

		}

		// Test Order tracking: URL contains expversion OR mock OR debug OR experience
		(() => {
			const urlParams = new URLSearchParams(window.location.search);
			const params = ["expversion", "mock", "debug", "experience"]

			if ( params.some(param => urlParams.has(param)) ) {
				_aape.metrics.events = utilities.apl("event161");
			}

		})()

		/* event for the count of Unique SKUs on Order Confirmation, set with the actual count in the product string */
		_aape.metrics.events = utilities.apl( "event228" );

		_aape.metrics.products = productString.run( "purchase", ddo.transaction.item );

		if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" || BUILD_TARGET === "b2business-desktop" || BUILD_TARGET === "b2business-mobile" ) {
			
			

			let transactions = Array.isArray(ddo.transaction.item) ? ddo.transaction.item : [];

			for( let i = 0; i < transactions.length; i++ ) {

				// Back Order Tracking non-check availability
				if ( transactions[i].fulfillment && transactions[i].fulfillment.backOrder && transactions[i].fulfillment.backOrder.toString().toLowerCase() === 'yes' ) {
					_aape.metrics.events = utilities.apl( "event125" );
				}

				// In-Store Assembly Tracking
				if ( transactions[i].productInfo && transactions[i].productInfo.assembly && transactions[i].productInfo.assembly.toString().toLowerCase() === 'in store' ) {
					_aape.metrics.events = utilities.apl( "event271" );
				}
			}

			//Pro Large Cart new metrics
			_aape.metrics.eVar200 = ( ddo.transaction.cartViewType ? ddo.transaction.cartViewType : '' );
			_aape.metrics.eVar224 = ( ddo.transaction.quantityTotal ? ddo.transaction.quantityTotal : "" );
			_aape.metrics.eVar225 = ( ddo.transaction.uniqueSkuCount ? ddo.transaction.uniqueSkuCount : "" );


			if ( ddo.transaction.attributes && ddo.transaction.attributes.poJobName ) {
				_aape.metrics.eVar159 = ddo.transaction.attributes.poJobName;
			}

			if ( ddo.transaction.profile.additionalEmail ) {
				_aape.metrics.eVar193 = ddo.transaction.profile.additionalEmail;
			}

			/* Instance Checkout Impression */
			if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.instantCheckoutDisplayed ) === 'string' && ddo.content.feature.instantCheckoutDisplayed.toLowerCase() === 'y' ) {
				_aape.metrics.events = utilities.apl( "event80,event108" );
			}

		}

	},
	'searchAnalyticsFromURLParam': function ( ) {				
		// searchAnalytics={searchTerm}-_-{searchMedium}-_-{searchTypeAheadBits}-_-{searchTypeAheadType}-_-{searchTermOrigin}
		let searchAnalytics =  remoteUtils.getQueryParam( 'searchAnalytics', document.URL );
		let result  = { "searchTerm":"", "searchMedium":"", "searchTypeAheadBits":"", "searchTypeAheadType":"", "searchTermOrigin":"" };

		
		if ( !searchAnalytics ) { 

			return {};
			
		}
		
		let searchAnalyticsArr = searchAnalytics.split("-_-");
				
		result.searchTerm = ( searchAnalyticsArr[0] ? searchAnalyticsArr[0] : "" );
		result.searchMedium = ( searchAnalyticsArr[1] ? searchAnalyticsArr[1] : "" );	
		result.searchTypeAheadBits = ( searchAnalyticsArr[2] ? searchAnalyticsArr[2] : "" );
		result.searchTypeAheadType = ( searchAnalyticsArr[3] ? searchAnalyticsArr[3] : "" );
		result.searchTermOrigin = ( searchAnalyticsArr[4] ? searchAnalyticsArr[4] : "" );

		return result;
	},
	'visNavAnalyticsFromURLParam': function ( ) {				
		// visNavSearch = {searchTerm}-_-{podPosition}-_-{categoryId}
		let visNavAnalytics =  remoteUtils.getQueryParam( 'visNavSearch', document.URL );
		let result  = { "searchTerm":"", "podPosition":"", "categoryId":"" };
		
		if ( !visNavAnalytics ) { 

			return {};
			
		}
		
		let visNavAnalyticsArr = visNavAnalytics.split("-_-");
				
		result.searchTerm = ( visNavAnalyticsArr[0] ? visNavAnalyticsArr[0] : "" );
		result.podPosition = ( visNavAnalyticsArr[1] ? visNavAnalyticsArr[1] : "" );	
		result.categoryId = ( visNavAnalyticsArr[2] ? visNavAnalyticsArr[2] : "" );
		
		return result;
	}


};

var nodes = {
	'universal': {
		'forcePageView': false,
		'reportingType': 't',
		'setMetrics': function ( ddo ) {

			window._aape.deployments.core.versions.daMap = CODE_VERSION;

			_aape.metrics.localizationMethod = ( ddo.user.localization.method ? ddo.user.localization.method : 'value not populated' );

			_aape.metrics.pageURL = document.URL;
			/* Remove Krypto from reported querystring parameters */
			if ( document.location.href.indexOf( '&krypto' ) > -1 ) {
				_aape.metrics.pageURL = document.location.href.replace( /&krypto=[\w+%]+/, '' );
			}

			_aape.metrics.pageName = ddo.page.pageInfo.pageName;

			_aape.metrics.events = utilities.apl( "event40=" + document.cookie.length.toString() );

			_aape.metrics.prop5 = storage.getItem( "s_pv_pType" );
			_aape.metrics.prop13 = utilities.getNewRepeat( 365 );
			_aape.metrics.prop24 = 'alloy=' + _aape.alloyLibraryInfo.version + '|build=' + BUILD_TARGET + '|version=' + CODE_VERSION + '|ts=' + '2025-07-23T14:24:54.499Z' + '|host=' + _aape.scriptHost;

			// Capture the difference between _aape.ECID and THDCustomer MSVID
			_aape.metrics.prop31 = (function() {
				let thdMvisID = window?.THDCustomer?.default?.mcvisID || 'not set';
				if (thdMvisID === _aape?.ECID) {
					return 'yes';
				} else {
					return 'No THDCus= ' + thdMvisID;
				}
			})();

			_aape.metrics.prop33 = (function() {
				
				const isWebview = remoteUtils.isConsumerApp();

				if ( ddo.page.pageInfo.abTest && isWebview ){
					return 'mobile web view|' + ddo.page.pageInfo.abTest;
				}
				else if ( isWebview ) {
					return 'mobile web view'
				}
				else if (ddo.page.pageInfo.abTest) {
					return ddo.page.pageInfo.abTest;
				}
			}());
			_aape.metrics.prop34 = utilities.getWindowOrientation();

			_aape.metrics.prop46 = _aape.metrics.pageURL;

			//cookie size
			_aape.metrics.prop47 = document.cookie.length.toString();

			/* New Header Variable */
			_aape.metrics.prop50 = ( ddo.page.pageInfo.headerVersion ? ddo.page.pageInfo.headerVersion : '' );

			_aape.metrics.prop56 = ( function () {

				const beaconExecutionType = appData.getFromCache( "beaconExecutionType" );				
				return ( beaconExecutionType ? beaconExecutionType : 'standard' );				

			}() );

			_aape.metrics.prop63 = stash.getPersistedDataWithKey( "globalMyAccountSettings" );

			_aape.metrics.prop67 = ddo.page.pageInfo.platform ? ddo.page.pageInfo.platform : '';

			stash.deletePersistedData( "globalMyAccountSettings" );

			// Bio Metric Auth Method
			_aape.metrics.eVar9 = ( () => {

				let stashData = stash.getPersistedDataWithKey( "signInSuccess" );				
				
				return ( stashData?.authMethod || '' );				

			})();

			if ( BUILD_TARGET === "b2consumer-mobile" || BUILD_TARGET === "b2business-mobile" ) {

				_aape.metrics.eVar1 = (()=>{
						
					if ( !remoteUtils.isConsumerApp() ) { return ""; }	

						let device = remoteUtils.getMobileDevice(),
							version = remoteUtils.getMobileAppVersion();

						return (device !== "" && version !== "" ? `${device} ${version}` : "");
					})();				

			}

			_aape.metrics.eVar15 = ddo.site.betaSite;			

			_aape.metrics.eVar25 = ( function () {

				var btstrap = config.getClient();

				if ( remoteUtils.isConsumerApp() ) {
					return 'consumer app';
				}
				else if ( btstrap === 'homedepot' ) {
					return 'desktop';
				}
				else if ( btstrap === 'homedepotmobile' ) {
					return 'mobile';
				}
				else {
					return btstrap;
				}
			}() );

			_aape.metrics.eVar26 = ( function ( ddo ) {
				let result = mapMethods.setEvar26( ddo ),
					stashData = stash.getPersistedDataWithKey( "signInSuccess" );

				// implements use cases "Sign in alongside other tracking" and "Registration alongside other tracking "
				if ( ddo.user.profile.action === 'sign in' || ddo.user.profile.action === 'register' ) {
					_aape.metrics.events = ( ddo.user.profile.action === 'register' ? utilities.apl( "event1,event25" ) : utilities.apl( "event25" ) );
					result = 'authenticated';
				}

				// Handle SIWP and Biometric enrollment cases 
				if ( utilities.objHasValue( stashData ) && result ) {
					
					if ( stashData.biometricEnablement === 'completed' ) {

						result = `${result}|siwp|biometric`;
						_aape.metrics.events = utilities.apl( "event24" );

					} else if (  stashData.siwpEnrollment === 'completed') {

						
						result = ( result.toLowerCase().indexOf( "siwp") === -1 ? `${result}|siwp` : result );
						_aape.metrics.events = utilities.apl( "event19" );

					} 

				}

				return result;
			}( ddo ) );

			_aape.metrics.eVar27 = ( typeof(ddo.user.localization.storeNumber) === 'string' && ddo.user.localization.storeNumber.indexOf("@")=== -1 ? ddo.user.localization.storeNumber : '' );

			/*instore tracking*/
			if ( BUILD_TARGET === "b2consumer-mobile" || BUILD_TARGET === "b2business-mobile" ) {
				_aape.metrics.eVar42 = ( ddo.user.localization.inStoreNumber ? ddo.user.localization.inStoreNumber : '' );
			}

			if ( config.site === "b2consumer-mobile" || config.site === "b2business-mobile" ) {
				_aape.metrics.eVar59 = remoteUtils.getMobileDevice();
			}

			/* AAEFES/Military Exchange Tracking */
			_aape.metrics.eVar54 = ( typeof ( ddo.site.integration ) !== 'undefined' ? ddo.site.integration : "" );

			/*Quatum Metric User and Session Ids*/
			_aape.metrics.eVar60 = ( function () {
				if ( window.QuantumMetricAPI ) {
					let getUser = (  typeof ( window.QuantumMetricAPI.getUserID ) === 'function' ? window.QuantumMetricAPI.getUserID() : undefined ),
						getSession = ( typeof ( window.QuantumMetricAPI.getSessionID ) === 'function' ? window.QuantumMetricAPI.getSessionID() : undefined );
					return ( typeof ( getUser ) === 'string' ? getUser : 'na' ) + '|' + ( typeof ( getSession ) === 'string' ? getSession : 'na' );
				}
			}() )

			/* Set eVar61 with the PcId */
			_aape.metrics.eVar61 = ( window.mboxFactoryDefault && typeof window.mboxFactoryDefault.getPCId === "function" ? window.mboxFactoryDefault.getPCId().getId() : '' );

			/* Time Parting */
			_aape.metrics.eVar69 = ( function () {
				let value = utilities.getDaysSinceLastVisit();
				console.log( LOG_PREFIX + " -- getDaysSinceLastVisit -- eVar69: ", value );
				let result = ( value === "New Visitor" ? "first visit" : value );
				return result;
			}() );

			_aape.metrics.eVar84 = ( function () {
				if ( _aape.metrics.eVar25 == 'consumer app' ) {
					let evar84Ios = remoteUtils.getQueryParam( 'idfa', document.URL ),
						evar84And = remoteUtils.getQueryParam( 'advertising_id', document.URL ),
						evar84 = ( evar84Ios ? evar84Ios : evar84And ? evar84And : '' );
					return evar84;
				}
				return '';
			}() );

			_aape.metrics.eVar86 = ( function () {
				var stashDataObj = stash.getPersistedDataWithKey( "categoryRecommendation" );
				var result = "";

				if ( stashDataObj ) {

					var collectionID = ( ddo.content && ddo.content.collection && ddo.content.collection.collectionID ? ddo.content.collection.collectionID : '' );

					result += ( stashDataObj.categoryRecommendationType ? stashDataObj.categoryRecommendationType : 'n/a' ) + "-";
					result += _aape.metrics.prop5 + "-";
					result += ( ddo.page && ddo.page.category && ddo.page.category.subCategory2 ? ddo.page.category.subCategory2 : 'n/a' ) + "-";
					result += ( stashDataObj.displayPosition ? stashDataObj.displayPosition : 'n/a' ) + "-";
					result += ( stashDataObj.anchorSku ? stashDataObj.anchorSku : 'n/a' ) + "-";
					result += ( stashDataObj.anchorCollectionID ? stashDataObj.anchorCollectionID : 'n/a' ) + "-";
					result += ( collectionID ? collectionID : 'n/a' ) + "-";
					result += ( stashDataObj.version ? stashDataObj.version : 'n/a' ) + "-";
					result += ( stashDataObj.strategy ? stashDataObj.strategy : 'n/a' );

				}

				/**
				 * category recommendation event which is linked to eVar86
				 */
				if ( result ) {
					_aape.metrics.events = utilities.apl( "event87" );
				}

				return result;

			}() );

			/// Start Aurora Cart Updates
			_aape.metrics.eVar89 = digitalDataFormatters.formatCartID( ddo, ddo.cart.cartID );
			// End Aurora Cart Update

			/**
			 * eVar for intergration with perimeterx
			 * @type {string}
			 */
			_aape.metrics.eVar92 = ( _aape.pxbs ? _aape.pxbs : '' );

			//enrichment data evar
			_aape.metrics.list3 = ( _aape.pxEnrich ? _aape.pxEnrich : '' );

			// Aurora SVOCID
			_aape.metrics.eVar94 = ( function ( ddo ) {

				var result = "";
				if ( ddo.user.profile.profileInfo.profileID ) {

					//We check to make sure this value is NOT ALL NUMBERS before setting it (has at least 1 non-numeric character), to avoid putting the WCSid into this variable
					if ( ddo.user.profile.profileInfo.profileID.toString().match( /[^0-9]/ ) ) {

						result = ddo.user.profile.profileInfo.profileID;

					}
				}

				return result;

			}( ddo ) );

			_aape.metrics.eVar100 = ( function () {

				let tmxValue = 	stash.getPersistedDataWithKey( "tmxPolicyDetails" );
				
				if ( !tmxValue ) {
					tmxValue = stash.getEventData( "tmxPolicyDetailsErrorCase" );
				}

				stash.deletePersistedData( "tmxPolicyDetails" );
				stash.deleteEventData( "tmxPolicyDetailsErrorCase" );

				return tmxValue;

			}());

			/* addition of Martech code id from param */
			_aape.metrics.eVar110 = remoteUtils.getQueryParam( 'mtc', document.URL );

			_aape.metrics.eVar156 = ( function ( ddo ) {

				var result = '';
				if ( ddo.appExperience && ddo.appExperience.length ) {
					for ( var index = 0; index < ddo.appExperience.length; index += 1 ) {
                        result += ( ddo.appExperience[ index ].name ? ddo.appExperience[ index ].name : 'n/a' ) + ">" + ( ddo.appExperience[ index ].version ? ddo.appExperience[ index ].version : 'n/a' ) + ">" + ( ddo.appExperience[ index ].featureVersion ? ddo.appExperience[ index ].featureVersion : 'n/a' );

						if ( index < ddo.appExperience.length - 1 ) {
							result += "|";
						}
					}
				}

				return result;

			}( ddo ) );

			_aape.metrics.eVar129 = ( function () {

				var stashDataObj = stash.getPersistedDataWithKey( "contentModuleClick" ),
					result = "",
					widgetObj = ( stashDataObj && stashDataObj.content && stashDataObj.content.widgets && stashDataObj.content.widgets[ 0 ] ? stashDataObj.content.widgets[ 0 ] : '' );

				if ( widgetObj ) {

					result += ( widgetObj.id ? widgetObj.id : "n/a" ) + "|";
					result += ( widgetObj.name ? widgetObj.name : "n/a" ) + "|";
					result += ( widgetObj.templates ? widgetObj.templates : "n/a" ) + "|";
					result += ( widgetObj.component ? widgetObj.component : "n/a" ) + "|";
					result += ( widgetObj.campaign ? widgetObj.campaign : "n/a" ) + "|";
					result += ( widgetObj.action ? widgetObj.action : "n/a" ) + "|";
					result += ( stashDataObj.pageType ? stashDataObj.pageType : "n/a" );

					_aape.metrics.events = utilities.apl( "event194" );
				}

				return result;

			}() );

			_aape.metrics.eVar145 = ( window.location && location.protocol && location.pathname && location.host ? location.protocol + '//' + location.host + location.pathname : '' );
			_aape.metrics.eVar146 = _aape.metrics.pageURL;
			_aape.metrics.eVar147 = remoteUtils.getQueryParam( 'ecc_ord', document.URL );

			// widget tracking
			mapMethods.setWidgetTracking( stash.getPersistedDataWithKey( "contentModuleClick" ) );

			_aape.metrics.eVar150 = ( ddo.site.businessType ? ddo.site.businessType.toString().toLowerCase() : "b2c" );

			if ( ddo.site.businessType.toString().toLowerCase() === "b2b" ) {

				_aape.metrics.eVar151 = ddo.user.b2bProfile.userType;

				_aape.metrics.eVar152 = ddo.user.b2bProfile.userID;

				_aape.metrics.eVar153 = ddo.user.b2bProfile.accountID;

				_aape.metrics.eVar155 = ddo.user.b2bProfile.userTradeType;

			}

			_aape.metrics.eVar142 = ( function () {

				var experience = stash.getPersistedDataWithKey( "experience" ),
					result = "";

				if ( typeof experience === 'string' && experience ) {

					experience = experience.toLowerCase();

					result = ( experience === 'hd home' ? experience : "na" );

					stash.deletePersistedData( "experience" );

				}

				return result;

			}() );

			//eVar for Article pagename
			_aape.metrics.eVar157 = ( function () {
				var pgName = ddo.page.pageInfo.pageName;
				if ( pgName && pgName.toString().match( /article>9ba/ ) ) {
					return pgName;
				}
				else {
					return "";
				}
			}() );

			_aape.metrics.eVar163 = ( remoteUtils.getQueryParam( 'neweng', document.URL ) ? remoteUtils.getQueryParam( 'neweng', document.URL ) : remoteUtils.getQueryParam( 'bzid', document.URL ) ? remoteUtils.getQueryParam( 'bzid', document.URL ) : '' );

			_aape.metrics.eVar171 = ( function () {

				var result = ""

				result = ( ddo.user.b2bProfile.perks.enrollment ? ddo.user.b2bProfile.perks.enrollment : "n/a" );
				result += ",";
				result += ( ddo.user.b2bProfile.perks.program ? ddo.user.b2bProfile.perks.program : "n/a" );
				result += ",";
				result += ( ddo.user.b2bProfile.perks.tier ? ddo.user.b2bProfile.perks.tier : "n/a" );

				return result;

			}() );

			_aape.metrics.eVar172 = ( function () {

				var result = "";

				result = ( ddo.user.b2bProfile.preferredPricing.enrollment ? ddo.user.b2bProfile.preferredPricing.enrollment : "n/a" );
				result += ",";
				result += ( ddo.user.b2bProfile.preferredPricing.program ? ddo.user.b2bProfile.preferredPricing.program : "n/a" );
				result += ",";
				result += ( ddo.user.b2bProfile.preferredPricing.tier ? ddo.user.b2bProfile.preferredPricing.tier : "n/a" );

				return result;

			}() );

			if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2business-desktop" ) {
				//extension should go here for PX
				_aape.metrics.eVar173 = ( function () {

					let pxCookie = storage.getItem( 'pxdefender' );

					if ( pxCookie !== '' ) {
						_aape.metrics.events = ( pxCookie && pxCookie.toString() === 'true' ? utilities.apl( 'event266' ) : utilities.apl( 'event267' ) );

						return 'extension';

					}

					return '';

				}() );
			}
			/* eslint-disable no-useless-escape */
			/*passing metarouter id */
			_aape.metrics.eVar177 = ( function () {
				let mrId = remoteUtils.readCookie( "ajs_anonymous_id" );
				if ( mrId ) {
					mrId = mrId.replace( /\"/g, "" );
					mrId = mrId.replace( /\\/g, "" );
					return mrId;
				}
				else {
					return '';
				}
			}() );
			/* eslint-enable  no-useless-escape*/

			mapMethods.setRedirect( ddo );

			// Product Impression Tracking
			if ( !appData.getFromCache( "suppressProductImpression" ) && ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {

				// the appData setter will push this value to the private array
				appData.addInternalEvents( {
					"category": {
						"primaryCategory": "content display"
					},
					"eventInfo": {
						"eventName": "product impression"
					}
				} );

				appData.addUpdateCache( "suppressProductImpression", true ); // We only want to send this info once per page load
			}

				
			_aape.metrics.campaign = ( function () {

				var result = "";

				/* Set campaign variable */
				var temp = remoteUtils.getQueryParam( 'cm_mmc,cid' );
				if ( !temp ) { //fallback for commission junction
					temp = ( 'true' === remoteUtils.getQueryParam( 'cj' ) ) ? 'cj-_-cj-_-cj-_-cj' : '';
				}
				if ( temp ) {
					temp = decodeURI( temp );
					result = temp;
				}
				else {
					temp = remoteUtils.getQueryParam( 'cm_ven,cm_cat,cm_pla,cm_ite', '-_-' );
					temp = ( !temp ) ? remoteUtils.getQueryParam( 'cm_ven,cm_cat,cm_pla,cm_ite', '-_-', decodeURI( window.location.href ) ) : temp;
					if ( temp ) {
						temp = decodeURI( temp );
						result = temp;
					}
				}

				// Track campaign of 'cj' if it is in the URL but no campaign is found
				var u = ( _aape.metrics.pageURL ? _aape.metrics.pageURL : window.location ) + '';
				if ( !result && u.indexOf( '&cj=true' ) > -1 ) {
					result = "cj-_-omtr_auto_append";
				}
				/* Don't allow same campaign on subsequent pages */
				if ( _aape.metrics.exec < 1 ) {
					var k = storage.getItem( "s_cmpnm" );
					storage.setItem( "s_cmpnm", result );
					if ( result === k ) {
						result = "";
					}
					_aape.metrics.exec += 1;
				}

				return result;

			}() );

			//Akamai Bot Score 
			_aape.metrics.eVar174 =  remoteUtils.readCookie( "_bman" );

			// Article Recommendations
			_aape.metrics.eVar175 = ( function() {
				let articleRecValue = (stash.getPersistedDataWithKey( "articleEvar175Value" ));
				stash.deletePersistedData( "articleEvar175Value" );

				if ( articleRecValue ) {
					_aape.metrics.events = utilities.apl( "event269" );
					return articleRecValue;
				} else {
					return '';
				}
			}())

			//Article Finding Method
			_aape.metrics.eVar176 = ( function( ddo ) {
				let previousPageType = storage.getItem( "s_pv_pType" );
				let previousPageName = storage.getItem( "s_pv_pName" );
				let articleRecPageTypeValue = ( stash.getPersistedDataWithKey( "articleEvar176Value" ) );
				stash.deletePersistedData( "articleEvar176Value" );

				if ( _aape.metrics.eVar157 && document.cookie.indexOf( 'CNative' ) === -1 ) {

					if ( _aape.metrics.eVar175 && articleRecPageTypeValue ) {
						return articleRecPageTypeValue;
					}

					if ( document.URL.indexOf( 'searchRedirect' ) > -1 ) {
						return 'internal search';
					}

					if ( document.referrer.indexOf( 'homedepot.com' ) === -1 || ( document.referrer === '' && document.URL.indexOf( 'searchRedirect' ) === -1 ) || remoteUtils.getQueryParam( 'cm_mmc', document.URL ) ) {
						return 'external: external';

					}

					if ( previousPageType ) {

						let prePgTyLow = previousPageType.toLowerCase();

						if ( prePgTyLow === 'article>alp' ) {
							let artText = ( ddo.page.category.subCategory2 ? ddo.page.category.subCategory2.match( '>.*>' ) : 'undefined' );
							if ( Array.isArray( artText ) ) {
								artText = artText[ 0 ].slice( 1, -1 ); //zero array returns string, slice skips 1st char, -1 indexs from end of string.(skips the last char)
								return 'alp: ' + ( artText ? `${ artText } : ${ previousPageName }` : '' );
							}
							return 'alp: ';

						}
						else if ( prePgTyLow === 'homepage' ) {
							return `page referral: homepage : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'search results' ) {
							return `page referral: search results : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'plp' ) {
							return `page referral: plp : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'category' ) {
							return `page referral: category : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'pip' || prePgTyLow === 'expanded view overlay' ) {
							return `page referral: pip : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'pep' ) {
							return `page referral: pep : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'content' ) {
							return `page referral: content : ${ previousPageName }`;
						}
						else if ( prePgTyLow === 'article' ) {
							return `page referral: article : ${ previousPageName }`;
						}
						else {
							return `page referral: other : ${ previousPageName }`;
						}
					}

				}


			}( ddo ) )
			
			//Article ALP Filters Method
			_aape.metrics.eVar188 = ( function ( ddo ) {
				if ( ( ddo.page.pageInfo.pageType === "article>alp" ) && ( ddo.page.filter && Array.isArray( ddo.page.filter ) ) ) {
					let formattedArray = [];

					for ( const filterRec of ddo.page.filter ) {
						let filterType = ( function ( filterRec ) {
							if ( typeof(filterRec.type) === 'string' ) {
								let lcFilterType = filterRec.type.toLowerCase();

								if ( lcFilterType === 'information type' ) {
									return 'IA';
								} else if ( lcFilterType === 'home area' ) {
									return 'HA';
								} else if ( lcFilterType === 'keyword' ) {
									return 'KW';
								} else if ( lcFilterType === 'video' ) {
									return 'VD';
								} else if ( lcFilterType === 'brand type' ) {
									return 'BT';
								} else if ( lcFilterType === 'seasonal' ) {
									return 'SL';
								} else {
									return 'na';
								}
							} else {
								return 'na';
							}

						}( filterRec ) );

						let filterValue = filterRec.value ? filterRec.value : 'na';
						formattedArray.push(`${filterType}:${filterValue}`);
					}

					if ( formattedArray.length > 0 ) { 
						return formattedArray.join('>');
					}
				}

				return '';
			}( ddo ) );

			if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {

				_aape.metrics.eVar184 = ( ddo.user.localization.userZip ? ddo.user.localization.userZip.toString() : 'na' );

			}

			/* seo/earned media query param */
			_aape.metrics.eVar194 = remoteUtils.getQueryParam( 'emt', document.URL );
			
			/* New Header Variable */
			_aape.metrics.eVar195 = ( ddo.page.pageInfo.headerVersion ? ddo.page.pageInfo.headerVersion : '' );
			
			// TARGET DATA OBJECT
			_aape.metrics.targetEventData = window._tt?.TDO?.getEventData() ?? [];
			_aape.metrics.eVar199 = ( Array.isArray( _aape.metrics.targetEventData ) && _aape.metrics.targetEventData.length  ? _aape.metrics.targetEventData.join( "|" ) : "" );		

			//Sprinklr ID
			_aape.metrics.eVar245 = ( _aape.sprId ?  _aape.sprId : '' );

			//ECR PARTY ID
			_aape.metrics.eVar249 = storage.getItem( "ecridFromSVOCID" ).toUpperCase();
		}
	},
	't': {
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.referrer = document.referrer;
			_aape.metrics.channel = ddo.page.category.primaryCategory;
			_aape.metrics.prop1 = ddo.page.category.subCategory1;
			_aape.metrics.prop2 = ddo.page.category.subCategory2;

			// _aape.metrics.localizationMethod set in unviversal
			_aape.metrics.prop9 = _aape.metrics.localizationMethod;		

			// Capture sign In Success
			if ( stash.getPersistedDataWithKey( "signInSuccess" ) ) {
				_aape.metrics.events = utilities.apl( 'event25' );
				stash.deletePersistedData( "signInSuccess" );
			}

			// Capture Target Vitals
			( function setTargetVitals() {

				let targetVitals = ( typeof ( window.getAtPerformance ) === 'function' ? window.getAtPerformance() : [] );						

				targetVitals.forEach( ( vital ) => {

					if ( vital[ 'LLL' ] ) {
						_aape.metrics.events = utilities.apl( `event280=${vital.LLL}` );
					}

					if ( vital[ 'TNC' ] ) {
						_aape.metrics.events = utilities.apl( `event281=${vital.TNC}` );
					}

					if ( vital[ 'ATRS' ] ) {
						_aape.metrics.events = utilities.apl( `event282=${vital.ATRS}` );
					}

					if ( vital[ 'ATRF' ] ) {
						_aape.metrics.events = utilities.apl( `event283=${vital.ATRF}` );
					}

					if ( vital[ 'ATCS' ] ) {
						_aape.metrics.events = utilities.apl( `event284=${vital.ATCS}` );
					}

					if ( vital[ 'ATCF' ] ) {
						_aape.metrics.events = utilities.apl( `event285 =${vital.ATCF}` );
					}

				} );

			}() );

			_aape.metrics.prop25 = ( document.referrer.indexOf("homedepot.com") !== -1 && history.length === 1  ? "new tab" : "" );

			_aape.metrics.prop30 = ddo.page.pageInfo.pageType;

			//Eyeo Ad Blo	
			_aape.metrics.prop32 = ddo.page.pageInfo.adBlocker ? ddo.page.pageInfo.adBlocker : '';

			_aape.metrics.prop41 = ddo.user.localization.gpsPermission;

			// capture previous page version (prop33) on all page level tracking
			_aape.metrics.prop43 = storage.getItem( "s_pv_pVer" );

			// capture previous page name on all page level tracking
			_aape.metrics.prop52 = storage.getItem( "s_pv_pName" );
			_aape.metrics.prop61 = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

			if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
				_aape.metrics.prop62 = "no template";
			}

			_aape.metrics.prop75 = ( function () {
				
				let hdr = remoteUtils.getQueryParam('hdr', document.URL);
				let stashHC = stash.getPersistedDataWithKey( "headerClick" );
				let _prop75 = "";

				if ( stashHC ) {
					_prop75 = stashHC;
					stash.deletePersistedData( "headerClick" );
					_aape.metrics.prop37 = "headerClickStash";
				} else if ( hdr ) {
					_prop75 = decodeURI( decodeURI( hdr ) );
					_aape.metrics.prop37 = "hdrQueryParam";
				}

				return _prop75;
			}() );

			
			_aape.metrics.eVar2 = ( ddo.page?.decisionEngine?.post_de ? ddo.page.decisionEngine.post_de : '' );
			
			/* Capture Link ID Values */
			if ( !_aape.metrics.eVar3 ) {
				_aape.metrics.eVar3 = remoteUtils.getQueryParam( 'cm_sp' );
			}

			_aape.metrics.eVar8 = ( _aape.metrics.prop30 ? _aape.metrics.prop30 : '' );

			_aape.metrics.eVar14 = _aape.metrics.localizationMethod;

			// Capture N-Value 
			_aape.metrics.eVar30 = ( ddo.page.pageInfo.pageID ? ddo.page.pageInfo.pageID : "" );
			
			/* Get Exact Target ID */
			if ( !_aape.metrics.eVar46 ) {
				_aape.metrics.eVar46 = remoteUtils.getQueryParam( 'et_rid', document.URL );
			}

			// My Account Military Exchange
			_aape.metrics.eVar213 = ( ddo.user.profile.exchange ? ddo.user.profile.exchange : '' );

			// Header Click
			_aape.metrics.eVar230 = ( _aape.metrics.prop75 ? _aape.metrics.prop75 : '' );

			/*Capture of Google id_GCLID*/
			_aape.metrics.eVar250 = remoteUtils.getQueryParam( "gclid", document.URL );

			if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ||  BUILD_TARGET === "b2business-desktop" || BUILD_TARGET === "b2business-mobile" ) {

				_aape.metrics.eVar144 = ( function () {

					let resultArr = [],
						result = '',
						contentModule = ( ddo.content && Array.isArray( ddo.content.module ) && ddo.content.module.length > 0 ? ddo.content.module : '' );

					// PLCC Next Page Beacon Fields/Events
					let stashContentModuleValue = ( stash.getPersistedDataWithKey( "stashContenModuleImpressionValue" ) );
					stash.deletePersistedData( "stashContenModuleImpressionValue" );

					if ( stashContentModuleValue ) {

						resultArr.push( stashContentModuleValue );

					}

					if ( contentModule ) {

						for ( let i = 0; i < contentModule.length; i++ ) {

							if ( contentModule[ i ].name && contentModule[ i ].feature && contentModule[ i ].type ) {

								resultArr.push( contentModule[ i ].name + ">" + contentModule[ i ].feature + ">" + contentModule[ i ].type );

							}

						}

					}

					result = resultArr.join( '|' );

					if ( result.indexOf( "plcc" ) > -1 ) {
						_aape.metrics.events = utilities.apl( "event258" );
					}

					return result;

				}() );
			}

			/* A/B testing */
			let target = ddo.page.target;
			if (target) {
				if( target.experienceNameA ) {
					_aape.metrics.eVar140 =  target.experienceNameA;
				} else if( target.experienceNameB ) {
					_aape.metrics.eVar141 = target.experienceNameB
				}
			}

			/* if orig_ref param exists populate _aape.metrics.referrer */
			var oref = remoteUtils.getQueryParam( "orig_ref", document.URL );
			var utmref = remoteUtils.getQueryParam( "utm_referrer", document.URL );

			// orig ref takes precedent
			oref = ( oref ? oref : utmref ? utmref : '' );

			if ( oref ) {
				if ( oref.indexOf( 'http%' ) === 0 || oref.indexOf( 'https%' ) === 0 ) {
					_aape.metrics.referrer = unescape( oref );
				}
				else {
					_aape.metrics.referrer = oref;
				}
			}

			/* Populate Campaign for Altruik */
			var a = "";
			var ref = ( _aape.metrics.referrer ) ? _aape.metrics.referrer : document.referrer;
			var prevcamp = storage.getItem( "s_pv_cmpgn" );
			var tYmal = remoteUtils.getQueryParam( 'merch' );

			ref = ref.toLowerCase();

			if ( tYmal && tYmal !== '' ) {
				a = tYmal.split( "-_-" );
				a = a[ 2 ];
			}

			if ( !_aape.metrics.campaign && ref && /homedepot.com.buy\//.test( ref ) && ( a || !prevcamp || !/altruik/.test( prevcamp ) ) ) {
				_aape.metrics.campaign = "seo|altruik" + ( a ? "|" + a : "" );
			}

			if ( _aape.metrics.campaign ) {
				_aape.metrics.eVar43 = _aape.metrics.campaign;
			}

			/**
			 * Page level enhanced error tracking
			 *   Iterates over ddo.page.error array to find unreported errors.
			 *   if any found, add to _aape.metrics.list2 and mark as reported
			 *   ~ sets isReported = true for newly reported errors so they will not be processed again.
			 */
			_aape.metrics.list2 = ( function ( ddo ) { //TODO: when we remove the legacy error requirement for OPC, we can combine the _aape.metrics.t() and _aape.metrics.tl() setting of _aape.metrics.list2 into a common method

				var list2 = "";

				if ( Array.isArray( ddo.page.error ) ) {

					var errors = ddo.page.error,
						result = [],
						_left = function ( str, count ) { // main purpose of this method is the safe checking
							str = typeof str !== 'undefined' ? str : '';
							count = typeof count !== 'undefined' ? count : 2;

							return str.substr( 0, count );
						};

					errors.forEach( function ( error, index ) {
						if ( !error.isReported ) {
							error.isReported = true;
							digitalData.page.error[ index ].isReported = true;
							result.push( _left( error.type ) + ":" + _left( error.displayType ) + ":" + ( error.pageSection ? error.pageSection : '' ) + ":" + ( error.message ? error.message : '' ) + ":" + ( error.code ? error.code : '' ) );
						}
					} );

					list2 = result.join( "|" );
				}

				if ( list2 ) {
					_aape.metrics.events = utilities.apl( 'event49' );
				}

				return list2;

			}( ddo, eventIndex ) );

			if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
				_aape.metrics.eVar82 = "no template";
			}

			//internal tracking code
			_aape.metrics.eVar180 = remoteUtils.getQueryParam( 'itc', document.URL );

			//revjet creative ID
			if ( _aape.metrics.eVar180 ) {
				_aape.metrics.eVar178 = ( remoteUtils.getQueryParam( 'rev_cid', document.URL ) ? remoteUtils.getQueryParam( 'rev_cid', document.URL ) : 'no revjet ids' );

				//internal tracking code click event
				_aape.metrics.events = utilities.apl( "event209" );
			}

			// Pinterest Experience Tracking

			if ( BUILD_TARGET === "b2consumer-desktop" ) {
				var _shopByPinImageCount = stash.getEventData( "shopByPinImageCount" );

				if ( _shopByPinImageCount !== "" ) {

					_aape.metrics.events = utilities.apl( "event242=" + _shopByPinImageCount );
					stash.deleteEventData( 'shopByPinImageCount' );

				}

				var _pinterest = ( ddo.content && ddo.content.pinterest ? ddo.content.pinterest : {} );

				if ( typeof ( _pinterest.totalProductsDisplayed ) !== 'undefined' ) {
					_aape.metrics.events = utilities.apl( "event243=" + _pinterest.totalProductsDisplayed );
				}

				if ( typeof ( _pinterest.totalCategoriesDisplayed ) !== 'undefined' ) {
					_aape.metrics.events = utilities.apl( "event244=" + _pinterest.totalCategoriesDisplayed );
				}

				var _shopByPinCategory = stash.getEventData( "shopByPinCategory" );

				if ( utilities.objHasValue( _shopByPinCategory ) ) {

					if ( typeof ( _shopByPinCategory.totalProductsSelected ) !== 'undefined' ) {
						_aape.metrics.events = utilities.apl( "event245=" + _shopByPinCategory.totalProductsSelected );
					}

					if ( typeof ( _shopByPinCategory.totalCategoriesSelected ) !== 'undefined' ) {
						_aape.metrics.events = utilities.apl( "event246=" + _shopByPinCategory.totalCategoriesSelected );
					}

					stash.deleteEventData( 'shopByPinCategory' );

				}

			}			
		}
	},
	'tl': {
		'setMetrics': function () {
			_aape.metrics.referrer = "";
			_aape.metrics.prop35 = _aape.metrics.pageName;

			utilities.addEventsToLinkTrack( "event40" );
			utilities.addVarsToLinkTrack( "pageName,events,prop5,prop13,prop24,prop31,prop33,prop34,prop35,prop38,prop46,prop47,prop50,prop55,prop56,prop57,prop63,prop67,eVar1,eVar9,eVar15,eVar17,eVar25,eVar26,eVar27,eVar35,eVar37,eVar47,eVar54,eVar61,eVar69,eVar89,eVar94,eVar99,eVar100,eVar145,eVar146,eVar147,eVar150,eVar151,eVar152,eVar153,eVar155,eVar174,eVar178,eVar180,eVar183,eVar194,eVar195,eVar199,eVar244,eVar245,eVar249" );
		}
	},

	'blinds_customizer_page': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.product );

			_aape.metrics.events = utilities.apl( 'event155,event184' );
		}
	},	
	'button_submission*item_config_update': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "item config update",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'scAdd,event98,event156,event157' );
			
			_aape.metrics.products = productString.run( 'cartAdd', ddo.event[ eventIndex ].item, { "pageType": ddo.page.pageInfo.pageType } );

			utilities.addEventsToLinkTrack( 'scAdd,event98,event156,event157' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},	
	'button_submission*design_save': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design save",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event210' );
			utilities.addEventsToLinkTrack( 'event210' );
		}
	},
	'button_submission*design_delete': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design delete",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event211' );
			utilities.addEventsToLinkTrack( 'event211' );
		}
	},
	'button_submission*design_duplicate': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design duplicate",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event212' );
			utilities.addEventsToLinkTrack( 'event212' );
		}
	},
	'button_submission*design_shop_products': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design shop products",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event213' );
			utilities.addEventsToLinkTrack( 'event213' );
		}
	},
	'button_submission*design_add_product': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design add product",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event214' );

			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( 'event214' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*design_remove_product': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design remove product",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event215' );
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( 'event215' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*design_swap_products': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design swap products",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event216' );
			utilities.addEventsToLinkTrack( 'event216' );
		}
	},
	'button_submission*design_item_config_update': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design item config update",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event217' );
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( 'event217' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*design_copy_style': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design copy style",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event218' );
			utilities.addEventsToLinkTrack( 'event218' );
		}
	},
	'button_submission*video_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "video start",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event13' );
			_aape.metrics.eVar168 = ( ddo.event && ddo.event[ eventIndex ] && ddo.event[ eventIndex ].video && ddo.event[ eventIndex ].video.id ? ddo.event[ eventIndex ].video.id : '' );
			utilities.addEventsToLinkTrack( 'event13' );
			utilities.addVarsToLinkTrack( 'eVar168' );
		}
	},
	'button_submission*video_complete': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "video complete",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event270' );
			_aape.metrics.eVar168 = ( ddo.event && ddo.event[ eventIndex ] && ddo.event[ eventIndex ].video && ddo.event[ eventIndex ].video.id ? ddo.event[ eventIndex ].video.id : '' );
			utilities.addEventsToLinkTrack( 'event270' );
			utilities.addVarsToLinkTrack( 'eVar168' );
		}
	},
	'button_submission*bundle_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "bundle add",
		'setMetrics': function ( ddo, eventIndex ) {

			let bundleType = 'add';
			
			_aape.metrics.products = productString.run( 'bundle', ddo.event[ eventIndex ].item, { "bundleType": bundleType } );

			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*bundle_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "bundle remove",
		'setMetrics': function ( ddo, eventIndex ) {

			let bundleType = 'remove';
			
			_aape.metrics.products = productString.run( 'bundle', ddo.event[ eventIndex ].item, { "bundleType": bundleType } );
			
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'category_plp': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			mapMethods.setInitialLoadBrowseNucleus( ddo );

		}
	},
	'browse_results': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			mapMethods.setInitialLoadBrowseNucleus( ddo );

		}
	},
	'search_results': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			let searchTerm = ( ddo.page.onsiteSearchInfo.searchTerm ? ddo.page.onsiteSearchInfo.searchTerm : '' );

			_aape.metrics.events = utilities.apl( "event15" );

			_aape.metrics.prop4 = searchTerm;
			_aape.metrics.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults ? ddo.page.onsiteSearchInfo.numberOfResults : '' );
			_aape.metrics.prop21 = storage.getItem( "s_pv_pName" );

			_aape.metrics.eVar5 = searchTerm;
			_aape.metrics.eVar12 = ( ddo.page.onsiteSearchInfo.resultsType ? ddo.page.onsiteSearchInfo.resultsType : '' );

			mapMethods.setInitialLoadSearchNucleus( ddo );

		}
	},
	'pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			const _filterArray = ( Array.isArray( ddo.page.filter ) && ddo.page.filter.length ? ddo.page.filter : [] ),
				_isFilter2point0 = ( _filterArray.length && Array.isArray( _filterArray[ 0 ] ) ? true : false ),
				pageNumber = ( ddo.page.displayAttributes && typeof ( ddo.page.displayAttributes.pageNumber ) !== 'undefined' ? ddo.page.displayAttributes.pageNumber : '' ),
				headerCrumb = ( ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" );

			_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">pagination";

			_aape.metrics.prop7 = pageNumber;

			_aape.metrics.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );

			_aape.metrics.prop61 = headerCrumb;

			_aape.metrics.prop62 = ddo.page.pageInfo.pageTemplate;
			
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

			if ( _isFilter2point0 ) {
				
				_aape.metrics.eVar18 = ( _filterArray.length ? digitalDataFormatters.formatSearchBrowseFilters( _filterArray[ _filterArray.length - 1 ], ";" ) : "" );
				
				_aape.metrics.eVar29 = _filterArray.map( filterArr => digitalDataFormatters.formatSearchBrowseFilters( filterArr ) ).join(",");
				
				_aape.metrics.prop16 = _aape.metrics.eVar29;			

	
			} else {

				_aape.metrics.eVar29 = mapMethods.getFilters( _filterArray );
				
				_aape.metrics.prop16 = _aape.metrics.eVar29;
				
	
			}
			
			_aape.metrics.eVar28 = headerCrumb;
			_aape.metrics.eVar31 = headerCrumb;
			
			//For pagination case, give DDO the priority
			if ( ddo.page.onsiteSearchInfo.resultsCategory ) {

				_aape.metrics.eVar63 = ddo.page.onsiteSearchInfo.resultsCategory;

			}

			_aape.metrics.eVar82 = ddo.page.pageInfo.pageTemplate;

			_aape.metrics.eVar103 = digitalDataFormatters.getContentSku( ddo );

			if ( _aape.metrics.eVar103 !== '' || _aape.metrics.eVar103 !== undefined ) {
				_aape.metrics.events = utilities.apl( "event118" );
			}

			if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
				_aape.metrics.events = utilities.apl( "event119" );

				_aape.metrics.products = productString.run( 'productImpression', ddo.content.product, { "pageNumber": pageNumber } );

				_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );
			}
		}

	},
	'cart_view': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			var optimalFlag = false,
				cartItems = ( ddo.cart.item ? ddo.cart.item : [] );

			_aape.metrics.events = utilities.apl( "scView,event69,event169" );

			// APPL Delivery Fee Tracking (Cart page only)
			/* 
				Used == here to allow looser matching of 29.  For example any of these 
				variations of 29 return true: ["29.00","29",29,29.00]
			*/
			if ( typeof ( ddo.cart.price.applDeliveryFee ) !== "undefined" && ddo.cart.price.applDeliveryFee == 29 ) {

				_aape.metrics.events = utilities.apl( "event305" );

			}
			
			if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {

				//Instant Checkout impression on Cart page load (event80)
				if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.instantCheckoutDisplayed ) === 'string' && ddo.content.feature.instantCheckoutDisplayed.toLowerCase() === 'y' ) {

					_aape.metrics.events = utilities.apl( "event80" );

				}				

				//Optimal Fulfillment linked to event265

				for ( let i = 0; i < cartItems.length; i++ ) {
					if ( cartItems[ i ].fulfillment && cartItems[ i ].fulfillment.changeType && cartItems[ i ].fulfillment.changeType.toString().toLowerCase() === 'optimal' ) {
						optimalFlag = true;
						break;
					}
				}

				if ( optimalFlag ) {
					_aape.metrics.events = utilities.apl( "event265" );
				}

			}

			_aape.metrics.products = productString.run( "cartView", ddo.cart.item, {
				"addrevenueevents": true,
				"content": ddo.content,				
				"pageType": ddo.page.pageInfo.pageType
			} );

			_aape.metrics.eVar62 = ( function () {
				var _eVar62 = storage.getItem( "eVar62" );
				if ( !_eVar62 || ( _eVar62 && _eVar62.indexOf( ">" ) === -1 ) ) {
					_eVar62 = digitalDataFormatters.getFulfillString();
				}
				storage.setItem( "eVar62", _eVar62 );
				return _eVar62;
			}() );

			//Cart Error Section
			_aape.metrics.eVar117 = ( ddo.cart?.errorSection || '' );

			// Bulk Fulfillment Option on Cart Page
			_aape.metrics.eVar119 = ( ddo.cart.bulkAvailability ? ddo.cart.bulkAvailability : '' );
			
			//shared cart ID
			_aape.metrics.eVar125 = ( ddo.cart.sharedCartID ? ddo.cart.sharedCartID : '' );

			//successful event retrieval status event and cart add
			if ( _aape.metrics.eVar125 ) {

				_aape.metrics.events = ( function ( ddo ) {
					var scOpenString = "",
						_evtStr = utilities.apl( 'scAdd,event98' ),
						_cartID = ( ddo.cart && ddo.cart.cartID ? ddo.cart.cartID : "" );

					if ( _cartID ) {
						scOpenString = 'scOpen:' + _cartID;
						_evtStr = utilities.apl( scOpenString, _evtStr );
					}

					_evtStr = utilities.apl( "event236", _evtStr );

					return _evtStr;
				}( ddo ) );

				_aape.metrics.products = productString.run( "cartView", ddo.cart.item, {					
					"atcloc": "checkout<n/a<shared cart<n/a<atc<n/a",
					"content": ddo.content,
					"pageType": ddo.page.pageInfo.pageType
				} );

			}
			
			// Pro Large Cart			
			_aape.metrics.eVar200 = ( ddo.cart.cartViewType ? ddo.cart.cartViewType : '' );

			_aape.metrics.eVar226 = ( ddo.cart.quantityTotal ? ddo.cart.quantityTotal : "" );
			_aape.metrics.eVar227 = ( ddo.cart.uniqueSkuCount ? ddo.cart.uniqueSkuCount : "" );
			_aape.metrics.eVar228 = (ddo.cart.price && ddo.cart.price.cartTotal ? ddo.cart.price.cartTotal : "" );


		}
	},
	'empty_cart': {
		// Fire scView on empty cart
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "scView" );
		}
	},
	'checkout_sign_in': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( "event70,event170" );
			_aape.metrics.products = productString.run( "cartView", ddo.cart.item );
		}
	},
	'request_a_quote': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( "event74" );
			_aape.metrics.eVar24 = ( ddo.page && ddo.page.form && ddo.page.form.formName ? ddo.page.form.formName : '' );
		}
	},
	'paypal_order_review': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( "event73,event173" );
			_aape.metrics.eVar33 = "ppl";

			if ( ddo.cart.attributes && ddo.cart.attributes.poJobName ) {
				_aape.metrics.eVar159 = ddo.cart.attributes.poJobName;
			}

			_aape.metrics.products = productString.run( "cartView", ddo.cart.item );

			_aape.metrics.transactionID = ( ddo.cart && ddo.cart.cartID ? ddo.cart.cartID : "" );

			if ( config.site === "b2consumer-desktop" || config.site === "b2business-desktop" ) {
				_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ">ppe-cart";
			}
		}
	},
	'focused_product': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			var focusedProducts = ( function ( content ) {
				var result = [];

				if ( typeof ( content ) !== 'undefined' && Array.isArray( content.product ) && content.product.length ) {

					result = content.product.filter( function ( obj ) {
						return obj.productInfo && obj.productInfo.focused;
					} );

				}

				return result;

			} )( ddo.content );

			_aape.metrics.events = utilities.apl( 'prodView,event186' );

			if ( focusedProducts.length ) {		
				_aape.metrics.products = productString.run( 'skuOnly', focusedProducts );
			}

		}
	},
	'product_view': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setProductView( ddo, eventIndex );
		}
	},
	'pep_view': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setProductView( ddo, eventIndex );

			mapMethods.setInitialLoadSearchNucleus( ddo );

			_aape.metrics.events = utilities.listRemove( _aape.metrics.events, "event15" );

		}
	},
	'product_comparison': { // Page load event pip plus FBT if available
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( 'event12' );
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.product );

			_aape.metrics.prop11 = utilities.getValuesByPath( ddo.product, 'productInfo.sku' ).join(",");
		}
	},
	'installation_form_start': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			var formObj = ( ddo.page.form ? ddo.page.form : {} );

			_aape.metrics.events = utilities.apl( 'event74' );

			_aape.metrics.eVar24 = ( formObj.formName ? formObj.formName : '' );
		}
	},
	'installation_form_complete': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			var formObj = ( ddo.page.form ? ddo.page.form : {} );

			_aape.metrics.events = utilities.apl( 'event9' );

			_aape.metrics.eVar24 = ( formObj.formName ? formObj.formName : '' );
			_aape.metrics.eVar72 = ( formObj.universalLeadID ? formObj.universalLeadID : formObj.leadID ? formObj.leadID : '' );
			_aape.metrics.eVar73 = ( formObj.zip ? formObj.zip : '' );

		}
	},
	'hdpp_content*hdpp_display': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			// Checks whether HDPP is displayed in a preload event or in an post-page load event. Sadly, the DCs differ between these event types
			// so we must account for both possibilities.  Being that as it may, the following minimally attempts to accomplish this as succinctly as possible...etc
			var isHdppDisplayed = function ( ddo, eventIndex ) {
				var ev = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

				// We have to check both possible DC locations to account for PIP load as well as event based trigger.
				return ( ( ev.componentInfo && ev.componentInfo.displayedProtectionPlan ) || (
					// todo: remove inline method below after FED implementation updates, the DC value below is deprecated
					( function ( ev ) {
						if ( ev.item ) {

							for ( var i = 0; i < ev.item.length; i++ ) {
								if ( ev.item[ i ].productInfo && ev.item[ i ].productInfo.displayedProtectionPlan ) {
									return true;
								}
							}

						}
						return false;
					}( ev ) )
				) );
			};

			if ( isHdppDisplayed( ddo, eventIndex ) ) {
				_aape.metrics.events = utilities.apl( "event108" );
			}
		}
	},
	'button_submission*filter': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'filter',
		'setMetrics': function ( ddo, eventIndex ) {

			var evar120 = function () {
				var filter = ( typeof ( ddo ) !== "undefined" && ddo.event && ddo.event[ eventIndex ].filter ? ddo.event[ eventIndex ].filter : [] ),
					resultHere = [];

				for ( var i = 0; i < filter.length; i++ ) {

					resultHere.push( ( filter[ i ].name ? filter[ i ].name : "" ) + ':' + ( Array.isArray( filter[ i ].values ) ? filter[ i ].values.join( "," ) : "" ) );

				}

				return resultHere.join( "|" );

			};
			_aape.metrics.events = utilities.apl( "event128" );
			_aape.metrics.eVar120 = evar120();

			utilities.addEventsToLinkTrack( 'event128' );
			utilities.addVarsToLinkTrack( 'eVar120' );
		}
	},
	'button_submission*apple_pay': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'apple-pay',
		'setMetrics': function ( ddo, eventIndex ) {
			
			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl( "scCheckout,event129,event309,event310" );
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.cart.item );
			
			_aape.metrics.eVar33 = mapMethods.setEvar33( ddo.cart.price.paymentMethod, "applepay" );

			// Pro Large Cart			
			_aape.metrics.eVar200 = ( evtObj.cartViewType ? evtObj.cartViewType : '' );

			utilities.addEventsToLinkTrack( 'scCheckout,event129,event309,event310' );
			utilities.addVarsToLinkTrack( 'eVar33,eVar200,products' );
		}
	},
	'button_submission*paypal_express': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'paypal-checkout',
		'setMetrics': function ( ddo, eventIndex ) {
			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl( "scCheckout,event53,event54,event129,event153,event154" );
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.cart.item );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ">ppe-cart";

			
			// Pro Large Cart			
			_aape.metrics.eVar200 = ( evtObj.cartViewType ? evtObj.cartViewType : '' );

			utilities.addEventsToLinkTrack( 'scCheckout,event53,event54,event129,event153,event154' );
			utilities.addVarsToLinkTrack( 'eVar62,eVar200,products' );
		}
	},
	'button_submission*paypal_pay_later': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'paypal-pay-later-checkout',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );
			
			_aape.metrics.events = utilities.apl( "scCheckout,event53,event54,event129,event153,event154,event203" );

			_aape.metrics.products = productString.run( 'skuOnly', ddo.cart.item );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ">pppl-cart";
			
			// Pro Large Cart			
			_aape.metrics.eVar200 = ( evtObj.cartViewType ? evtObj.cartViewType : '' );

			utilities.addEventsToLinkTrack( 'scCheckout,event53,event54,event129,event153,event154,event203' );
			utilities.addVarsToLinkTrack( 'eVar62,eVar200,products' );
		}
	},
	'button_submission*paypal_express_pip': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'paypal express pip',
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "scAdd,scCheckout,event53,event54,event98,event129,event153,event154" );

			_aape.metrics.products = productString.run( 'cartAdd', ddo.event[ eventIndex ].item, { "pageType": ddo.page.pageInfo.pageType } );

			_aape.metrics.eVar33 = mapMethods.setEvar33( ddo.cart.price.paymentMethod, "ppl" );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString( ddo.event[ eventIndex ].item ) + ">ppe-pip";

			utilities.addEventsToLinkTrack( 'scAdd,scCheckout,event53,event54,event98,event129,event153,event154' );
			utilities.addVarsToLinkTrack( 'eVar33,eVar62,products' );
		}
	},
	'button_submission*proceed_to_payment': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'proceed to payment',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event58" );	
			utilities.addEventsToLinkTrack( 'event58' );
		}
	},
	'button_submission*paypal_order_submission': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'submit order',
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( "event76,event77,event176,event177" );
			
			_aape.metrics.products = productString.run( 'opc', ddo.cart.item );

			_aape.metrics.eVar33 = "ppl";
			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString();

			utilities.addEventsToLinkTrack( "event76,event77,event176,event177" );
			utilities.addVarsToLinkTrack( "eVar33,evar62,products" );
		}
	},
	'button_submission*order_submission': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'submit order',
		'setMetrics': function ( ddo, eventIndex ) {

			var isQuote = remoteUtils.getQueryParam( "isQuote", document.URL );

			_aape.metrics.eVar26 = ( function ( ddo ) {
				var result = mapMethods.setEvar26( ddo );
				if ( ddo.user.profile.action === 'register' ) {
					_aape.metrics.events = utilities.apl( "event1,event25" );
					result = 'authenticated';
				}
				return result;
			}( ddo ) );

			_aape.metrics.eVar167 = ( function ( ddo, eventIndex ) {

				let result = "";
				let event = ddo.event[ eventIndex ];

				if ( event && Array.isArray( event.addressValidation ) ) {

					// capture the last value in the array wihtout changing the original array
					let addressValidation = JSON.parse( JSON.stringify( event.addressValidation ) ).pop();

					if ( addressValidation ) {
						result = ( addressValidation.type ? addressValidation.type : 'n/a' ) + ">" + ( addressValidation.overlay ? addressValidation.overlay : 'n/a' ) + ">" + ( addressValidation.address ? addressValidation.address : 'n/a' );
					}

				}

				return result;

			}( ddo, eventIndex ) );

			_aape.metrics.eVar33 = mapMethods.setEvar33( ddo.cart.price.paymentMethod );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ( isQuote === 'true' ? ">quote" : ">opc" );
			
			_aape.metrics.products = productString.run( 'opc', ddo.cart.item );

			_aape.metrics.events = ( function ( ddo ) {
				var _evtStr = utilities.apl( "event76,event176" ),
					_paymentMethodArray = [];

				if ( typeof ( ddo.cart.price ) !== 'undefined' && typeof ( ddo.cart.price.paymentMethod ) !== 'undefined' ) {

					// normalize to an array
					_paymentMethodArray = (	Array.isArray( ddo.cart.price.paymentMethod ) ? ddo.cart.price.paymentMethod : [ ddo.cart.price.paymentMethod ] );	 

					if ( _paymentMethodArray.includes( 'ppl' ) ) {

						_evtStr = utilities.apl( "event77,event177", _evtStr );

					} 
										
					if ( _paymentMethodArray.includes( 'applepay' ) ) {

						_evtStr = utilities.apl( "event311,event312", _evtStr );
						
					}
					
				}

				return _evtStr;

			}( ddo ) );

			_aape.metrics.transactionID = ( ddo.cart && ddo.cart.cartID ? ddo.cart.cartID : '' );

			utilities.addEventsToLinkTrack( "event1,event25,event76,event77,event176,event177,event311,event312" );
			utilities.addVarsToLinkTrack( 'eVar26,eVar33,eVar62,eVar167,products,transactionID' );
		}
	},
	'button_submission*cart_checkout': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'cart checkout',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl( "scCheckout,event129" );
			
			_aape.metrics.products = productString.run( 'cartCheckout', ddo.cart.item );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString();

			// Pro Large Cart			
			_aape.metrics.eVar200 = ( evtObj.cartViewType ? evtObj.cartViewType : '' );
			
			utilities.addEventsToLinkTrack( 'scCheckout,event129' );
			utilities.addVarsToLinkTrack( 'eVar62,eVar200,products' );
		}
	},
	'button_submission*instant_checkout': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'instant checkout',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl( "scCheckout,event129,event30,event76,event176" );
			
			_aape.metrics.products = productString.run( 'cartCheckout', ddo.cart.item );

			_aape.metrics.eVar33 = mapMethods.setEvar33( ddo.cart.price.paymentMethod );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ">instant-checkout";
	
			// Pro Large Cart			
			_aape.metrics.eVar200 = ( evtObj.cartViewType ? evtObj.cartViewType : '' );

			utilities.addEventsToLinkTrack( 'scCheckout,event30,event76,event129,event176' );
			utilities.addVarsToLinkTrack( 'eVar33,eVar62,eVar200,products' );
		}
	},
	'button_submission*curbside_pickup': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'curbside pickup',
		'setMetrics': function (ddo, eventIndex) {
			let itemArr = Array.isArray( ddo.event[ eventIndex ].item ) ? ddo.event[ eventIndex ].item : [],
				revenue = itemArr[0]?.price?.basePrice ?? "";
						
			_aape.metrics.events = utilities.apl( "event22,event273=" + revenue );
			
			_aape.metrics.eVar41 = ( ddo.postOrder.transactionID ? ddo.postOrder.transactionID : "" );

			utilities.addEventsToLinkTrack( 'event22,event273' );
			utilities.addVarsToLinkTrack( 'eVar41' );
		}
	},
	'button_submission*share_cart': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'share cart',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event235" );
			utilities.addEventsToLinkTrack( 'event235' );
		}
	},
	'button_submission*registration': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'account sign in',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( typeof ( ddo.event[ eventIndex ] ) !== 'undefined'  ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl( "event1,event25" );

			_aape.metrics.eVar26 = mapMethods.setEvar26( ddo );
			_aape.metrics.eVar74 = ( typeof ( evtObj.passwordOption ) !== 'undefined' && typeof ( evtObj.userType ) !== 'undefined' ? evtObj.userType + ":" + evtObj.passwordOption : '' );

			utilities.addEventsToLinkTrack( 'event1,event25' );
			utilities.addVarsToLinkTrack( 'eVar26,eVar74' );

		}
	},
	'button_submission*sign_in_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'sign in',
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( "event25" );

			_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;
			_aape.metrics.eVar26 = mapMethods.setEvar26( ddo );

			utilities.addEventsToLinkTrack( 'event25' );
			utilities.addVarsToLinkTrack( 'eVar8,eVar26' );
		}
	},
	'button_submission*pro_xtra_registration_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'pro registration',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event7" );
			utilities.addEventsToLinkTrack( 'event7' );
		}
	},
	'button_submission*pro_xtra_account_create_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'pro xtra account create',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event7" );
			utilities.addEventsToLinkTrack( 'event7' );
		}
	},
	'button_submission*link_account_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'link account',
		'setMetrics': function () {
			/* this block only contained retirement variables, so it is essentially an empty block now */
			return true;
		}
	},
	'button_submission*successful_appliance_reschedule': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'successful appliance delivery',
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( 'event93' );
			_aape.metrics.channel = ddo.page.category.primaryCategory;

			_aape.metrics.prop1 = ddo.page.category.subCategory1;
			_aape.metrics.prop2 = ddo.page.category.subCategory2;
			_aape.metrics.prop30 = ddo.page.pageInfo.pageType;
			_aape.metrics.prop33 = ( ddo.page.pageInfo.abTest ? ddo.page.pageInfo.abTest : '' );

			_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;

			utilities.addEventsToLinkTrack( 'event93' );
			utilities.addVarsToLinkTrack( 'channel,prop1,prop2,prop30,prop33,eVar8' );
		}
	},
	'button_submission*make_this_my_store': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'make this my store',
		'setMetrics': function ( ddo ) {

			_aape.metrics.events = utilities.apl( 'event20' );

			// _aape.metrics.localizationMethod set in universal
			_aape.metrics.prop9 = _aape.metrics.localizationMethod;

			_aape.metrics.prop41 = ( ddo.user.localization.gpsPermission ? ddo.user.localization.gpsPermission : '' );

			// _aape.metrics.localizationMethod set in universal
			_aape.metrics.eVar14 = _aape.metrics.localizationMethod;

			utilities.addEventsToLinkTrack( 'event20' );
			utilities.addVarsToLinkTrack( 'prop9,prop41,eVar14' );

		}
	},
	'button_submission*bopis_cancellation_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'successful bopis cancellation',
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = utilities.apl( 'event97' );

			_aape.metrics.prop30 = ddo.page.pageInfo.pageType;
			_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;

			utilities.addEventsToLinkTrack( 'event97' );
			utilities.addVarsToLinkTrack( 'prop30,eVar8' );
		}
	},
	'button_submission*cancel_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cancel success",
		'setMetrics': function ( ddo, eventIndex ) {
			let postOrderInfo = ddo.event[ eventIndex ].postOrder ? ddo.event[ eventIndex ].postOrder : {};
			let postOrderInfoItem = ( Array.isArray( postOrderInfo.item ) && postOrderInfo.item.length ? postOrderInfo.item : [] );
					
			_aape.metrics.products = productString.run( 'cancelSuccess', postOrderInfoItem );
			_aape.metrics.prop63 = ( postOrderInfo.cancelReason ? postOrderInfo.cancelReason : '' );

			utilities.addVarsToLinkTrack( 'products,prop63' );
		}
	},
	'button_submission*start_a_return': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "start a return",
		'setMetrics': function (ddo, eventIndex) {
			_aape.metrics.eVar213 = ( ddo.event[ eventIndex ].exchange ? ddo.event[ eventIndex ].exchange : '' );
			_aape.metrics.events = utilities.apl( 'event36' );			

			utilities.addEventsToLinkTrack( 'event36' );
			utilities.addVarsToLinkTrack( 'eVar213' );			
		}
	},
	'button_submission*confirm_return': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "confirm return",
		'setMetrics': function (ddo, eventIndex) {

			mapMethods.setConfirmReturn( ddo.event[ eventIndex ].postOrderReturn ? ddo.event[ eventIndex ].postOrderReturn : {} );

		}
	},
	'button_submission*delete_list': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'delete list',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event103' );
			utilities.addEventsToLinkTrack( 'event103' );
		}
	},
	'button_submission*list_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "add to list",
		'setMetrics': function ( ddo, eventIndex ) {

			var evtObj = ddo.event[ eventIndex ];

			_aape.metrics.eVar118 = ( evtObj.bulkAction ?? "" );

			_aape.metrics.eVar135 = ( evtObj.content && evtObj.content.collection && typeof ( evtObj.content.collection.collectionID ) !== 'undefined' ? evtObj.content.collection.collectionID : '' );
			
			_aape.metrics.products = productString.run( 'myListCreate', evtObj.item );

	
			utilities.addVarsToLinkTrack( 'products,eVar118,eVar135' );

		}
	},	
	'button_submission*new_address_created': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "new address created",
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.eVar85 = mapMethods.setEvar85( ddo.event[ eventIndex ].addressBook );

			utilities.addVarsToLinkTrack( 'eVar85' );

		}
	},
	'button_submission*address_edited': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "address edited",
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.eVar85 = mapMethods.setEvar85( ddo.event[ eventIndex ].addressBook );

			utilities.addVarsToLinkTrack( 'eVar85' );
		}
	},
	'button_submission*address_deleted': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "address deleted",
		'setMetrics': function () {}
	},
	'button_submission*my_account_settings': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "my account settings",
		'setMetrics': function ( ddo, eventIndex ) {

			var evtObj = ddo.event[ eventIndex ],
				myacct = ( evtObj && evtObj.myAccount ? evtObj.myAccount : {} ),
				returns = ( evtObj && evtObj.return ? evtObj.return : {} );

			_aape.metrics.prop63 = ( myacct.settings ? myacct.settings : "" );

			_aape.metrics.eVar87 = ( myacct.giftCardCount ? myacct.giftCardCount : "" );

			_aape.metrics.eVar91 = ( myacct.searchBy && myacct.searchTerm ? myacct.searchBy + ">" + myacct.searchTerm : "" );

			_aape.metrics.eVar213 = ( evtObj.exchange ? evtObj.exchange : "" );

			_aape.metrics.eVar214 = ( evtObj.fulfillmentType ? evtObj.fulfillmentType : "" );

			if ( myacct.biometricEnablement === "completed" ) {
				
				_aape.metrics.events = utilities.apl( "event24" );	
							
			} 

			if ( Array.isArray( returns.item ) && returns.item.length ) {

				_aape.metrics.products = productString.run( "selfServiceReturn", returns.item );

			}

			utilities.addEventsToLinkTrack( "event24" );
			utilities.addVarsToLinkTrack( "products,prop63,eVar87,eVar91,eVar213,eVar214" );
		}
	},
	'button_submission*3ds_failure': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "3ds failure",
		'setMetrics': function ( ddo, eventIndex ) {

			var evtObj = ddo.event[ eventIndex ];

			_aape.metrics.eVar100 = ( evtObj.overlayType ? evtObj.overlayType : '' );

			utilities.addVarsToLinkTrack( 'eVar100' );
		}
	},
	'button_submission*request_a_quote': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "request a quote",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.eVar24 = ( ddo.event[ eventIndex ].form && ddo.event[ eventIndex ].form.formName ? ddo.event[ eventIndex ].form.formName : '' );
			_aape.metrics.events = utilities.apl( 'event74' );

			utilities.addEventsToLinkTrack( 'event74' );
			utilities.addVarsToLinkTrack( 'eVar24' );
		}
	},
	'button_submission*quote_refresh': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "quote refresh",
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ddo.event[ eventIndex ],
				myacct = ( evtObj && evtObj.myAccount ? evtObj.myAccount : {} );
				

			_aape.metrics.prop63 = ( myacct.settings ? myacct.settings : '' );
			_aape.metrics.eVar190 = ( evtObj.quoteId ? evtObj.quoteId : '' );
			_aape.metrics.eVar191 = ( evtObj.quoteType ? evtObj.quoteType : '' );

			_aape.metrics.events = utilities.apl( 'event320' );

			utilities.addEventsToLinkTrack( 'event320' );
			utilities.addVarsToLinkTrack( 'prop63,eVar190,eVar191' );
			
		}
	},
	'button_submission*quote_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "quote add",
		'setMetrics': function ( ddo, eventIndex ) {
			
			mapMethods.setQuoteAdd(ddo, eventIndex);

		}
	},
	'button_submission*new_quote_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "new quote add",
		'setMetrics': function ( ddo, eventIndex ) {			
			mapMethods.setQuoteAdd(ddo, eventIndex, "event48,event149" );
		}
	},
	'quote_view_modification*quote_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "quote view modification quote add",
		'setMetrics': function ( ddo, eventIndex ) {			
			mapMethods.setQuoteAdd(ddo, eventIndex);
		}
	},
	'quote_view_modification*quote_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "quote view modification quote remove",
		'setMetrics': function ( ddo, eventIndex ) {			

			let evtObj = ddo.event[ eventIndex ];
			
			_aape.metrics.events = utilities.apl( "event154" );

			_aape.metrics.products = productString.run( "quoteRemove", evtObj.item, { "quoteid": evtObj.quoteId, "quotetype":  evtObj.quoteType } );

			utilities.addEventsToLinkTrack( "event154" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*check_fulfillment_availability': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'check fulfillment availability',
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( 'event31' );

			if ( Array.isArray( ddo.event[ eventIndex ].item ) && ddo.event[ eventIndex ].item.length ) {

				var eventObj = ddo.event[ eventIndex ].item[ 0 ],
					applStock = ( ( eventObj.productInfo && eventObj.productInfo.availabilityStatus ) ? eventObj.productInfo.availabilityStatus : '' );

				if ( typeof ( applStock.inStockAppl ) !== 'undefined' ) {

					if ( applStock.inStockAppl.toString() === "false" ) {

						_aape.metrics.events = utilities.apl( 'event197' );
						utilities.addEventsToLinkTrack( "event197" );

					}
				}

			}

			_aape.metrics.products = productString.run( "checkFulfillment", ddo.event[ eventIndex ].item, { "pageType": ddo.page.pageInfo.pageType } );

			utilities.addEventsToLinkTrack( "event31" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'button_submission*ps_overlay_attributes': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "ps overlay attributes",
		'setMetrics': function ( ddo, eventIndex ) {

			let eventObj = ddo.event[ eventIndex ],
				attributeArray = ( eventObj.attributes ? eventObj.attributes : [] ),
				tempArray = [];

			// legacy support; current prod implementation uses a single object.....so we convert it to an object array for compatibility with the new (upcoming) implementation
			if ( !Array.isArray(attributeArray) ) {		
				tempArray.push( attributeArray );
				attributeArray = tempArray;		
			}

			_aape.metrics.events = utilities.apl( 'event126' );

			_aape.metrics.products = productString.run( "psOverlay", attributeArray );

			utilities.addEventsToLinkTrack( "event126" );
			utilities.addVarsToLinkTrack( 'products' );

		}
	},
	'button_submission*oos_notification': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "oos notification",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event59' );
			utilities.addEventsToLinkTrack( 'event59' );
		}
	},
	'content_view*engage_coupon_delivered': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "engage coupon delivered",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event272' );
			utilities.addEventsToLinkTrack( 'event272' );
		}
	},
	'expansion*my_account>online_orders': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "my account>online orders",
		'setMetrics': function ( ddo, eventIndex ) {

			var evtObj = ddo.event[ eventIndex ];
			_aape.metrics.prop63 = ( evtObj && evtObj.myAccount && evtObj.myAccount.settings ? evtObj.myAccount.settings : "" );

			utilities.addVarsToLinkTrack( 'prop63' );
		}
	},
	'expansion*track_your_order>online_orders': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "track your order>online orders",
		'setMetrics': function ( ddo, eventIndex ) {

			var evtObj = ddo.event[ eventIndex ];
			_aape.metrics.prop63 = ( evtObj && evtObj.myAccount && evtObj.myAccount.settings ? evtObj.myAccount.settings : "" );

			utilities.addVarsToLinkTrack( 'prop63' );
		}
	},
	'interaction*pip_sub-content': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "sub-content interaction",
		'setMetrics': function ( ddo, eventIndex ) {
			
			_aape.metrics.events = utilities.apl( 'event3' );

				//PIP Review Summary Impression
			if ( ddo.event[ eventIndex ] && typeof( ddo.event[ eventIndex ].reviewSummaryDisplayed ) !== 'undefined' ) {

				_aape.metrics.events = utilities.apl( "event307" );

			}
			
			_aape.metrics.products = productString.run( 'skuOnly', ddo.product );

			_aape.metrics.eVar38 = ( function ( ddo, eventIndex ) {
				var subContent = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].subContent ? ddo.event[ eventIndex ].subContent : "" ),
					result = "";

				if ( subContent ) { //<SECTION>|<COMPONENT>|<TARGET>(:POSITION)(:GUID)
					result = subContent.section + "|" + subContent.component + "|" + subContent.target + ( subContent.position && subContent.position !== 'n/a' ? ":" + subContent.position : "" ) + ( subContent.guid && subContent.guid !== 'n/a' ? ":" + subContent.guid : "" );
				}

				return result;
			}( ddo, eventIndex ) );

			utilities.addEventsToLinkTrack( 'event3,event307' );
			utilities.addVarsToLinkTrack( 'eVar38,products' );
		}
	},
	'interaction*product_options': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "product options interaction",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event119' );
			
			_aape.metrics.products = productString.run( 'productImpression', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( 'event119' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'interaction*create_list': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "new list created",
		'setMetrics': function ( ddo, eventIndex ) {

			var items = digitalDataFormatters.getEventItemForProdString( ddo, eventIndex );
			var evtObj = ddo.event[ eventIndex ];

			_aape.metrics.events = utilities.apl( 'event321' );
			_aape.metrics.eVar118 = ( evtObj.bulkAction ?? "" );
			_aape.metrics.prop63 = ( evtObj && evtObj.myAccount && evtObj.myAccount.settings ? evtObj.myAccount.settings : "" );

			// set the following when list is created with a product
			if ( items ) {
					
				_aape.metrics.products = productString.run( 'myListCreate', items );
				
			}
			
			utilities.addEventsToLinkTrack( 'event321' );
			utilities.addVarsToLinkTrack( 'products,eVar118,prop63' );
		}
	},
	'interaction*email_list': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "email list",
		'setMetrics': function () {
			_aape.metrics.prop66 = "email list";
			utilities.addVarsToLinkTrack( 'prop66' );
		}
	},
	'interaction*print_list': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "print list",
		'setMetrics': function () {
			_aape.metrics.prop66 = "print list";
			utilities.addVarsToLinkTrack( 'prop66' );
		}
	},
	'interaction*export_list': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "export list",
		'setMetrics': function () {
			_aape.metrics.prop66 = "export list";
			utilities.addVarsToLinkTrack( 'prop66' );
		}
	},
	'interaction*ssku_pod_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "ssku pod click",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "event247" );

			let sku = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].sskuPodSku ? ddo.event[ eventIndex ].sskuPodSku : '' );

			_aape.metrics.products = productString.run( 'skuOnly', [ {"productInfo": {"sku": sku }} ] );
			
			utilities.addEventsToLinkTrack( "event247" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'interaction*compare_color_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "compare color click",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event264" );
			utilities.addEventsToLinkTrack( 'event264' );
		}
	},
	'interaction*content_media_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': true,
		'trackLinkName': "content media click",
		'setMetrics': function ( ddo, eventIndex ) {

			let content = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} ),
				_setSponsoredID = ( sponsoredID ) => {

					if ( typeof ( sponsoredID ) === 'undefined' ) { return 'ddo missing'; }
					
					if ( sponsoredID === null || sponsoredID.toString().toLowerCase() == "null" ) { return "ddo null"; } 
										
					return ( sponsoredID === "" ? 'ddo empty' : sponsoredID.toString() );					
					
				};

			_aape.metrics.events = utilities.apl( "event209" );

			_aape.metrics.prop19 = _setSponsoredID( content.sponsoredID );
			_aape.metrics.eVar50 = _aape.metrics.prop19;

			_aape.metrics.eVar178 = ( content.creativeID ? content.creativeID : '' );

			_aape.metrics.eVar180 = 'auc-' + ( content.campaignID ? content.campaignID + '-' : '' ) + ( content.placementID ? content.placementID + '-' : '' ) + ( content.slotID ? content.slotID : '' );
			
			let _metrics = { "eVar180": _aape.metrics.eVar180, "eVar178": _aape.metrics.eVar178, "eVar50": _aape.metrics.eVar50, "prop19": _aape.metrics.prop19 };

			appData.addUpdateCache( "sponsoredMetrics", JSON.stringify( _metrics ) );

			utilities.addEventsToLinkTrack( 'event209' );
			utilities.addVarsToLinkTrack( 'prop19,eVar50,eVar178,eVar180' );
		}
	},
	'interaction*instant_rec_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'trackLinkName': "instant rec click",
		'setMetrics': function ( ddo, eventIndex ) {

			let eventObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );
			let newRec = ( eventObj.recommendation && utilities.objHasValue( eventObj.recommendation ) ? eventObj.recommendation : {} );
			
			//exit if we dont have all the data
			if ( typeof newRec.sku === "undefined" || typeof newRec.status === "undefined" ) { return; }

			//get any previously stored data
			let instantRecs =  appData.getFromCache( "_InstantRecs" ) || {};

			// capture new entry, ensure only 1 entry per sku by using sku as key
			instantRecs[newRec.sku] = newRec.status;

			// update instant rec data captured thus far
			appData.addUpdateCache( "_InstantRecs", instantRecs );

			//send final formatted data to Batcher
			_aape.PUB_SUB.publish( "thdcoreanalytics|batch", [{				
				"key": 'eVar106',
				"value": Object.keys( instantRecs ).map( key => `${key}:${instantRecs[key]}` ).join( "|" )
			}]);
		}
	},	
	'interaction*discovery_zone_pip_load': {
		'forcePageView': false,
		'reportingType': "non-reporting",
		'runUniversal': true,
		'trackLinkName': "discovery zone pip load",
		'setMetrics': function ( ddo, eventIndex ) {
			let _PAGEINFO = ( typeof ( ddo !== 'undefined' ) && ddo && ddo.page && ddo.page.pageInfo ? ddo.page.pageInfo : {} ), 			
			_pageType = ( _PAGEINFO.pageType ? _PAGEINFO.pageType : "" );

			
			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} ),
				zone = ( evtObj.discoveryZone ? evtObj.discoveryZone : {} ),
				itemArray = [ {
					"productInfo": {
						"sku": ( zone.anchorSku ? zone.anchorSku : "" )
					}
				} ];

			//add pageType to zone object from parent page DDO	
			zone.pageType = _pageType;
			
			_aape.metrics.products = productString.run( 'discoveryZone', itemArray, { "zone": zone } );
			
			utilities.addVarsToLinkTrack( 'products,eVar109' );			
		}
	},
	'magic_apron*maa_fab_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "maa fab click",
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( "event72" );

			_aape.metrics.eVar207 = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].maSessionID ? ddo.event[ eventIndex ].maSessionID : '' );
			
			utilities.addEventsToLinkTrack( "event72" );
			utilities.addVarsToLinkTrack( 'eVar207' );
			
		}
	},
	'magic_apron*maa_question_submit': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "maa question submit",
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( Array.isArray( ddo.event ) && ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );
			
			_aape.metrics.events = utilities.apl( "event84" );

			_aape.metrics.eVar207 = ( evtObj.maSessionID ?? '' );
			_aape.metrics.eVar80 = ( evtObj.question ?? '' );
			
			utilities.addEventsToLinkTrack( "event84" );
			utilities.addVarsToLinkTrack( 'eVar207,eVar80' );

		}
	},
	'magic_apron*maa_qna_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "maa qna click",
		'setMetrics': function (ddo, eventIndex) {
			
			let evtObj = ( Array.isArray( ddo.event ) && ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );

			_aape.metrics.events = utilities.apl("event85");			

			_aape.metrics.eVar207 = ( evtObj.maSessionID ?? '' );
			_aape.metrics.eVar88 = ( evtObj.question ?? '' );

			
			utilities.addEventsToLinkTrack( "event85" );
			utilities.addVarsToLinkTrack( 'eVar207,eVar88' );

		}
	},
	'cart_view_modification*cart_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart update",
		'setMetrics': function ( ddo, eventIndex ) {
			var evtObj = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ] ? ddo.event[ eventIndex ].item[ 0 ] : '' );

			_aape.metrics.events = utilities.apl( "scAdd,event98" );

			if ( evtObj && evtObj.subscription && evtObj.subscription.frequency ) {

				_aape.metrics.events = utilities.apl( "event82" );

			}

			//Pro Large Cart new metrics
			_aape.metrics.eVar215 = ( ddo.cart.quantityTotal ? ddo.cart.quantityTotal : "" );
			_aape.metrics.eVar216 = ( ddo.cart.uniqueSkuCount ? ddo.cart.uniqueSkuCount : "" );
			_aape.metrics.eVar217 = ( ddo.cart.price && ddo.cart.price.cartTotal ? ddo.cart.price.cartTotal : "" );
			


			_aape.metrics.products = productString.run( 'cartAdd', ddo.event[ eventIndex ].item, {
				"atcloc": stash.getEventData( "cart add location" ),
				"pageType": ddo.page.pageInfo.pageType
			});

			//clear stash after setting atc location
			stash.deleteEventData( "cart add location" );

			utilities.addEventsToLinkTrack( "scAdd,event82,event98,event157" );
			utilities.addVarsToLinkTrack( "products,eVar115,eVar215,eVar216,eVar217" );
		}
	},
	'cart_view_modification*cart_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart remove",
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartRemove(ddo, eventIndex);

		}
	},
	'cart_view_modification*gift_card_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "gift card remove",
		'setMetrics': function ( ddo, eventIndex ) {
			
			let evtObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : { "item": [] } );

			_aape.metrics.eVar23 = ( evtObj.removeLocation ?? "" );
			
			_aape.metrics.eVar118 = ( evtObj.bulkAction ?? "" );

			_aape.metrics.events = utilities.apl( "scRemove" );
		
			_aape.metrics.products = productString.run( 'giftCardRemove', evtObj.item, {
				"v23": _aape.metrics.eVar23
			} );
			
			utilities.addEventsToLinkTrack( "scRemove" );
			utilities.addVarsToLinkTrack( 'products,eVar23,eVar118' );
		}
	},
	'cart_view_modification*cart_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart fulfillment change",
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFulfillmentChange( ddo, eventIndex );
		}
	},
	'cart_view_modification*bulk_cart_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "bulk cart fulfillment change",
		'setMetrics': function ( ddo, eventIndex ) {
			
			mapMethods.setFulfillmentChange( ddo, eventIndex );	

			_aape.metrics.events = utilities.apl( "event104" );

			utilities.addEventsToLinkTrack( "event104" );
		}
	},
	'cart_view_modification*save_for_later': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "save for later",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "event137" );
			
			_aape.metrics.eVar118 = ( ddo.event[ eventIndex ].bulkAction ?? "" );

			_aape.metrics.products = productString.run( "saveForLater", ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( "event137" );
			utilities.addVarsToLinkTrack( 'products,eVar118' );
		}
	},
	'cart_view_modification*cart_re-add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart re-add",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "event140" );
			
			_aape.metrics.products = productString.run( 'cartReAdd', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( "event140" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'cart_view_modification*optimal_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "optimal fulfillment change",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "event265" );
			
			_aape.metrics.products = productString.run( 'optimalFulfillmentChange', ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( "event265" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'list_view_modification*list_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "list add",
		'setMetrics': function ( ddo, eventIndex ) {
						
			_aape.metrics.products = productString.run( 'myListAddRemove', ddo.event[ eventIndex ].item, { "type": "add" } );
			
			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'list_view_modification*list_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "list remove",
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ddo.event[ eventIndex ];

			_aape.metrics.eVar135 = ( evtObj.content && evtObj.content.collection && typeof ( evtObj.content.collection.collectionID ) !== 'undefined' ? evtObj.content.collection.collectionID : '' );

			_aape.metrics.products = productString.run( 'myListAddRemove', evtObj.item, { "type": "remove" } );
					
			utilities.addVarsToLinkTrack( 'products,eVar135' );
		}
	},
	'opc_view_modification*opc_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "opc fulfillment change",
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFulfillmentChange( ddo, eventIndex );
		}
	},
	'opc_view_modification*opc_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart remove",
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartRemove(ddo, eventIndex);
			
		}
	},
	'checkout_view_modification*checkout_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "checkout fulfillment change",
		'setMetrics': function ( ddo, eventIndex ) {
			let evtObj = ddo.event[ eventIndex ];

			_aape.metrics.events = utilities.apl( "event134" );

			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ">opc";
			
			_aape.metrics.products = productString.run( "cartView", evtObj.item );

			utilities.addEventsToLinkTrack( "event134" );
			utilities.addVarsToLinkTrack( 'eVar62,products' );
		}
	},
	'overlay': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.referrer = "";

			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop15 = ddo.page.pageInfo.pageName;
			_aape.metrics.prop17 = ddo.page.pageInfo.pageType;
			_aape.metrics.prop30 = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			
			if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {
				_aape.metrics.prop33 = ( ddo.event[ eventIndex ].eventInfo.abTest ? ddo.event[ eventIndex ].eventInfo.abTest : _aape.metrics.prop33 ? _aape.metrics.prop33 : '' );
			}
			_aape.metrics.prop35 = ddo.page.pageInfo.pageName;

			_aape.metrics.eVar8 = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.eVar96 = _aape.metrics.prop15 ? _aape.metrics.prop15 : '';
			_aape.metrics.eVar97 = ddo.page.pageInfo.pageType;
			
			// prevent ITC/Sponsored Click related values from firing on Overlays	
			mapMethods.clearSponsoredMetrics();
			
		}
	},
	'overlay*bss': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			try {

				let podClickObj = mapMethods.getPodClick();

				_aape.metrics.products = productString.run( "bssOverlay",  ddo.event[ eventIndex ].item, { "pageType": ddo.page.pageInfo.pageType, "podClick": podClickObj } );

				_aape.metrics.events = utilities.apl( "event31" );

				_aape.metrics.eVar63 = appData.getFromCache( "pageLoadeVar63" );

				_aape.metrics.eVar101 = mapMethods.setEVar101( podClickObj );

			}
			catch ( e ) {}
		}
	},
	'overlay*instant_rebate_details': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.prop2 = ddo.page.category.subCategory2 + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			
			_aape.metrics.products = productString.run( "productView",  ddo.product );

		}
	},
	'overlay*instant_rebate_checkout': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.prop2 = ddo.page.category.subCategory2 + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;

		}
	},
	'overlay*pro_xtra_account_created': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event7" );
		}
	},
	'overlay*compare_color': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			var evtObj = ddo.event[ eventIndex ];
			_aape.metrics.eVar158 = ( evtObj && evtObj.colorExplore && Array.isArray( evtObj.colorExplore.color ) && evtObj.colorExplore.color.length ? "imp|" + evtObj.colorExplore.color.join( "|" ) : "" );

		}
	},
	/************************************************************************************************************************************************************
	 * The following triggers use default overlay tracking, they are listed here for documentation purposes:                                                    *
	 * **********************************************************************************************************************************************************
	   MAML:
	     -> overlay*list_settings
	     -> overlay*create_a_list
	     -> overlay*save_to_your_list
	     -> overlay*email_list
	     -> overlay*sign_in_prompt
	*************************************************************************************************************************************************************/
	'check_zip*shipping_options': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'DETA Check Zip Code',
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.events = utilities.apl( 'event31' );

			_aape.metrics.eVar7 = ddo.page.pageInfo.pageType + ":" + ( ddo.event[ eventIndex ].item && ddo.event[ eventIndex ].item[ 0 ].fulfillmentMethod ? ddo.event[ eventIndex ].item[ 0 ].fulfillmentMethod : "" );

			utilities.addEventsToLinkTrack( 'event31' );
			utilities.addVarsToLinkTrack( 'eVar7' );
		}
	},	
	'search*filter_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change filter values',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFilterBy( ddo, eventIndex );
		}
	},
	'search*pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPagination( ddo, eventIndex );
		}
	},
	'browse*pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPagination( ddo, eventIndex );
		}
	},
	'plp_module*pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setPagination( ddo, eventIndex );

			_aape.metrics.events = utilities.apl( 'event253' );

			_aape.metrics.eVar143 = ( function ( evtObj ) {

				evtObj = ( typeof ( evtObj ) !== 'undefined' ? evtObj : {} );

				var displayAttributes = ( evtObj.category && evtObj.category.displayAttributes ? evtObj.category.displayAttributes : {} ),
					filter = ( Array.isArray( evtObj.filter ) ? evtObj.filter : [] ),
					index = 0,
					result = "";

				for ( index = 0; index < filter.length; index++ ) {

					result += ( filter[ index ].selectionMethod ? filter[ index ].selectionMethod : "n/a" ) + ">";
					result += ( filter[ index ].type ? filter[ index ].type : "n/a" ) + ">";
					result += ( filter[ index ].value ? filter[ index ].value : "n/a" ) + ">";
					result += ( filter[ index ].position ? filter[ index ].position : "n/a" ) + ">";
					result += ( displayAttributes.pageNumber ? displayAttributes.pageNumber : "n/a" ) + ">";
					result += ( displayAttributes.sortBy ? displayAttributes.sortBy : "n/a" ) + ">";
					result += ( displayAttributes.viewType ? displayAttributes.viewType : "n/a" );

				}

				return result;

			}( ddo.event[ eventIndex ] ) );

		}
	},
	'browse*filter_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change filter values',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFilterBy( ddo, eventIndex );
		}
	},
	'search*sort_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setSortBy( ddo, eventIndex );
		}
	},
	'browse*sort_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setSortBy( ddo, eventIndex );
		}
	},
	'search*view_type_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {			
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},
	'browse*view_type_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {			
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},
	'search*product_availability_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {			
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},
	'browse*product_availability_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {			
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},
	'content_display*product_impression': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'product impression tracking',
		'setMetrics': function ( ddo ) {
			_aape.metrics.events = 'event119';

			_aape.metrics.prop30 = ddo.page && ddo.page.pageInfo && ddo.page.pageInfo.pageType ? ddo.page.pageInfo.pageType : '';
			
			let collectionID = ( ddo.content && ddo.content.collection && ddo.content.collection.collectionID ? ddo.content.collection.collectionID : '' ),
				_isSearch = ( window.location.pathname.indexOf( "/s/" ) !== -1 ),	
				headerCrumb = ( _isSearch ? "non-browse" : ddo.page.category.headerCrumb ? ddo.page.category.headerCrumb : "" ),
				widgetArray = ( ddo.content && Array.isArray( ddo.content.widget ) ? ddo.content.widget : [] ),
				recData = (function () {
					let merch = remoteUtils.getQueryParam('MERCH', document.URL),
						prevPageType = storage.getItem( "s_pv_pType");

					if ( merch && merch.toLowerCase().indexOf("rec-_-") === 0 && prevPageType.toLowerCase().indexOf('overlay') === -1 ) {

						_aape.metrics.prop37 = "merchQueryParam";

						return mapMethods.recObjFromMerchQueryParam(merch, prevPageType);
					}

					return {};

				}());

			if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.plpModule ) === 'string' && ddo.content.feature.plpModule.toLowerCase() === 'y' ) {
				_aape.metrics.events = utilities.apl( 'event254' );
			}

			_aape.metrics.products = productString.run( "productImpression", ddo.content.product, {
				"collectionID": collectionID,
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ 0 ], ddo.page ),
				"pageType": ddo.page.pageInfo.pageType,
				"recobj": recData,
				"widget": widgetArray
			} );
				
			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page, '' );
				
			_aape.metrics.eVar28 = headerCrumb;

			_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );

			utilities.addEventsToLinkTrack( "event14,event119,event124,event254" );
			utilities.addVarsToLinkTrack( 'products,eVar21,eVar28,eVar132,eVar160,prop30,prop37' );
		}
	},
	'content_display*piq_impression': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,		
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.PUB_SUB.publish( "thdcoreanalytics|piq_impression", {
				"trigger": "content_display*piq_impression",
				"eventData": ddo.event[ eventIndex ],
				"pageInfo": ddo.page.pageInfo
			});

		}
	},
	'batch*target_data': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function (ddo, eventIndex) {

			let eventObj = ( ddo.event[eventIndex] ? ddo.event[eventIndex] : {} ),
				cacheKey = "_targetEventData",
				targetData = ( Array.isArray( eventObj.data ) ? eventObj.data : [] ),				
				v199 = "";


			// Remove eVar199 from pagehide batch queue if no target event data are present and exit
			if ( !targetData.length ) {

				_T.PUB_SUB.publish("thdcoreanalytics|batch_remove", ["eVar199"]);
				
				appData.addUpdateCache( cacheKey, "" ); // clear cache

				return;
			}
						
			v199 = targetData.join( "|" );

			// update target event data captured thus far (overwrited any stored value, since we capture ALL pending target data each time this trigger is called)
			appData.addUpdateCache( cacheKey, v199 );
			
			//send final formatted data to Batcher
			_T.PUB_SUB.publish("thdcoreanalytics|batch", [{
				"key": 'eVar199',
				"value": v199
			}]);

		}
	},
	'batch*target_custom_decision_scope': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function (ddo, eventIndex) {

			let eventObj = (ddo.event[eventIndex] ? ddo.event[eventIndex] : {}),
				hasCustomPropositions = eventObj.propositionCount > 0;

			// Remove event255 from pagehide batch queue if no custom propositions are present and exit
			if (!hasCustomPropositions) {

				_T.PUB_SUB.publish("thdcoreanalytics|batch_remove", ["event255"]);

				return;
			}

			//send data to Batcher
			_T.PUB_SUB.publish("thdcoreanalytics|batch", [{
				"key": 'event255',
				"value": "event255"
			}]);

		}
	},
	'batch*target_rec_impression': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function (ddo, eventIndex) {

			let eventObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} ),
				recsTntInfo = ( eventObj.recsTntInfo && utilities.objHasValue( eventObj.recsTntInfo ) ? eventObj.recsTntInfo : {} ),
				newItem = "";
						
			//get any previously stored data
			let tntRecs =  appData.getFromCache( "_tntRecs" ) || "";
			
			newItem = `${recsTntInfo.testApi ?? 'na'}:${recsTntInfo.fallback ?? 'na'}:${recsTntInfo.error ?? 'na'}:${recsTntInfo.productsCnt ?? 'na'}`
				
			// append or create
			tntRecs = (tntRecs ? `${tntRecs},${newItem}`: newItem);

			// update target rec data captured thus far
			appData.addUpdateCache( "_tntRecs", tntRecs );
			
			//send final formatted data to Batcher
			_T.PUB_SUB.publish("thdcoreanalytics|batch", [{
				"key": 'eVar186',
				"value": tntRecs
			}]);

		}
	},
	'batch*viewport_impression': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function (ddo, eventIndex) {

			// Exit early if impressions disabled
			if ( !config.featureEnabled('impressionProvider') ) { return; }

			const _appExperience = ( typeof ( ddo ) !== 'undefined' && Array.isArray( ddo.appExperience ) && ddo.appExperience.length ? ddo.appExperience[ 0 ] : {} ),
				_PATH = window.location.pathname,
				_PAGEINFO = ( typeof ( ddo !== 'undefined' ) && ddo && ddo.page && ddo.page.pageInfo ? ddo.page.pageInfo : {} ), 
				_GLOBAL_META_DATA = ( window.globalMetadata ?? {} ),
				_isHomepage = _PATH === ( "/" ),				
				_isBrowsePLP = ( _PATH.indexOf( "/b/" ) !== -1 ),
				_isCart = ( _PATH.indexOf( "/cart" ) !== -1 || _GLOBAL_META_DATA?.experience?.name === "my-cart" ),
				_isCheckout = ( _PATH.indexOf( "/checkout" ) !== -1 || _GLOBAL_META_DATA?.experience?.name === "checkout"),	
				_isSearchPLP = ( _PATH.indexOf( "/s/" ) !== -1 ),
				_isPIP = remoteUtils.isPIP(),				
				_isAudiencePage = ( _PATH.indexOf( "/a/" ) !== -1 ),
				_isCategoryLandingPage = ( typeof ( _appExperience.name ) === "string" && _appExperience.name.toLowerCase() === "landing-page" ? true : false ),
				_isCreditCenterPage = ( _PATH.indexOf( "/c/credit-center" ) !== -1 ),
				_isGiftCardPage = ( _PATH.indexOf( "/c/gift-cards" ) !== -1 ),				
				_isSpecialityContent = ["/c/SamsungBespoke","/c/DonateYourHarvest","/c/behrpro","/c/SF_TH_PR_RIDGID_Power_Tools_Warranty"].includes( _PATH ),				
				_pageType = ( _PAGEINFO.pageType ? _PAGEINFO.pageType : "" ),
				_isHybridPLPPage = ( _pageType.toLowerCase() === "cat plp" && typeof( _PAGEINFO.pageID ) !== 'undefined'),
				_formatType = ( type ) => {
					const TYPES = { "content": "cont", "product": "prod", "sponsoredproduct": "spprod", "sponsoredcontent": "spcont" };
					let result = (typeof (type) === 'string' ? TYPES[type.toLowerCase()] : '');
					return (result ? result : 'na');
				},
				_formatSectionSlot = ( section ) => {
					const regex = /slot/gi;
					return typeof ( section ) === 'string' ? section.replaceAll( regex, '' ) : 'na';
				},
				_isSponsoredModule = ( itype ) => {					
					return ['spprod', 'spcont'].includes( itype );
				},
				_impressionProviderEnabled = (_cont, _impr) => {
					let allowedByPage = _isHomepage || _isAudiencePage || _isCategoryLandingPage || _isCreditCenterPage || _isGiftCardPage ||  _isSpecialityContent || _isHybridPLPPage,
						sponsoredModule = _isSponsoredModule( _formatType( _impr.type ) ),
						atcDrawerRec = 'verticalrecs' === _cont.component.toLowerCase(), 						
						allowedOnBrowsePLP = _isBrowsePLP && (['categorycards','customersultimatelypurchased','recentlyviewed','relatedcategories','relatedproducts','relatedsearch'].includes( _cont.name.toLowerCase() ) || ['discoveryzones','dynamicrecs','recentlyviewed','searchfeedback'].includes( _cont.component.toLowerCase() )),
						allowedOnCart = _isCart && (['dynamicrecs','endcap','recentlyviewed','reorderrecommendations'].includes( _cont.component.toLowerCase() )),
						allowedOnCheckout = _isCheckout && (['consumercardmessaging'].includes( _cont.component.toLowerCase() )),
						allowedOnSearchPLP = _isSearchPLP && (['categorycards'].includes( _cont.name.toLowerCase() ) || ['discoveryzones','dynamicrecs','recentlyviewed','relatedcategories','relatedsearch','searchfeedback','searchviewed'].includes( _cont.component.toLowerCase() )),
						allowedOnPIP = _isPIP && (['drawerrecommendations','relatedsearch','relatedcategories','dynamicrecs','recentlyviewed','thdrecsfbt','featurebasedrecommendations'].includes( _cont.component.toLowerCase() ) || ['customersalsoviewed','recentlyviewed'].includes( _cont.name.toLowerCase() ));

					return  allowedByPage || sponsoredModule || allowedOnPIP || allowedOnBrowsePLP || allowedOnSearchPLP || allowedOnCart || allowedOnCheckout || atcDrawerRec;

				};

			let eventObj = (ddo.event[eventIndex] ? ddo.event[eventIndex] : {}),
				impression = (eventObj.impression && utilities.objHasValue(eventObj.impression) ? eventObj.impression : {}),
				container = (eventObj.container && utilities.objHasValue(eventObj.container) ? eventObj.container : {});

			//Exit if we dont have all the required data
			if ((typeof container.component === "undefined" || !container.component) ||
				(typeof container.name === "undefined" || !container.name) ||
				(typeof impression.component === "undefined" || !impression.component)) { return; }
			
			//Exit early if impressions not enabled for current page
			if ( !_impressionProviderEnabled( container, impression ) ) { return; }

			//get any previously stored data
			let list1 = appData.getFromCache("_Impressions"),				
				impressionType = ( impression.type ? _formatType(impression.type) : 'na' ),
				isSponsored = _isSponsoredModule( impressionType );
			
			// Ensure correct type for sponsored modules
			if ( isSponsored && !impressionType.startsWith('sp')) { 

				impressionType =`sp${impressionType}`; 

			}		
			
			// format impression to append to list var
			/**
			 * impression.type[>container.recType];container.component;container.name[-container.category[>container.categoryPosition]];container.id;impression.name[-impression.category];impression.position;impression.id;container.sectionSlotID;[impression.campaignId;impression.placementId;impression.slotId;impression.sponsoredId;]
			 */
			let _defaultContainerID = container.name ? `DEF_${container.name}` : 'na',
				newItem = `${impressionType}` + `${container.recType ? ">" + container.recType : ''};` +
				`${container.component ? container.component : 'na'};` +
				`${container.name ? container.name : 'na'}` + `${container.category ? "-" + container.category : ''}` + `${container.categoryPosition ? ">" + container.categoryPosition : ''}` + `${ container.zonePosition ? "@" + container.zonePosition : ''};` +
				`${container.id ? container.id : _defaultContainerID };` +
				`${impression.name ? impression.name : 'na'}` + `${impression.category ? "-" + impression.category : ''}` + `${impression.anchorSku ? ">" + impression.anchorSku : ''};` +
				`${impression.position || impression.position == 0 ? impression.position : 'na'};` +
				`${impression.id ? impression.id : 'na'};` +
				`${container.sectionSlotID ? _formatSectionSlot( container.sectionSlotID ): 'na'};`;

			// handle any sponsored module fields							
			if ( isSponsored ) {
			
				newItem = newItem + 
				`${impression.campaignId ? impression.campaignId : 'na'};` +
				`${impression.placementId ? impression.placementId : 'na'};` +
				`${impression.slotId ? impression.slotId : 'na'};` +
				`${impression.sponsoredId ? impression.sponsoredId : 'na'};` +
				`${impression.flightId ? impression.flightId : 'na'};` +
				`${impression.creativeId ? impression.creativeId : 'na'};`

			}

			// append or create
			list1 = (list1 ? `${list1},${newItem}` : newItem);

			// update impression data captured thus far
			appData.addUpdateCache("_Impressions", list1);
			
			//send final formatted data to Batcher
			_aape.PUB_SUB.publish("thdcoreanalytics|batch", [{
				"key": 'list1',
				"value": list1
			},{
				"key": 'prop7',
				"value": ( ddo.page.displayAttributes && typeof ( ddo.page.displayAttributes.pageNumber ) !== 'undefined' ? ddo.page.displayAttributes.pageNumber : "" )
			},{
				"key": 'prop30',
				"value": _pageType
			},{
				"key": 'prop32',
				"value": _PAGEINFO.adBlocker ?? ''
			},{
				"key": 'event226',
				"value": 'event226'
			},{
				"key": 'eVar11',
				"value": appData.getFromCache( "pageLoadeVar5" )
			},{
				"key": 'eVar30',
				"value": ddo.page.pageInfo.pageID ?? ""
			}]);

			// TL TEST STUFF
			if ( config.featureEnabled('tlTest') ) {

				let _tlKey = config.getTLTestConfig().cache_key;

				list1 = appData.getFromCache(_tlKey);

				// append or create
				list1 = (list1 ? `${list1},${newItem}` : newItem);

				// update impression data captured thus far
				appData.addUpdateCache(_tlKey, list1);

			}


		}
	},
	'interaction*category_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'product impression tracking',
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = 'event119';

			_aape.metrics.prop30 = ddo.page && ddo.page.pageInfo && ddo.page.pageInfo.pageType ? ddo.page.pageInfo.pageType : '';

			var collectionID = ( ddo.content && ddo.content.collection && ddo.content.collection.collectionID ? ddo.content.collection.collectionID : '' ),
				widgetArray = ( ddo.content && Array.isArray( ddo.content.widget ) ? ddo.content.widget : [] );

			if ( ddo.content && ddo.content.feature && typeof ( ddo.content.feature.plpModule ) === 'string' && ddo.content.feature.plpModule.toLowerCase() === 'y' ) {
				_aape.metrics.events = utilities.apl( 'event254' );
			}

			_aape.metrics.products = productString.run( "productImpression", ddo.event[ eventIndex ].content.product, {
				"collectionID": collectionID,
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] ),
				"pageType": ddo.page.pageInfo.pageType,
				"widget": widgetArray
			} );

			_aape.metrics.eVar132 = mapMethods.setEvar132( ddo );

			utilities.addEventsToLinkTrack( "event119,event124,event254" );
			utilities.addVarsToLinkTrack( 'products,eVar132,eVar160,prop30' );
		}
	},
	'interaction*perimeterx_defender': {
		'forcePageView': true,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'perimeterx defender',
		'setMetrics': function ( ddo, eventIndex ) {

			let eventData = ddo.event[ eventIndex ].eventData;

			//extension should go here
			_aape.metrics.eVar173 = 'extension';

			_aape.metrics.events = ( eventData && eventData.toString() === 'true' ? 'event266' : 'event267' );

			utilities.addEventsToLinkTrack( 'event266,event267' );
			utilities.addVarsToLinkTrack( 'eVar173' );
		}
	},
	'workshop*form_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'workshop form start',
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event65' );
			_aape.metrics.eVar66 = ( ddo.event[ eventIndex ].form.formType && ddo.event[ eventIndex ].form.formName ? ddo.event[ eventIndex ].form.formType + ": " + ddo.event[ eventIndex ].form.formName : '' );

			utilities.addEventsToLinkTrack( 'event65' );
			utilities.addVarsToLinkTrack( 'eVar66' );
		}
	},
	'workshop*form_complete': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'workshop form complete',
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( 'event66' );
			_aape.metrics.eVar66 = ( ddo.event[ eventIndex ].form.formType && ddo.event[ eventIndex ].form.formName ? ddo.event[ eventIndex ].form.formType + ": " + ddo.event[ eventIndex ].form.formName : '' );

			utilities.addEventsToLinkTrack( 'event66' );
			utilities.addVarsToLinkTrack( 'eVar66' );
		}
	},
	'installation_services_and_repair*form_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'web installation services form start',
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( 'event74' );
			_aape.metrics.eVar24 = ( ddo.event[ eventIndex ].form && ddo.event[ eventIndex ].form.formName ? ddo.event[ eventIndex ].form.formName : '' );

			utilities.addEventsToLinkTrack( 'event74' );
			utilities.addVarsToLinkTrack( 'eVar24' );
		}
	},
	'installation_services_and_repair*form_complete': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'web installation services form complete',
		'setMetrics': function ( ddo, eventIndex ) {

			var formObj = ( ddo.event[ eventIndex ].form ? ddo.event[ eventIndex ].form : {} );

			_aape.metrics.events = utilities.apl( 'event9' );
			_aape.metrics.eVar24 = ( formObj.formName ? formObj.formName : '' );
			_aape.metrics.eVar72 = ( formObj.universalLeadID ? formObj.universalLeadID : formObj.leadID ? formObj.leadID : '' );
			_aape.metrics.eVar73 = ( formObj.zip ? formObj.zip : '' );

			_aape.metrics.transactionID = ( formObj.leadID ? formObj.leadID : '' );

			utilities.addEventsToLinkTrack( 'event9' );
			utilities.addVarsToLinkTrack( 'eVar24,eVar72,eVar73,transactionID' );
		}
	},
	'tooltip': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': function ( ddo, eventIndex ) {
			return ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		},
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.referrer = "";

			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.products = appData.getFromCache( "pageLoadProdString" );

			utilities.addVarsToLinkTrack( 'products' );

		}
	},
	'tooltip*in-store_clearance_message': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'in-store clearance message tooltip',
		'setMetrics': function ( ddo, eventIndex  ) {

			let itemArray = ( ddo.event[ eventIndex ].item && Array.isArray( ddo.event[ eventIndex ].item ) ? ddo.event[ eventIndex ].item : [] );

			if ( itemArray.length ) {
				_aape.metrics.products = productString.run( 'skuOnly', itemArray );
			}

			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'tooltip*shipping_options': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'shipping options tooltip',
		'setMetrics': function ( ddo ) {

			if ( remoteUtils.isPIP() ) {		
				_aape.metrics.products = productString.run( 'skuOnly', ddo.product );
			}

			utilities.addVarsToLinkTrack( 'products' );
		}
	},
	'error*error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error message',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setErrorMessage( ddo, eventIndex );
		}
	},
	'sys_msg*error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error message',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setErrorMessage( ddo, eventIndex );
		}
	},
	'error*post_page_error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error',
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( 'event49' );

			_aape.metrics.list2 = ( function ( ddo, eventIndex ) {

				var list2 = "";

				if ( Array.isArray( ddo.event[ eventIndex ].eventInfo.error ) ) {

					var errors = ddo.event[ eventIndex ].eventInfo.error,
						result = [],
						_left = function ( str, count ) { // main purpose of this method is the safe checking
							str = typeof str !== 'undefined' ? str : '';
							count = typeof count !== 'undefined' ? count : 2;

							return str.substr( 0, count );
						};

					for ( var error in errors ) {

						if ( errors.hasOwnProperty( error ) ) {

							result.push( _left( errors[ error ].type ) + ":" + _left( errors[ error ].displayType ) + ":" + ( errors[ error ].pageSection ? errors[ error ].pageSection : '' ) + ":" + ( errors[ error ].message ? errors[ error ].message : '' ) + ":" + ( errors[ error ].code ? errors[ error ].code : '' ) );

						}
					}

					list2 = result.join( "|" );
				}

				return list2;

			}( ddo, eventIndex ) );

			// prevent ITC/Sponsored Click related values from firing
			mapMethods.clearSponsoredMetrics();

			utilities.addEventsToLinkTrack( 'event49' );
			utilities.addVarsToLinkTrack( 'list2,events,products' );
		}
	},	
	'stash*cart_add_location': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash );

			// will be picked up by cart add event handler
			stash.addToEventData( eventObj.eventInfo.eventName, data );
		}
	},
	'stash*opc_order_attributes': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash ? eventObj.stash : {} );

			// will be picked up by purchase event handler
			stash.addToWillPersist("opc_order_attributes", stashData );

			
			//3DS overlay support - will be picked up by purchase event handler
			if ( stashData.overlayType ) {

				stash.addToWillPersist( "3ds-overlay", stashData.overlayType );

			}
		}
	},
	'stash*type_ahead': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash;

			// will be picked up by search page event handler
			stash.addToWillPersist( "searchMedium", stashData.searchMedium ); // searchMedium is to be used at a future date, but could be utilized to determine evar 12
			stash.addToWillPersist( "searchTerm", stashData.searchTerm );
			stash.addToWillPersist( "searchTermOrigin", stashData.searchTermOrigin );
			stash.addToWillPersist( "searchTermSuggestion", stashData.searchTermSuggestion );
			stash.addToWillPersist( "searchTypeAheadBits", stashData.searchTypeAheadBits );
			stash.addToWillPersist( "searchTypeAheadType", stashData.searchTypeAheadType );
			stash.addToWillPersist( "searchTypeAheadImp", stashData.searchTypeAheadImp );
			stash.addToWillPersist( "searchTypeAheadRvImp", stashData.searchTypeAheadRvImp );
			stash.addToWillPersist( "searchTypeAheadBiaImp", stashData.searchTypeAheadBiaImp );
		}
	},
	'stash*related_term': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash;

			// will be picked up by search page event handler
			stash.addToWillPersist( "searchTerm", stashData.searchTerm );
			stash.addToWillPersist( "searchMedium", stashData.searchMedium );
		}
	},
	'stash*header_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ];

			stash.addToWillPersist( "headerClick", eventObj.stash.clickInfo );
			stash.addToWillPersist( "headerEvent", eventObj );
		}
	},
	'stash*sponsored_recommendation_pip_load': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ];

			stash.addToWillPersist( "recommendationPipLoad", eventObj.stash.recommendation );
		}
	},
	'stash*sponsored_recommendation_cart_addition': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ],

				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash );

			// will be picked up by cart add event handler
			stash.addToEventData( "recCartAddLoc", data );

			stash.addToEventData( "recommendationCartAdd", eventObj.stash.recommendation );
		}
	},
	'stash*category_recommendation': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ];

			stash.addToWillPersist( "categoryRecommendation", eventObj.stash.recommendation );

		}
	},	
	'stash*recommendation_pip_load': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ];

			stash.addToWillPersist( "recommendationPipLoad", eventObj.stash.recommendation );
		}
	},
	'stash*recommendation_cart_addition': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ],
				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash ),
				stashObj = ( eventObj.stash ? eventObj.stash : {} ),
				recObj = ( stashObj.recommendation ? stashObj.recommendation : Array.isArray( stashObj.item ) ? stashObj.item : "" );

			// will be picked up by cart add event handler
			stash.addToEventData( "recCartAddLoc", data );

			stash.addToEventData( "recommendationCartAdd", recObj );
		}
	},
	'stash*cart_addition_info': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ],

				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash );

			// will be picked up by cart add event handler
			stash.addToEventData( "recCartAddLoc", data );

			stash.addToEventData( "recommendationCartAdd", eventObj.stash.item );
		}
	},
	'stash*recently_viewed_pip_load': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ];

			stash.addToWillPersist( "recRecentlyViewedPipLoad", eventObj.stash.recommendation );
		}
	},
	'stash*visual_nav_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash,
				visualCategoryIdArray = ddo.page.onsiteSearchInfo.visualCategoryId,
				visualCategoryIdLength = ( Array.isArray( visualCategoryIdArray ) && visualCategoryIdArray.length ? visualCategoryIdArray.length : 0 ),
				clickInfo = ( stashData && stashData.clickInfo ? stashData.clickInfo : {} );

			stash.addToWillPersist( "categoryId", clickInfo.categoryId );
			stash.addToWillPersist( "podPosition", clickInfo.podPosition );
			stash.addToWillPersist( "visualCategoryIdLength", visualCategoryIdLength );
			stash.addToWillPersist( "experience", clickInfo.experience );
		}
	},
	'stash*product_pod_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash;

			stash.addToWillPersist( "podClick", stashData );
			stash.addToEventData( "atcPodClick", stashData );

		}
	},
	'stash*widget_interaction': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function () {

			stash.addToWillPersist( "widgetInteractionClick", true );

		}
	},
	'stash*check_fulfillment_availability': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash ? eventObj.stash : {} ),
				result = "",
				data = [],
				fulfillmentObj = {},
				prodInfoEta = [];

			if ( utilities.objHasValue( stashData ) ) {

				if ( Array.isArray( stashData.item ) && stashData.item[ 0 ] ) {

					fulfillmentObj = ( stashData.item[ 0 ].fulfillment ? stashData.item[ 0 ].fulfillment : fulfillmentObj );

					// Get any ETA data
					stashData.item.map( function ( obj ) {
						if ( obj.productInfo && obj.productInfo.eta && utilities.objHasValue( obj.productInfo.eta ) ) {
							prodInfoEta.push( obj.productInfo );
						}
					} );
				}

				data.push( ( fulfillmentObj.method ? fulfillmentObj.method : 'n/a' ) );
				data.push( ( stashData.pageType ? stashData.pageType : 'n/a' ) );
				data.push( ( fulfillmentObj.zip ? fulfillmentObj.zip : 'n/a' ) );

				result = data.join( ">" );

			}

			stash.addToEventData( eventObj.eventInfo.eventName, result );

			if ( prodInfoEta.length ) {
				stash.addToEventData( "checkFulfillmentAvailabilityEta", prodInfoEta );
			}

		}
	},
	'stash*content_module_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash ? eventObj.stash : {} );

			stash.addToWillPersist( "contentModuleClick", stashData );
		}
	},
	'stash*badge_clickthrough': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash && Array.isArray( eventObj.stash.badge ) ? eventObj.stash.badge : [] );

			stashData = stashData.map( function ( elem ) {
				return ( elem.type ? elem.type : "n/a" ) + ">" +
					( elem.pageType ? elem.pageType : "n/a" ) + ">" +
					( elem.recommendationStrategy ? elem.recommendationStrategy : "n/a" ) + ">" +
					( elem.recommendationVersion ? elem.recommendationVersion : "n/a" );
			} ).join( "~" );

			stash.addToWillPersist( "badgeClickThrough", stashData );
			stash.addToEventData( "atcBadgeClickThrough", stashData );
		}
	},
	'stash*collections_product_click': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash ? eventObj.stash : {} ),
				result = [];

			if ( utilities.objHasValue( stashData ) ) {

				result.push( ( stashData.collection && stashData.collection.collectionID ? stashData.collection.collectionID : 'n/a' ) );
				result.push( ( Array.isArray( stashData.product ) && stashData.product[ 0 ] && stashData.product[ 0 ].curationID ? stashData.product[ 0 ].curationID : 'n/a' ) );

				if ( stashData.collection && stashData.collection.pageLocation )  {
					result.push(stashData.collection.pageLocation);
				}
	
				stash.addToWillPersist( "collectionsProductClick", result.join( ">" ) );

			}
		}
	},
	'stash*collections_link_interaction': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash ? eventObj.stash : {} );

			stash.addToWillPersist( "collectionsLinkInteraction", stashData );

		}
	},
	'stash*shop_by_pin_image': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash && eventObj.stash.pinterest && typeof ( eventObj.stash.pinterest.imageCount ) !== 'undefined' ? eventObj.stash.pinterest.imageCount : "" );

			stash.addToEventData( "shopByPinImageCount", stashData );

		}
	},
	'stash*shop_by_pin_category': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				stashData = ( eventObj.stash && eventObj.stash.pinterest ? eventObj.stash.pinterest : {} );

			stash.addToEventData( "shopByPinCategory", stashData );

		}
	},
	'stash*my_account_settings': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var evtObj = ddo.event[ eventIndex ],
				stashData = ( evtObj && evtObj.stash && evtObj.stash.myAccount && evtObj.stash.myAccount.settings ? evtObj.stash.myAccount.settings : "" );

			stash.appendToEventData( "myAccountSettings", stashData );
			stash.addToWillPersist( "globalMyAccountSettings", stashData );

		}
	},
	'stash*solver_pip_load': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				solver = {};

			if ( eventObj.stash && Array.isArray( eventObj.stash.item ) && eventObj.stash.item[ 0 ] && eventObj.stash.item[ 0 ].solverPath ) {
				solver = eventObj.stash.item[ 0 ].solverPath;
			}

			// will be picked up by cart add event handler
			stash.addToWillPersist( "solverPath", solver );
		}
	},
	'stash*solver_cart_addition': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				atcLoc = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash ),
				solver = [];

			if ( eventObj.stash && Array.isArray( eventObj.stash.item ) && ( eventObj.stash.item.length > 0 ) && eventObj.stash.item[ 0 ].solverPath ) {
				solver = eventObj.stash.item;
			}

			// will be picked up by cart add event handler
			stash.addToEventData( "cart add location", atcLoc );
			stash.addToEventData( "solverPath", solver );
		}
	},
	'stash*buy_sample': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var evtObj = ddo.event[ eventIndex ];
			var stashData = ( evtObj && evtObj.stash && evtObj.stash.colorExplore ? evtObj.stash.colorExplore : {} );

			stash.addToEventData( "selectedColor", stashData.selectedColor );
			stash.addToEventData( "selectedCategory", stashData.selectedCategory );

		}
	},
	'stash*buy_paint': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var evtObj = ddo.event[ eventIndex ];
			var stashData = ( evtObj && evtObj.stash && evtObj.stash.colorExplore ? evtObj.stash.colorExplore : {} );

			stash.addToWillPersist( "selectedColor", stashData.selectedColor );
			stash.addToWillPersist( "selectedCategory", stashData.selectedCategory );

		}
	},
	'stash*article_recommendations': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ],
			stashDataRec = ( eventObj.stash && eventObj.stash.recommendation ? eventObj.stash.recommendation : {} ),
			guid = stashDataRec.guid ? stashDataRec.guid.toString() : "na",
			pageType = stashDataRec.pageType ? stashDataRec.pageType.toString() : "na",
			articleRecType = stashDataRec.articleRecommendationType ? stashDataRec.articleRecommendationType.toString() : "na",
			article_evar175_value = `ar>${guid}>${pageType}>${articleRecType}`;

			stash.addToWillPersist( "articleEvar175Value", article_evar175_value );

		}
	},
	'opc_view': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			var isQuote = remoteUtils.getQueryParam( "isQuote", document.URL ),
				opcSavedCard = ( ddo.page && ddo.page.myAccount && ddo.page.myAccount.savedPaymentMethod && typeof ddo.page.myAccount.savedPaymentMethod === 'string' ? ddo.page.myAccount.savedPaymentMethod.toLowerCase() : "" ),
				fulfillmentFlag = false,
				cartItems = ( ddo.cart && ddo.cart.item && ddo.cart.item.length > 0 ? ddo.cart.item : '' );

			_aape.metrics.events = utilities.apl( "event90,event109" );

			if ( ddo.content && ddo.content.feature && ddo.content.feature.suppressedFields && ddo.content.feature.suppressedFields === 'cvv' ) {
				_aape.metrics.events = utilities.apl( "event89" );
			}

			if ( cartItems ) {
				for ( var i = 0; i < cartItems.length; i++ ) {
					if ( cartItems[ i ].fulfillment && cartItems[ i ].fulfillment.deliveryNotice && cartItems[ i ].fulfillment.deliveryNotice.toString().toLowerCase() === 'yes' ) {
						fulfillmentFlag = true;
						break;
					}
				}
			}

			if ( fulfillmentFlag ) {
				_aape.metrics.events = utilities.apl( "event135" );
			}			

			if ( ddo.cart.attributes && ddo.cart.attributes.poJobName ) {
				_aape.metrics.eVar159 = ddo.cart.attributes.poJobName;
			}

			_aape.metrics.products = productString.run( 'opc', ddo.cart.item );

		
			_aape.metrics.eVar62 = digitalDataFormatters.getFulfillString() + ( isQuote === 'true' ? ">quote" : ">opc" );

			//Pro Large Cart new metrics
			_aape.metrics.eVar221 = ( ddo.cart.quantityTotal ? ddo.cart.quantityTotal : "" );
			_aape.metrics.eVar222 = ( ddo.cart.uniqueSkuCount ? ddo.cart.uniqueSkuCount : "" );
			_aape.metrics.eVar223 = (ddo.cart.price.cartTotal ? ddo.cart.price.cartTotal : "" );


			if ( opcSavedCard ) {
				_aape.metrics.prop63 = 'opc: saved card ' + opcSavedCard;
			}

		}
	},
	'purchase': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			mapMethods.setPurchaseMetrics( ddo );

		}
	},
	'product_rental_confirmation': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			mapMethods.setPurchaseMetrics( ddo );

		}
	},
	'cashstar_purchase': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			_aape.metrics.events = utilities.apl( 'event143:' + ( ddo.transaction && ddo.transaction.transactionID ? ddo.transaction.transactionID : '' )  );
			
			_aape.metrics.products = productString.run( 'giftCard', ddo.transaction.item );

		}
	},
	'button_submission*find_a_store': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'find a store',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event38" );
			utilities.addEventsToLinkTrack( 'event38' );
		}
	},
	'button_submission*pay_in_store': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'pay in store',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event39" );
			utilities.addEventsToLinkTrack( 'event39' );
		}
	},
	'cancel_success': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {			
			
			_aape.metrics.products = productString.run( 'cancelSuccess', ddo.postOrder.item );

		}
	},
	'confirm_return': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,		
		'setMetrics': function ( ddo ) {
			
			mapMethods.setConfirmReturn( ddo.postOrderReturn ? ddo.postOrderReturn : {} );

		}
	},
	'interaction*opc_card_number_field': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "opc card number field interaction",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event91,event111' );
			utilities.addEventsToLinkTrack( 'event91,event111' );
		}
	},
	'content_display*bodfs_fulfillment_change': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'bodfs fulfillment change',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event133" );
			utilities.addEventsToLinkTrack( 'event133' );
		}
	},
	'content_display*instant_checkout_impression': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'instant checkout impression',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event80" );
			utilities.addEventsToLinkTrack( 'event80' );
		}
	},
	'content_display*installation_displayed': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'installation displayed',
		'setMetrics': function ( ddo, eventIndex ) {

			var installLabor = mapMethods.getAttachedLabor( ddo.product ),
				installationStatus = ( utilities.objHasValue( installLabor ) && installLabor ? installLabor : '' );

			_aape.metrics.eVar131 = "installation";
			
			_aape.metrics.products = productString.run( 'installationSku', ddo.event[ eventIndex ].item );

			if ( installationStatus ) {				
				_aape.metrics.products = productString.run( 'installationSku', ddo.product );
			}

			// prevent ITC/Sponsored Click related values from firing	
			mapMethods.clearSponsoredMetrics();

			// prevent ITC/Sponsored Click related values from firing	
			mapMethods.clearSponsoredMetrics();

			utilities.addEventsToLinkTrack( "event193" );
			utilities.addVarsToLinkTrack( 'products,eVar131' );
		}
	},
	'content_display*labor_displayed': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'labor displayed',
		'setMetrics': function ( ddo, eventIndex ) {

			if ( remoteUtils.isNucleus() ){
				mapMethods.setLaborDisplayedNucleus( ddo, eventIndex );
			} else {
				mapMethods.setLaborDisplayed( ddo, eventIndex );
			}

			// prevent ITC/Sponsored Click related values from firing
			mapMethods.clearSponsoredMetrics();

		}
	},
	'content_display*proreferral_displayed': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'proreferral displayed',
		'setMetrics': function ( ddo, eventIndex ) {

			var proReferralLabor = mapMethods.getAttachedLabor( ddo.product ),
				proStatus = ( utilities.objHasValue( proReferralLabor ) && proReferralLabor ? proReferralLabor : '' );

			_aape.metrics.eVar131 = "proreferral";

			_aape.metrics.products = productString.run( "proreferralSku", ddo.event[ eventIndex ].item );

			if ( proStatus ) {
				_aape.metrics.products = productString.run( "proreferralSku", ddo.product );
			}


			// prevent ITC/Sponsored Click related values from firing
			mapMethods.clearSponsoredMetrics();

			utilities.addEventsToLinkTrack( "event193" );
			utilities.addVarsToLinkTrack( 'products,eVar131' );
		}
	},	
	'content_display*target_experience_displayed': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'target experience displayed',
		'setMetrics': function ( ddo, eventIndex ) {

			let target = ddo.event[eventIndex].target;

			if ( target ) {
				
				if ( target.experienceNameA ) {

					_aape.metrics.eVar140 =  target.experienceNameA;					

				}

				if ( target.experienceNameB ) {

					_aape.metrics.eVar141 = target.experienceNameB;	

				}

				utilities.addVarsToLinkTrack( 'eVar140,eVar141' );	

			}
		}
	},	
	'interaction*target_audit': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'target audit',
		'setMetrics': function ( ddo, eventIndex ) {
						
			_aape.metrics.eVar199 = ddo.event[eventIndex].message ?? "";	
				
			utilities.addVarsToLinkTrack( 'eVar199' );	

		}		
	},	
	'overlay*change_delivery_zip': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			_aape.metrics.prop2 = ddo.page.pageInfo.pageType;
		}
	},
	'overlay*view_delivery_faqs': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'view delivery faqs',
		'setMetrics': function ( ddo, eventIndex ) {
			var productStatus = ( Array.isArray( ddo.event[ eventIndex ].item ) && ddo.event[ eventIndex ].item.length && ddo.event[ eventIndex ].item[ 0 ].productInfo && ddo.event[ eventIndex ].item[ 0 ].productInfo.availabilityStatus ? ddo.event[ eventIndex ].item[ 0 ].productInfo.availabilityStatus : '' ),
				shippingStatus = ( productStatus.shipping ? productStatus.shipping : '' );

			if ( shippingStatus.bodfs === 'oos' ) {

				_aape.metrics.events = utilities.apl( "event196" );

			}

			utilities.addEventsToLinkTrack( 'event196' );

		}

	},
	'overlay*appliance_protection_plan': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.pageName = 'checkout>appliance parts services>protection plan';
			_aape.metrics.channel = 'appliances';

			_aape.metrics.prop2 = ddo.page.category.subCategory2 + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop35 = "";

		}
	},
	'overlay*my_account>online_orders>order_details>bopis_cancellation_request': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {

		}
	},
	'overlay*mini_cart': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			_aape.metrics.events = utilities.apl( "scView,event69,event169" );

			_aape.metrics.products = productString.run( "cartView", ddo.cart.item );

			_aape.metrics.eVar62 = ( function () {
				var _eVar62 = storage.getItem( "eVar62" );
				if ( !_eVar62 || ( _eVar62 && _eVar62.indexOf( ">" ) === -1 ) ) {
					_eVar62 = digitalDataFormatters.getFulfillString();
				}
				storage.setItem( "eVar62", _eVar62 );
				return _eVar62;
			}() );

		}
	},
	'overlay*shoppable_images_drawer': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.products = productString.run( 'skuOnly', ddo.event[ eventIndex ].product );

			utilities.addVarsToLinkTrack( 'products' );

		}
	},
	'overlay*shoppable_images_drawer:_collapsed_hotspot': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.products = productString.run( 'skuOnly', ddo.event[ eventIndex ].product );

			utilities.addVarsToLinkTrack( 'products' );

		}
	},	
	'overlay*appl_package_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );

		}
	},
	'overlay*appl_bundle_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );

		}
	},
	'overlay*parts_services_and_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
			
		}
	},
	'overlay*bundle_parts_services_and_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
		}
	},
	'overlay*package_parts_services_and_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
		}
	},
	'overlay*appl_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
		}
	},
	'overlay*bundle_appl_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
		}
	},
	'overlay*package_appl_hdpp_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
		}
	},
	'overlay*appl_install_and_haul_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
			_aape.metrics.events = utilities.apl( "event313" );
		}
	},
	'overlay*bundle_appl_p&s_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
			_aape.metrics.events = utilities.apl( "event313" );
		}
	},
	'overlay*package_appl_p&s_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set appliance cart add related metrics
			mapMethods.setApplianceCartAdd( ddo, eventIndex );
			_aape.metrics.events = utilities.apl( "event313" );
		}
	},
	'overlay*cart_add': { //FBT ticket number 2703
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartAdd( ddo, eventIndex );

		}
	},
	'overlay*gift_card_reload': { //FBT ticket number 2703
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( "scCheckout,event129" );
			mapMethods.setCartAdd( ddo, eventIndex );

		}
	},
	'overlay*hdpass_add_card': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ) {

			_aape.metrics.prop63 = stash.getEventData( "myAccountSettings" );

			stash.deleteEventData( "myAccountSettings" );
		
		}
	},
	'overlay*hdpass_remove_card': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ) {

			_aape.metrics.prop63 = stash.getEventData( "myAccountSettings" );

			stash.deleteEventData( "myAccountSettings" );
		
		}
	},
	'add_to_cart_click*cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartAdd( ddo, eventIndex );

		}
	},
	'button_submission*instant_cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartAdd( ddo, eventIndex );

			_aape.metrics.events = utilities.apl( "scCheckout,event129,event30" );

		}
	},
	'overlay*instant_checkout_review_order': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			// set cart add related metrics
			mapMethods.setCartAdd( ddo, eventIndex );

			//replace the ones that we need to for this use case
			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop30 = _aape.metrics.pageName;
			_aape.metrics.eVar8 = _aape.metrics.pageName;
		}
	},
	'type_ahead*suggestion_displayed': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'suggestion displayed',
		'setMetrics': function ( ddo ) {
			_aape.metrics.pageName = ddo.page.pageInfo.pageName;
		}
	},
	'type_ahead*suggestion_tapped': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'suggestion tapped',
		'setMetrics': function ( ddo ) {
			_aape.metrics.pageName = ddo.page.pageInfo.pageName;
		}
	},
	'find_a_store': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event38' );
		}
	},
	'expansion': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.referrer = "";

			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop30 = ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop35 = _aape.metrics.pageName;
			_aape.metrics.eVar8 = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		}
	},
	'in-line_product_details*collection_expanded_view': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop15 = ddo.page.pageInfo.pageName;
			_aape.metrics.prop30 = ddo.event[ eventIndex ].category.primaryCategory;
			_aape.metrics.prop35 = _aape.metrics.pageName;
			_aape.metrics.eVar8 = ddo.event[ eventIndex ].category.primaryCategory;

			_aape.metrics.events = utilities.apl( "prodView,event16" );
			
			_aape.metrics.products = productString.run( "productView",  ddo.product );

		}
	},
	'interaction*orangelens_shoppable_image_hotspot': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'orangelens shoppable image hotspot',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( typeof ( ddo.event[ eventIndex ] ) !== 'undefined'  ? ddo.event[ eventIndex ] : {} ),
				section = ( evtObj?.orangelens?.section ?? '' );
			
			_aape.metrics.pageName = `reverse image results>${section}`;

			_aape.metrics.events = utilities.apl( "event88" );
			
			_aape.metrics.eVar93 = section

			utilities.addEventsToLinkTrack( 'event88' );
			utilities.addVarsToLinkTrack( 'eVar93' );
		}
	},
	'button_submission*orangelens_upload_an_image': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'orangelens upload an image',
		'setMetrics': function () {

			_aape.metrics.events = utilities.apl( "event46" );

			utilities.addEventsToLinkTrack( 'event46' );
			
		}
	},
	'button_submission*content_module_click': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'content module click',
		'setMetrics': function ( ddo, eventIndex ) {

			let evtObj = ( typeof ( ddo.event[ eventIndex ] ) !== 'undefined'  ? ddo.event[ eventIndex ] : {} );

			mapMethods.setWidgetTracking( ddo.event[ eventIndex ] );

			_aape.metrics.prop30 = ddo.page.pageInfo.pageType;

			_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );
			
			_aape.metrics.eVar105 = ( evtObj.content && typeof ( evtObj.content.slmCandidateID ) !== 'undefined' ? evtObj.content.slmCandidateID : '' );

			utilities.addEventsToLinkTrack( 'event14,event194' );
			utilities.addVarsToLinkTrack( 'eVar5,eVar21,eVar105,eVar129,prop4,prop30' );
		}
	},
	'button_submission*siwp_enrollment_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'siwp enrollment start',
		'setMetrics': function () {

			_aape.metrics.events = utilities.apl( "event11" );
			utilities.addEventsToLinkTrack( 'event11' );			

		}
	},
	'button_submission*biometric_enrollment_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'biometric enrollment start',
		'setMetrics': function () {

			_aape.metrics.events = utilities.apl( "event23" );
			utilities.addEventsToLinkTrack( 'event23' );			

		}
	},
	'button_submission*create_my_account': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'create my account',
		'setMetrics': function (ddo, eventIndex) {

			let evtObj = ( typeof ( ddo.event[ eventIndex ] ) !== 'undefined'  ? ddo.event[ eventIndex ] : {} );


			_aape.metrics.events = utilities.apl( "event71" );
			_aape.metrics.eVar74 = ( typeof ( evtObj.passwordOption ) !== 'undefined' && typeof ( evtObj.userType ) !== 'undefined' ? evtObj.userType + ":" + evtObj.passwordOption : '' );


			utilities.addEventsToLinkTrack( 'event71' );
			utilities.addVarsToLinkTrack( 'eVar74' );		

		}
	},
	'button_submission*subscription_details_acceptance': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'subscription details acceptance',
		'setMetrics': function ( ddo ) {
			
			_aape.metrics.events = utilities.apl( "event130" );
			
			_aape.metrics.prop30 = ddo.page.pageInfo.pageType;
			_aape.metrics.eVar8 = ddo.page.pageInfo.pageType;

			utilities.addEventsToLinkTrack( 'event130' );
			utilities.addVarsToLinkTrack( 'prop30,eVar8' );
		}
	},
	'page_lifecycle*pagehide': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "pagehide",
		'setMetrics': function ( ddo, eventIndex ) {

			let eventObj = ( ddo.event[ eventIndex ] ? ddo.event[ eventIndex ] : {} );			
			let data = ( eventObj.data && utilities.objHasValue( eventObj.data ) ? eventObj.data : false );			

			//exit if we dont have all the data
			if ( !data ) { return; }
			console.log("AAPE LOG -- global pagehide", data);

			// set values on correseponding S object prop/evar/event/list
			Object.keys( data ).forEach ( key => {
				
				const value = data[key];

				if ( key.startsWith("event") ) {
					_aape.metrics.events = utilities.apl( value );
					utilities.addEventsToLinkTrack( key );
				} else {
					_aape.metrics[key] = value;
					utilities.addVarsToLinkTrack( key );
				}

			});

			// send this call using navigator.sendBeacon
			_aape.metrics.useBeacon = true;
			
		}
	},
	'time_based*impression_capture': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "impression timeout capture",
		'setMetrics': function (ddo, eventIndex) {

			let eventObj = (ddo.event[eventIndex] ? ddo.event[eventIndex] : {});
			let data = eventObj.data ?? false;
			let timeout = eventObj.timeout ?? "";

			//exit if we dont have all the data
			if (!data) { return; }
			console.log("AAPE LOG -- impression timeout capture", data);

			_aape.metrics.events = utilities.apl('event306');

			_aape.metrics.prop30 = ddo?.page?.pageInfo?.pageType ?? "";

			_aape.metrics.eVar212 = `timeout: ${timeout}`;

			_aape.metrics.list1 = data;

			utilities.addEventsToLinkTrack("event306");
			utilities.addVarsToLinkTrack('eVar212,prop30,list1');

			// Reset impression data
			appData.addUpdateCache(config.getTLTestConfig().cache_key, "");
			
			// send this call using navigator.sendBeacon
			_aape.metrics.useBeacon = true;

		}
	}
};

nodes[ 'overlay*available_rebates' ] = {
	'forcePageView': true,
	'reportingType': 't',
	'runUniversal': true,
	'setMetrics': function ( ddo, eventIndex ) {

			let podClickObj = mapMethods.getPodClick();

		_aape.metrics.products = productString.run( "productPod", ddo.event[ eventIndex ].item, { "podClick": podClickObj } );
			
		_aape.metrics.eVar101 = mapMethods.setEVar101( podClickObj );
	}
};

nodes[ 'overlay*slm_candidate_profile_modal' ] = {
	'forcePageView': true,
	'reportingType': 't',
	'runUniversal': true,
	'setMetrics': function ( ddo, eventIndex ) {

		let evtObj = ( typeof ( ddo.event[ eventIndex ] ) !== 'undefined'  ? ddo.event[ eventIndex ] : {} );
		
		_aape.metrics.eVar105 = ( evtObj.content && typeof ( evtObj.content.slmCandidateID ) !== 'undefined' ? evtObj.content.slmCandidateID : '' );

	}
};

nodes[ 'button_submission*text_me' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "text me",
	'setMetrics': function () {}
};

nodes[ 'button_submission*text_me_coupon' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "text me coupon",
	'setMetrics': function () {}
};

nodes[ 'cart_view_modification*add_subscription' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "add subscription",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event82" );

		_aape.metrics.products = productString.run( "cartView", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event82" );
		utilities.addVarsToLinkTrack( 'eVar115,products' );
	}
};

nodes[ 'cart_view_modification*remove_subscription' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "remove subscription",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event83" );

		_aape.metrics.products = productString.run( "cartView", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event83" );
		utilities.addVarsToLinkTrack( 'eVar115,products' );
	}
};

//blocking this event till FED can remove it on their end implemented 1-21-2019
nodes[ 'tooltip*map_disclosure' ] = {
	'forcePageView': false,
	'reportingType': 'non-reporting',
	'runUniversal': false,
	'setMetrics': function () {}
};

nodes[ 'button_submission*phone_verification_success' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'phone verification success',
	'setMetrics': function () {
		_aape.metrics.events = utilities.apl( 'event96' );

		utilities.addEventsToLinkTrack( 'event96' );
	}
};

nodes[ 'button_submission*phone_rescue_verification_success' ] = {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'phone rescue verification success',
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event99' );

			utilities.addEventsToLinkTrack( 'event99' );
	}
};

nodes[ 'browse*solver_abandon' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'solver abandon',
	'setMetrics': function ( ddo, eventIndex ) {
		var eventObj = ddo.event[ eventIndex ];

		_aape.metrics.eVar122 = ( eventObj.eventInfo && eventObj.eventInfo.solverPath ? eventObj.eventInfo.solverPath : '' );

		utilities.addVarsToLinkTrack( 'eVar122' );

	}
};

nodes[ 'button_submission*scan_credit_card' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'scan credit card',
	'setMetrics': function () {
		_aape.metrics.events = utilities.apl( 'event279' );

		utilities.addEventsToLinkTrack( 'event279' );
	}
};

nodes[ 'button_submission*instant_checkout_enrolled' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'instant checkout enrolled',
	'setMetrics': function () {
		_aape.metrics.events = utilities.apl( 'event64' );

		utilities.addEventsToLinkTrack( 'event64' );
	}
};

nodes[ 'button_submission*ugc_click' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'ugc click',
	'setMetrics': function ( ddo, eventIndex ) {

		let eventObj = ddo.event[ eventIndex ],
			ugc = ( eventObj && eventObj.content && Array.isArray( eventObj.content.ugc ) ? eventObj.content.ugc : [] );

		_aape.metrics.events = utilities.apl( 'event152' );
		
		//Pass in the first object in the product array
		if ( ddo.product && Array.isArray( ddo.product ) && ddo.product.length && ddo.product[ 0 ].productInfo && ddo.product[ 0 ].productInfo.sku ) {
			
			_aape.metrics.products = productString.run( "ugcClick", [ ddo.product[ 0 ]], { "ugcObj": ugc } );

		}
		
		utilities.addEventsToLinkTrack( 'event152' );
		utilities.addVarsToLinkTrack( 'products,eVar128' );
	}
};

nodes[ 'button_submission*email_sign_up' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'email sign up',
	'setMetrics': function ( ddo, eventIndex ) {

		var eventObj = ddo.event[ eventIndex ];

		_aape.metrics.events = utilities.apl( 'event251' );

		_aape.metrics.eVar139 = ( eventObj && eventObj.category && eventObj.category.emailListType ? eventObj.category.emailListType : "" );

		utilities.addEventsToLinkTrack( 'event251' );
		utilities.addVarsToLinkTrack( 'eVar139' );
	}
};

nodes[ 'button_submission*content_module_interaction' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'content module interaction',
	'setMetrics': function ( ddo, eventIndex ) {

		mapMethods.setEvar144( ddo, eventIndex, 'event259' );
	}
};

nodes[ 'interaction*configurator_click' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'configurator click',
	'setMetrics': function ( ddo, eventIndex ) {

		mapMethods.setEvar144( ddo, eventIndex, 'event60' );
	}
};

nodes[ 'button_submission*plp_pod_new_tab' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'plp pod new tab',
	'setMetrics': function ( ddo, eventIndex ) {

		var eventObj = ddo.event[ eventIndex ],
			pod = ( eventObj && eventObj.pod ? eventObj.pod : {} ),
			sku = ( pod.podAnchorSku ? pod.podAnchorSku : "" ),
			itemArray = [ {
				"productInfo": {
					"sku": sku
				}
			} ];

		_aape.metrics.prop30 = ddo.page.pageInfo.pageType;

		var podDataStr = ( function ( podData ) {

			var result = "";

			if ( podData ) {

				result += ( podData.podPageNumber ? podData.podPageNumber : '' ) + "|";
				result += ( podData.podPageResults ? podData.podPageResults : '' ) + "|";
				result += ( podData.podPosition ? podData.podPosition : '' ) + "|";
				result += ( podData.podType ? podData.podType : '' ) + "|";
				result += ( podData.podAction ? podData.podAction : '' );

			}

			return result;

		}( pod ) );

		_aape.metrics.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

		_aape.metrics.eVar101 = ( function ( podDataStr, podData ) {

			var result = "";

			if ( podDataStr && podData ) {

				result += podDataStr + "|" + ( podData.podAnchorSku ? podData.podAnchorSku : '' );
				_aape.metrics.events = utilities.apl( "event123=" + ( podData.podInteractionNumber ? podData.podInteractionNumber : '' ) );

			}

			return result;

		}( podDataStr, pod ) );

		_aape.metrics.products = productString.run( "productPod", itemArray, { "podClick": pod } );

		utilities.addEventsToLinkTrack( 'event14,event62,event123,event191' );
		utilities.addVarsToLinkTrack( 'products,prop30,eVar21,eVar101,eVar160' );
	}
};

nodes[ 'button_submission*new_project_created' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'new project created',
	'setMetrics': function ( ddo, eventIndex ) {
		let eventObj = ddo.event[ eventIndex ] ?? {};

		_aape.metrics.events = utilities.apl( 'event297' );

		_aape.metrics.prop63 = ( eventObj?.myAccount?.settings ?? "" );

		_aape.metrics.eVar196 = ( eventObj?.projectId ?? "" );

		utilities.addEventsToLinkTrack( 'event297' );
		utilities.addVarsToLinkTrack( 'prop63,eVar196' );
	}
};

nodes[ 'button_submission*project_add' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'project add',
	'setMetrics': function ( ddo, eventIndex ) {
		let eventObj = ddo.event[ eventIndex ] ?? { "item": [] };

		_aape.metrics.events = utilities.apl( 'event298' );

		_aape.metrics.eVar203 = ( eventObj.uniqueSkuCount ?? "" );
		_aape.metrics.eVar204 = ( eventObj.projectAddTotal ?? "" );

		_aape.metrics.products = productString.run( "projectAdd", eventObj.item, { "projectId": eventObj.projectId ?? "" } );

		utilities.addEventsToLinkTrack( 'event298' );
		utilities.addVarsToLinkTrack( 'products,eVar196,eVar197,eVar203,eVar204' );
	}
};

nodes[ 'button_submission*new_group_project_add' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'new group project add',
	'setMetrics': function ( ddo, eventIndex ) {
		let eventObj = ddo.event[ eventIndex ] ?? { "item": [] };

		_aape.metrics.events = utilities.apl( 'event298,event301' );
				
		_aape.metrics.eVar203 = ( eventObj.uniqueSkuCount ?? "" );
		_aape.metrics.eVar204 = ( eventObj.projectAddTotal ?? "" );
		_aape.metrics.prop63 = ( eventObj?.myAccount?.settings ? eventObj.myAccount.settings : "" );

		_aape.metrics.products = productString.run( "projectAdd", eventObj.item, { "projectId": eventObj.projectId ?? "" } );

		utilities.addEventsToLinkTrack( 'event298,event301' );
		utilities.addVarsToLinkTrack( 'products,eVar196,eVar197,eVar203,eVar204,prop63' );
	}
};

nodes[ 'button_submission*new_project_project_add' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': 'new project project add',
	'setMetrics': function ( ddo, eventIndex ) {
		let eventObj = ddo.event[ eventIndex ] ?? { "item": [] };

		_aape.metrics.events = utilities.apl( 'event297,event298' );

		_aape.metrics.eVar203 = ( eventObj.uniqueSkuCount ?? "" );
		_aape.metrics.eVar204 = ( eventObj.projectAddTotal ?? "" );
		_aape.metrics.prop63 = ( eventObj?.myAccount?.settings ? eventObj.myAccount.settings : "" );

		_aape.metrics.products = productString.run( "projectAdd", eventObj.item, { "projectId": eventObj.projectId ?? "" } );

		utilities.addEventsToLinkTrack( 'event297,event298' );
		utilities.addVarsToLinkTrack( 'products,eVar196,eVar197,eVar203,eVar204,prop63' );
	}
};

nodes[ 'project_view_modification*project_remove' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "project remove",
	'setMetrics': function ( ddo, eventIndex ) {
		let eventObj = ddo.event[ eventIndex ] ?? { "item": [] };
		
		_aape.metrics.events = utilities.apl( "event302" );

		_aape.metrics.products = productString.run( "projectRemove", eventObj.item, { "projectId": eventObj.projectId ?? "" } );

		utilities.addEventsToLinkTrack( "event302" );
		utilities.addVarsToLinkTrack( 'products,eVar196' );
	}
};

nodes[ 'stash*filter_by' ] = {
	'forcePageView': false,
	'reportingType': 'non-reporting',
	'runUniversal': false,
	'setMetrics': function () {

		stash.addToWillPersist( "filterby", true );

	}
};

nodes[ 'stash*sign_in_success' ] = {
	'forcePageView': false,
	'reportingType': 'non-reporting',
	'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			let eventObj = ddo.event[ eventIndex ],
			stashData = ( eventObj.stash ? eventObj.stash : {} );

			stash.addToWillPersist( "signInSuccess", stashData );
	}
};

nodes[ 'stash*tmx_policy' ] = {
	'forcePageView': false,
	'reportingType': 'non-reporting',
	'runUniversal': false,
	'setMetrics': function ( ddo, eventIndex ) {
		var eventObj = ddo.event[ eventIndex ],
			stashData = ( eventObj.stash ? eventObj.stash : {} ),
			data = (stashData.tmxPolicyDetails ? stashData.tmxPolicyDetails : '');

		stash.addToWillPersist( "tmxPolicyDetails", data );
		stash.addToEventData( "tmxPolicyDetailsErrorCase", data );
	}
};

nodes[ 'cart_view_modification*coupon_application' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "cart coupon application",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event277" );

		_aape.metrics.products = productString.run( "couponApplicationChange", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event277" );
		utilities.addVarsToLinkTrack( 'products' );
	}
};

nodes[ 'cart_view_modification*coupon_remove' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "cart coupon removal",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event278" );

		_aape.metrics.products = productString.run( "couponApplicationChange", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event278" );
		utilities.addVarsToLinkTrack( 'products' );
	}
};

nodes[ 'checkout_view_modification*coupon_application' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "checkout coupon application",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event277" );

		_aape.metrics.products = productString.run( "couponApplicationChange", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event277" );
		utilities.addVarsToLinkTrack( 'products' );
	}
};

nodes[ 'checkout_view_modification*coupon_remove' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "checkout coupon removal",
	'setMetrics': function ( ddo, eventIndex ) {
		_aape.metrics.events = utilities.apl( "event278" );

		_aape.metrics.products = productString.run( "couponApplicationChange", ddo.event[ eventIndex ].item );

		utilities.addEventsToLinkTrack( "event278" );
		utilities.addVarsToLinkTrack( 'products' );
	}
};

	nodes[ 'order_view' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			_aape.metrics.prop63 = ( ddo.page.myAccount.settings ? ddo.page.myAccount.settings : stash.getPersistedDataWithKey( "myAccountSettings" ) );

			_aape.metrics.eVar41 = ( ddo.postOrder.transactionID ? ddo.postOrder.transactionID : "" );

		}
	};
	


if ( BUILD_TARGET === "b2business-desktop" || BUILD_TARGET === "b2business-mobile" ) {

	nodes[ 'button_submission*quote_created' ] = {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "quote created",
		'setMetrics': function ( ddo, eventIndex ) {

			_aape.metrics.events = utilities.apl( 'event48' );

			_aape.metrics.products = productString.run( "quoteAdd", ddo.event[ eventIndex ].quote.item );

			utilities.addEventsToLinkTrack( 'event48' );
			utilities.addVarsToLinkTrack( 'products' );
		}
	};

	nodes[ 'button_submission*cart_re-add' ] = {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart re-add",
		'setMetrics': function ( ddo, eventIndex ) {
			_aape.metrics.events = utilities.apl( "event140" );

			_aape.metrics.products = productString.run( "cartReAdd", ddo.event[ eventIndex ].item );

			utilities.addEventsToLinkTrack( "event140" );
			utilities.addVarsToLinkTrack( 'products' );
		}
	};

	nodes[ 'quickbooks_sync_pass' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( "event248" );
		}
	};


	nodes[ 'order_details' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			// mainly setting this up to get access to forcePageView for this use case

		}
	};

}

if ( BUILD_TARGET === "b2consumer-desktop" || BUILD_TARGET === "b2consumer-mobile" ) {

	nodes[ 'button_submission*two_factor_authentication_success' ] = {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "two factor authentication success",
		'setMetrics': function () {
			_aape.metrics.events = utilities.apl( 'event229' );
			utilities.addEventsToLinkTrack( 'event229' );
		}
	};

	nodes[ 'overlay*verify_your_phone_number_-_code_entry' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			_aape.metrics.prop63 = ( ddo.page.myAccount.settings ? ddo.page.myAccount.settings : stash.getEventData( "myAccountSettings" ) );

			stash.deleteEventData( "myAccountSettings" );

		}
	};

	nodes[ 'overlay*paint_family' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPaintMetrics( ddo.event[ eventIndex ] );
		}
	};

	nodes[ 'overlay*paint_details' ] = {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPaintMetrics( ddo.event[ eventIndex ] );
		}
	};

	nodes [ 'stash*content_module_impression' ] = {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			let eventObj = ddo.event[ eventIndex ],
				stshContModArray = ( eventObj.stash && eventObj.stash.content && Array.isArray(eventObj.stash.content.module) ? eventObj.stash.content.module : []),
				stash_content_module_impression = "",
				plccArray = [];

			for (const moduleIndex in stshContModArray) {
				let name = (stshContModArray[moduleIndex].name ? stshContModArray[moduleIndex].name.toString() : ""),
					feature = (stshContModArray[moduleIndex].feature ? stshContModArray[moduleIndex].feature.toString() : ""),
					type = (stshContModArray[moduleIndex].type ? stshContModArray[moduleIndex].type.toString() : "");

				if ( name && type && feature && feature.substring(0,4).toLowerCase() === "plcc" ) {
					plccArray.push(`${name}>${feature}>${type}`);
				}
			}

			stash_content_module_impression = plccArray.join('|');
			stash.addToWillPersist( "stashContenModuleImpressionValue", stash_content_module_impression );
		}
	};
}


export {
	nodes
};
